/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type DeleteLLMProjectInput = {
  id: string,
};

export type ModelLLMProjectConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  description?: ModelStringInput | null,
  stripeCustomerId?: ModelIDInput | null,
  newCustomerTokenCount?: ModelIntInput | null,
  cacheResponsesForSeconds?: ModelIntInput | null,
  loadSheddingTier?: ModelIntInput | null,
  newCustomerLoadSheddingTier?: ModelIntInput | null,
  maintenanceMode?: ModelBooleanInput | null,
  maintenanceModeMessage?: ModelStringInput | null,
  loadBalancingMode?: ModelStringInput | null,
  piiRedactionScope?: ModelStringInput | null,
  systemInstructions?: ModelStringInput | null,
  piiScope?: ModelStringInput | null,
  piiGroupId?: ModelStringInput | null,
  piiMessage?: ModelStringInput | null,
  promptBlacklist?: ModelStringInput | null,
  blacklistGroupId?: ModelStringInput | null,
  blacklistMessage?: ModelStringInput | null,
  safety?: ModelFloatInput | null,
  safetyGroupId?: ModelStringInput | null,
  safetyMessage?: ModelStringInput | null,
  strongModelGroupId?: ModelStringInput | null,
  routeModel?: ModelStringInput | null,
  trialTokensRemaining?: ModelIntInput | null,
  logfileRetentionPeriod?: ModelIntInput | null,
  callRetentionPeriod?: ModelIntInput | null,
  logInterval?: ModelStringInput | null,
  lastLogGeneratedAt?: ModelStringInput | null,
  logGenerationCursor?: ModelStringInput | null,
  enterpriseAllowChat?: ModelBooleanInput | null,
  enterpriseAcceptableUsePolicy?: ModelStringInput | null,
  enterpriseAccessRequestEmail?: ModelStringInput | null,
  enterpriseSupportEmail?: ModelStringInput | null,
  enterpriseDomainWhitelist?: ModelStringInput | null,
  enterpriseTokenBudget?: ModelIntInput | null,
  enterpriseTokenBudgetPeriod?: ModelStringInput | null,
  enterpriseImageUrl?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  apiCreditRemaining?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  summaryEmailPeriod?: ModelIntInput | null,
  summaryEmailAddresses?: ModelStringInput | null,
  lastSummaryEmailSentAt?: ModelStringInput | null,
  mcpServerWhitelist?: ModelStringInput | null,
  automaticModelManagement?: ModelBooleanInput | null,
  supersmallGroupModels?: ModelStringInput | null,
  standardGroupModels?: ModelStringInput | null,
  premiumGroupModels?: ModelStringInput | null,
  reasoningGroupModels?: ModelStringInput | null,
  superpremiumGroupModels?: ModelStringInput | null,
  openrouterStandardGroupModels?: ModelStringInput | null,
  openrouterPremiumGroupModels?: ModelStringInput | null,
  azureOpenaiBaseUrl?: ModelStringInput | null,
  azureOpenaiApiVersion?: ModelStringInput | null,
  awsBedrockRegion?: ModelStringInput | null,
  newCustomerUsageTierId?: ModelIDInput | null,
  usageTapUsageApiKey?: ModelStringInput | null,
  lowApiCreditNotificationEmails?: ModelStringInput | null,
  lowApiCreditNotificationMinimumCredit?: ModelFloatInput | null,
  lastLowApiCreditNotificationSentAt?: ModelStringInput | null,
  integrationApiKey1Hash?: ModelStringInput | null,
  integrationApiKey1Status?: ModelStringInput | null,
  integrationApiKey1Prefix?: ModelStringInput | null,
  integrationApiKey1LastRotatedAt?: ModelStringInput | null,
  integrationApiKey1Scopes?: ModelStringInput | null,
  integrationApiKey2Hash?: ModelStringInput | null,
  integrationApiKey2Status?: ModelStringInput | null,
  integrationApiKey2Prefix?: ModelStringInput | null,
  integrationApiKey2LastRotatedAt?: ModelStringInput | null,
  integrationApiKey2Scopes?: ModelStringInput | null,
  and?: Array< ModelLLMProjectConditionInput | null > | null,
  or?: Array< ModelLLMProjectConditionInput | null > | null,
  not?: ModelLLMProjectConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type LLMProject = {
  __typename: "LLMProject",
  id: string,
  name: string,
  status: string,
  description?: string | null,
  users?: ModelLLMUserConnection | null,
  services?: ModelLLMServiceConnection | null,
  stripeCustomerId?: string | null,
  subscription?: LLMProjectSubscription | null,
  newCustomerTokenCount?: number | null,
  cacheResponsesForSeconds?: number | null,
  loadSheddingTier: number,
  newCustomerLoadSheddingTier?: number | null,
  maintenanceMode: boolean,
  maintenanceModeMessage?: string | null,
  loadBalancingMode: string,
  piiRedactionScope?: string | null,
  systemInstructions?: string | null,
  piiScope?: string | null,
  piiGroupId?: string | null,
  piiMessage?: string | null,
  promptBlacklist?: string | null,
  blacklistGroupId?: string | null,
  blacklistMessage?: string | null,
  safety?: number | null,
  safetyGroupId?: string | null,
  safetyMessage?: string | null,
  strongModelGroupId?: string | null,
  routeModel?: string | null,
  trialTokensRemaining?: number | null,
  logfileRetentionPeriod?: number | null,
  callRetentionPeriod?: number | null,
  logInterval?: string | null,
  lastLogGeneratedAt?: string | null,
  logGenerationCursor?: string | null,
  enterpriseAllowChat?: boolean | null,
  enterpriseAcceptableUsePolicy?: string | null,
  enterpriseAccessRequestEmail?: string | null,
  enterpriseSupportEmail?: string | null,
  enterpriseDomainWhitelist?: string | null,
  enterpriseTokenBudget?: number | null,
  enterpriseTokenBudgetPeriod?: string | null,
  enterpriseImageUrl?: string | null,
  randomGroup?: number | null,
  apiCreditRemaining?: number | null,
  createdAt: string,
  summaryEmailPeriod?: number | null,
  summaryEmailAddresses?: string | null,
  lastSummaryEmailSentAt?: string | null,
  mcpServerWhitelist?: string | null,
  automaticModelManagement?: boolean | null,
  supersmallGroupModels?: string | null,
  standardGroupModels?: string | null,
  premiumGroupModels?: string | null,
  reasoningGroupModels?: string | null,
  superpremiumGroupModels?: string | null,
  openrouterStandardGroupModels?: string | null,
  openrouterPremiumGroupModels?: string | null,
  azureOpenaiBaseUrl?: string | null,
  azureOpenaiApiVersion?: string | null,
  awsBedrockRegion?: string | null,
  newCustomerUsageTierId?: string | null,
  newCustomerUsageTier?: LLMUsageTier | null,
  usageTapUsageApiKey?: string | null,
  lowApiCreditNotificationEmails?: string | null,
  lowApiCreditNotificationMinimumCredit?: number | null,
  lastLowApiCreditNotificationSentAt?: string | null,
  integrationApiKey1Hash?: string | null,
  integrationApiKey1Status?: string | null,
  integrationApiKey1Prefix?: string | null,
  integrationApiKey1LastRotatedAt?: string | null,
  integrationApiKey1Scopes?: Array< string > | null,
  integrationApiKey2Hash?: string | null,
  integrationApiKey2Status?: string | null,
  integrationApiKey2Prefix?: string | null,
  integrationApiKey2LastRotatedAt?: string | null,
  integrationApiKey2Scopes?: Array< string > | null,
  updatedAt: string,
};

export type ModelLLMUserConnection = {
  __typename: "ModelLLMUserConnection",
  items:  Array<LLMUser | null >,
  nextToken?: string | null,
};

export type LLMUser = {
  __typename: "LLMUser",
  id: string,
  email: string,
  status: string,
  displayName?: string | null,
  acceptedTermsOfService?: boolean | null,
  acceptedGDPRTerms?: boolean | null,
  projectId: string,
  project?: LLMProject | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLLMServiceConnection = {
  __typename: "ModelLLMServiceConnection",
  items:  Array<LLMService | null >,
  nextToken?: string | null,
};

export type LLMService = {
  __typename: "LLMService",
  id: string,
  name: string,
  status: string,
  vendor: string,
  region: string,
  endpoint?: string | null,
  body?: string | null,
  header?: string | null,
  projectId: string,
  loadProportion?: number | null,
  inputTokenPricePerMillion?: number | null,
  outputTokenPricePerMillion?: number | null,
  groupId?: string | null,
  group?: LLMGroup | null,
  createdAt: string,
  updatedAt: string,
};

export type LLMGroup = {
  __typename: "LLMGroup",
  id: string,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  order?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type LLMProjectSubscription = {
  __typename: "LLMProjectSubscription",
  id: string,
  projectId?: string | null,
  quantity?: number | null,
  subscriptionId?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionStatus?: string | null,
  subscriptionProduct?: string | null,
  subscriptionInterval?: string | null,
  subscriptionEndedAt?: string | null,
  subscriptionCancelAtPeriodEnd?: string | null,
  usageSubscriptionId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type LLMUsageTier = {
  __typename: "LLMUsageTier",
  id: string,
  projectId: string,
  status: LLMUsageTierStatus,
  name: string,
  description?: string | null,
  version: number,
  activeAt?: string | null,
  inactiveAt?: string | null,
  priorUsageTierId?: string | null,
  priorUsageTier?: LLMUsageTier | null,
  baseUsageTierId?: string | null,
  baseUsageTier?: LLMUsageTier | null,
  replenishmentPeriod?: LLMPeriod | null,
  replenishmentMethod?: LLMReplenishmentMethod | null,
  usageLimitAction?: LLMUsageLimitAction | null,
  standardTokenReplenishmentAmount?: number | null,
  premiumTokenReplenishmentAmount?: number | null,
  superPremiumTokenReplenishmentAmount?: number | null,
  reasoningTokenReplenishmentAmount?: number | null,
  standardCallReplenishmentAmount?: number | null,
  premiumCallReplenishmentAmount?: number | null,
  superPremiumCallReplenishmentAmount?: number | null,
  reasoningCallReplenishmentAmount?: number | null,
  standardTokenUnlimited?: boolean | null,
  premiumTokenUnlimited?: boolean | null,
  superPremiumTokenUnlimited?: boolean | null,
  reasoningTokenUnlimited?: boolean | null,
  standardCallUnlimited?: boolean | null,
  premiumCallUnlimited?: boolean | null,
  superPremiumCallUnlimited?: boolean | null,
  reasoningCallUnlimited?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export enum LLMUsageTierStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}


export enum LLMPeriod {
  NONE = "NONE",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}


export enum LLMReplenishmentMethod {
  ACCUMULATE = "ACCUMULATE",
  RESET = "RESET",
  NONE = "NONE",
}


export enum LLMUsageLimitAction {
  BLOCK = "BLOCK",
  ALLOW = "ALLOW",
  RESTRICT = "RESTRICT",
}


export type DeleteLLMBatchInput = {
  id: string,
};

export type ModelLLMBatchConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  vendorBatchId?: ModelStringInput | null,
  vendorInputFileId?: ModelStringInput | null,
  vendorOutputFileId?: ModelStringInput | null,
  vendorErrorFileId?: ModelStringInput | null,
  requestCount?: ModelIntInput | null,
  completedCount?: ModelIntInput | null,
  failedCount?: ModelIntInput | null,
  nextPollAt?: ModelStringInput | null,
  callbackUrl?: ModelStringInput | null,
  callbackSecret?: ModelStringInput | null,
  callbackStatus?: ModelStringInput | null,
  callbackAttempts?: ModelIntInput | null,
  callbackLastError?: ModelStringInput | null,
  idempotencyKeyHash?: ModelStringInput | null,
  requestHash?: ModelStringInput | null,
  error?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMBatchConditionInput | null > | null,
  or?: Array< ModelLLMBatchConditionInput | null > | null,
  not?: ModelLLMBatchConditionInput | null,
};

export type LLMBatch = {
  __typename: "LLMBatch",
  id: string,
  projectId: string,
  status: string,
  vendor: string,
  vendorBatchId?: string | null,
  vendorInputFileId?: string | null,
  vendorOutputFileId?: string | null,
  vendorErrorFileId?: string | null,
  requestCount: number,
  completedCount: number,
  failedCount: number,
  nextPollAt: string,
  callbackUrl?: string | null,
  callbackSecret?: string | null,
  callbackStatus?: string | null,
  callbackAttempts?: number | null,
  callbackLastError?: string | null,
  idempotencyKeyHash?: string | null,
  requestHash?: string | null,
  error?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type CreateLLMProjectInput = {
  id?: string | null,
  name: string,
  status: string,
  description?: string | null,
  stripeCustomerId?: string | null,
  newCustomerTokenCount?: number | null,
  cacheResponsesForSeconds?: number | null,
  loadSheddingTier: number,
  newCustomerLoadSheddingTier?: number | null,
  maintenanceMode: boolean,
  maintenanceModeMessage?: string | null,
  loadBalancingMode: string,
  piiRedactionScope?: string | null,
  systemInstructions?: string | null,
  piiScope?: string | null,
  piiGroupId?: string | null,
  piiMessage?: string | null,
  promptBlacklist?: string | null,
  blacklistGroupId?: string | null,
  blacklistMessage?: string | null,
  safety?: number | null,
  safetyGroupId?: string | null,
  safetyMessage?: string | null,
  strongModelGroupId?: string | null,
  routeModel?: string | null,
  trialTokensRemaining?: number | null,
  logfileRetentionPeriod?: number | null,
  callRetentionPeriod?: number | null,
  logInterval?: string | null,
  lastLogGeneratedAt?: string | null,
  logGenerationCursor?: string | null,
  enterpriseAllowChat?: boolean | null,
  enterpriseAcceptableUsePolicy?: string | null,
  enterpriseAccessRequestEmail?: string | null,
  enterpriseSupportEmail?: string | null,
  enterpriseDomainWhitelist?: string | null,
  enterpriseTokenBudget?: number | null,
  enterpriseTokenBudgetPeriod?: string | null,
  enterpriseImageUrl?: string | null,
  randomGroup?: number | null,
  apiCreditRemaining?: number | null,
  createdAt?: string | null,
  summaryEmailPeriod?: number | null,
  summaryEmailAddresses?: string | null,
  lastSummaryEmailSentAt?: string | null,
  mcpServerWhitelist?: string | null,
  automaticModelManagement?: boolean | null,
  supersmallGroupModels?: string | null,
  standardGroupModels?: string | null,
  premiumGroupModels?: string | null,
  reasoningGroupModels?: string | null,
  superpremiumGroupModels?: string | null,
  openrouterStandardGroupModels?: string | null,
  openrouterPremiumGroupModels?: string | null,
  azureOpenaiBaseUrl?: string | null,
  azureOpenaiApiVersion?: string | null,
  awsBedrockRegion?: string | null,
  newCustomerUsageTierId?: string | null,
  usageTapUsageApiKey?: string | null,
  lowApiCreditNotificationEmails?: string | null,
  lowApiCreditNotificationMinimumCredit?: number | null,
  lastLowApiCreditNotificationSentAt?: string | null,
  integrationApiKey1Hash?: string | null,
  integrationApiKey1Status?: string | null,
  integrationApiKey1Prefix?: string | null,
  integrationApiKey1LastRotatedAt?: string | null,
  integrationApiKey1Scopes?: Array< string > | null,
  integrationApiKey2Hash?: string | null,
  integrationApiKey2Status?: string | null,
  integrationApiKey2Prefix?: string | null,
  integrationApiKey2LastRotatedAt?: string | null,
  integrationApiKey2Scopes?: Array< string > | null,
};

export type UpdateLLMProjectInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  description?: string | null,
  stripeCustomerId?: string | null,
  newCustomerTokenCount?: number | null,
  cacheResponsesForSeconds?: number | null,
  loadSheddingTier?: number | null,
  newCustomerLoadSheddingTier?: number | null,
  maintenanceMode?: boolean | null,
  maintenanceModeMessage?: string | null,
  loadBalancingMode?: string | null,
  piiRedactionScope?: string | null,
  systemInstructions?: string | null,
  piiScope?: string | null,
  piiGroupId?: string | null,
  piiMessage?: string | null,
  promptBlacklist?: string | null,
  blacklistGroupId?: string | null,
  blacklistMessage?: string | null,
  safety?: number | null,
  safetyGroupId?: string | null,
  safetyMessage?: string | null,
  strongModelGroupId?: string | null,
  routeModel?: string | null,
  trialTokensRemaining?: number | null,
  logfileRetentionPeriod?: number | null,
  callRetentionPeriod?: number | null,
  logInterval?: string | null,
  lastLogGeneratedAt?: string | null,
  logGenerationCursor?: string | null,
  enterpriseAllowChat?: boolean | null,
  enterpriseAcceptableUsePolicy?: string | null,
  enterpriseAccessRequestEmail?: string | null,
  enterpriseSupportEmail?: string | null,
  enterpriseDomainWhitelist?: string | null,
  enterpriseTokenBudget?: number | null,
  enterpriseTokenBudgetPeriod?: string | null,
  enterpriseImageUrl?: string | null,
  randomGroup?: number | null,
  apiCreditRemaining?: number | null,
  createdAt?: string | null,
  summaryEmailPeriod?: number | null,
  summaryEmailAddresses?: string | null,
  lastSummaryEmailSentAt?: string | null,
  mcpServerWhitelist?: string | null,
  automaticModelManagement?: boolean | null,
  supersmallGroupModels?: string | null,
  standardGroupModels?: string | null,
  premiumGroupModels?: string | null,
  reasoningGroupModels?: string | null,
  superpremiumGroupModels?: string | null,
  openrouterStandardGroupModels?: string | null,
  openrouterPremiumGroupModels?: string | null,
  azureOpenaiBaseUrl?: string | null,
  azureOpenaiApiVersion?: string | null,
  awsBedrockRegion?: string | null,
  newCustomerUsageTierId?: string | null,
  usageTapUsageApiKey?: string | null,
  lowApiCreditNotificationEmails?: string | null,
  lowApiCreditNotificationMinimumCredit?: number | null,
  lastLowApiCreditNotificationSentAt?: string | null,
  integrationApiKey1Hash?: string | null,
  integrationApiKey1Status?: string | null,
  integrationApiKey1Prefix?: string | null,
  integrationApiKey1LastRotatedAt?: string | null,
  integrationApiKey1Scopes?: Array< string > | null,
  integrationApiKey2Hash?: string | null,
  integrationApiKey2Status?: string | null,
  integrationApiKey2Prefix?: string | null,
  integrationApiKey2LastRotatedAt?: string | null,
  integrationApiKey2Scopes?: Array< string > | null,
};

export type CreateLLMUsageTierInput = {
  id?: string | null,
  projectId: string,
  status: LLMUsageTierStatus,
  name: string,
  description?: string | null,
  version: number,
  activeAt?: string | null,
  inactiveAt?: string | null,
  priorUsageTierId?: string | null,
  baseUsageTierId?: string | null,
  replenishmentPeriod?: LLMPeriod | null,
  replenishmentMethod?: LLMReplenishmentMethod | null,
  usageLimitAction?: LLMUsageLimitAction | null,
  standardTokenReplenishmentAmount?: number | null,
  premiumTokenReplenishmentAmount?: number | null,
  superPremiumTokenReplenishmentAmount?: number | null,
  reasoningTokenReplenishmentAmount?: number | null,
  standardCallReplenishmentAmount?: number | null,
  premiumCallReplenishmentAmount?: number | null,
  superPremiumCallReplenishmentAmount?: number | null,
  reasoningCallReplenishmentAmount?: number | null,
  standardTokenUnlimited?: boolean | null,
  premiumTokenUnlimited?: boolean | null,
  superPremiumTokenUnlimited?: boolean | null,
  reasoningTokenUnlimited?: boolean | null,
  standardCallUnlimited?: boolean | null,
  premiumCallUnlimited?: boolean | null,
  superPremiumCallUnlimited?: boolean | null,
  reasoningCallUnlimited?: boolean | null,
};

export type ModelLLMUsageTierConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelLLMUsageTierStatusInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  version?: ModelIntInput | null,
  activeAt?: ModelStringInput | null,
  inactiveAt?: ModelStringInput | null,
  priorUsageTierId?: ModelIDInput | null,
  baseUsageTierId?: ModelIDInput | null,
  replenishmentPeriod?: ModelLLMPeriodInput | null,
  replenishmentMethod?: ModelLLMReplenishmentMethodInput | null,
  usageLimitAction?: ModelLLMUsageLimitActionInput | null,
  standardTokenReplenishmentAmount?: ModelIntInput | null,
  premiumTokenReplenishmentAmount?: ModelIntInput | null,
  superPremiumTokenReplenishmentAmount?: ModelIntInput | null,
  reasoningTokenReplenishmentAmount?: ModelIntInput | null,
  standardCallReplenishmentAmount?: ModelIntInput | null,
  premiumCallReplenishmentAmount?: ModelIntInput | null,
  superPremiumCallReplenishmentAmount?: ModelIntInput | null,
  reasoningCallReplenishmentAmount?: ModelIntInput | null,
  standardTokenUnlimited?: ModelBooleanInput | null,
  premiumTokenUnlimited?: ModelBooleanInput | null,
  superPremiumTokenUnlimited?: ModelBooleanInput | null,
  reasoningTokenUnlimited?: ModelBooleanInput | null,
  standardCallUnlimited?: ModelBooleanInput | null,
  premiumCallUnlimited?: ModelBooleanInput | null,
  superPremiumCallUnlimited?: ModelBooleanInput | null,
  reasoningCallUnlimited?: ModelBooleanInput | null,
  and?: Array< ModelLLMUsageTierConditionInput | null > | null,
  or?: Array< ModelLLMUsageTierConditionInput | null > | null,
  not?: ModelLLMUsageTierConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMUsageTierStatusInput = {
  eq?: LLMUsageTierStatus | null,
  ne?: LLMUsageTierStatus | null,
};

export type ModelLLMPeriodInput = {
  eq?: LLMPeriod | null,
  ne?: LLMPeriod | null,
};

export type ModelLLMReplenishmentMethodInput = {
  eq?: LLMReplenishmentMethod | null,
  ne?: LLMReplenishmentMethod | null,
};

export type ModelLLMUsageLimitActionInput = {
  eq?: LLMUsageLimitAction | null,
  ne?: LLMUsageLimitAction | null,
};

export type UpdateLLMUsageTierInput = {
  id: string,
  projectId?: string | null,
  status?: LLMUsageTierStatus | null,
  name?: string | null,
  description?: string | null,
  version?: number | null,
  activeAt?: string | null,
  inactiveAt?: string | null,
  priorUsageTierId?: string | null,
  baseUsageTierId?: string | null,
  replenishmentPeriod?: LLMPeriod | null,
  replenishmentMethod?: LLMReplenishmentMethod | null,
  usageLimitAction?: LLMUsageLimitAction | null,
  standardTokenReplenishmentAmount?: number | null,
  premiumTokenReplenishmentAmount?: number | null,
  superPremiumTokenReplenishmentAmount?: number | null,
  reasoningTokenReplenishmentAmount?: number | null,
  standardCallReplenishmentAmount?: number | null,
  premiumCallReplenishmentAmount?: number | null,
  superPremiumCallReplenishmentAmount?: number | null,
  reasoningCallReplenishmentAmount?: number | null,
  standardTokenUnlimited?: boolean | null,
  premiumTokenUnlimited?: boolean | null,
  superPremiumTokenUnlimited?: boolean | null,
  reasoningTokenUnlimited?: boolean | null,
  standardCallUnlimited?: boolean | null,
  premiumCallUnlimited?: boolean | null,
  superPremiumCallUnlimited?: boolean | null,
  reasoningCallUnlimited?: boolean | null,
};

export type DeleteLLMUsageTierInput = {
  id: string,
};

export type CreateLLMProjectSubscriptionInput = {
  id?: string | null,
  projectId?: string | null,
  quantity?: number | null,
  subscriptionId?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionStatus?: string | null,
  subscriptionProduct?: string | null,
  subscriptionInterval?: string | null,
  subscriptionEndedAt?: string | null,
  subscriptionCancelAtPeriodEnd?: string | null,
  usageSubscriptionId?: string | null,
};

export type ModelLLMProjectSubscriptionConditionInput = {
  projectId?: ModelIDInput | null,
  quantity?: ModelIntInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionStartDate?: ModelStringInput | null,
  subscriptionEndDate?: ModelStringInput | null,
  subscriptionStatus?: ModelStringInput | null,
  subscriptionProduct?: ModelStringInput | null,
  subscriptionInterval?: ModelStringInput | null,
  subscriptionEndedAt?: ModelStringInput | null,
  subscriptionCancelAtPeriodEnd?: ModelStringInput | null,
  usageSubscriptionId?: ModelStringInput | null,
  and?: Array< ModelLLMProjectSubscriptionConditionInput | null > | null,
  or?: Array< ModelLLMProjectSubscriptionConditionInput | null > | null,
  not?: ModelLLMProjectSubscriptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMProjectSubscriptionInput = {
  id: string,
  projectId?: string | null,
  quantity?: number | null,
  subscriptionId?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionStatus?: string | null,
  subscriptionProduct?: string | null,
  subscriptionInterval?: string | null,
  subscriptionEndedAt?: string | null,
  subscriptionCancelAtPeriodEnd?: string | null,
  usageSubscriptionId?: string | null,
};

export type DeleteLLMProjectSubscriptionInput = {
  id: string,
};

export type CreateLLMUserInput = {
  id?: string | null,
  email: string,
  status: string,
  displayName?: string | null,
  acceptedTermsOfService?: boolean | null,
  acceptedGDPRTerms?: boolean | null,
  projectId: string,
};

export type ModelLLMUserConditionInput = {
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  acceptedTermsOfService?: ModelBooleanInput | null,
  acceptedGDPRTerms?: ModelBooleanInput | null,
  projectId?: ModelIDInput | null,
  and?: Array< ModelLLMUserConditionInput | null > | null,
  or?: Array< ModelLLMUserConditionInput | null > | null,
  not?: ModelLLMUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMUserInput = {
  id: string,
  email?: string | null,
  status?: string | null,
  displayName?: string | null,
  acceptedTermsOfService?: boolean | null,
  acceptedGDPRTerms?: boolean | null,
  projectId?: string | null,
};

export type DeleteLLMUserInput = {
  id: string,
};

export type CreateLLMServiceInput = {
  id?: string | null,
  name: string,
  status: string,
  vendor: string,
  region: string,
  endpoint?: string | null,
  body?: string | null,
  header?: string | null,
  projectId: string,
  loadProportion?: number | null,
  inputTokenPricePerMillion?: number | null,
  outputTokenPricePerMillion?: number | null,
  groupId?: string | null,
};

export type ModelLLMServiceConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  endpoint?: ModelStringInput | null,
  body?: ModelStringInput | null,
  header?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  loadProportion?: ModelIntInput | null,
  inputTokenPricePerMillion?: ModelFloatInput | null,
  outputTokenPricePerMillion?: ModelFloatInput | null,
  groupId?: ModelIDInput | null,
  and?: Array< ModelLLMServiceConditionInput | null > | null,
  or?: Array< ModelLLMServiceConditionInput | null > | null,
  not?: ModelLLMServiceConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMServiceInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  vendor?: string | null,
  region?: string | null,
  endpoint?: string | null,
  body?: string | null,
  header?: string | null,
  projectId?: string | null,
  loadProportion?: number | null,
  inputTokenPricePerMillion?: number | null,
  outputTokenPricePerMillion?: number | null,
  groupId?: string | null,
};

export type DeleteLLMServiceInput = {
  id: string,
};

export type CreateLLMGroupInput = {
  id?: string | null,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  order?: number | null,
};

export type ModelLLMGroupConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  order?: ModelIntInput | null,
  and?: Array< ModelLLMGroupConditionInput | null > | null,
  or?: Array< ModelLLMGroupConditionInput | null > | null,
  not?: ModelLLMGroupConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMGroupInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  projectId?: string | null,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  order?: number | null,
};

export type DeleteLLMGroupInput = {
  id: string,
};

export type CreateLLMCustomerInput = {
  id?: string | null,
  name?: string | null,
  status: string,
  tokensRemaining: number,
  lastCallMadeAt?: string | null,
  numberOfCallsMade?: number | null,
  projectId: string,
  loadSheddingTier: number,
  dataResidency: string,
  createdAt?: string | null,
  enterpriseUser?: boolean | null,
  tokenReplenishmentAmount?: number | null,
  tokenReplenishmentPeriod?: string | null,
  lastReplenishedAt?: string | null,
  nextReplenishAt?: string | null,
  usageTierId?: string | null,
  nextUsageTierId?: string | null,
  nextUsageTierAt?: string | null,
  usageLimitAction?: LLMUsageLimitAction | null,
  standardTokensRemaining?: number | null,
  premiumTokensRemaining?: number | null,
  superPremiumTokensRemaining?: number | null,
  reasoningTokensRemaining?: number | null,
  standardCallsRemaining?: number | null,
  premiumCallsRemaining?: number | null,
  superPremiumCallsRemaining?: number | null,
  reasoningCallsRemaining?: number | null,
  standardTokenUnlimited?: boolean | null,
  premiumTokenUnlimited?: boolean | null,
  superPremiumTokenUnlimited?: boolean | null,
  reasoningTokenUnlimited?: boolean | null,
  standardCallUnlimited?: boolean | null,
  premiumCallUnlimited?: boolean | null,
  superPremiumCallUnlimited?: boolean | null,
  reasoningCallUnlimited?: boolean | null,
};

export type ModelLLMCustomerConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  tokensRemaining?: ModelIntInput | null,
  lastCallMadeAt?: ModelStringInput | null,
  numberOfCallsMade?: ModelIntInput | null,
  projectId?: ModelIDInput | null,
  loadSheddingTier?: ModelIntInput | null,
  dataResidency?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  enterpriseUser?: ModelBooleanInput | null,
  tokenReplenishmentAmount?: ModelIntInput | null,
  tokenReplenishmentPeriod?: ModelStringInput | null,
  lastReplenishedAt?: ModelStringInput | null,
  nextReplenishAt?: ModelStringInput | null,
  usageTierId?: ModelIDInput | null,
  nextUsageTierId?: ModelIDInput | null,
  nextUsageTierAt?: ModelStringInput | null,
  usageLimitAction?: ModelLLMUsageLimitActionInput | null,
  standardTokensRemaining?: ModelIntInput | null,
  premiumTokensRemaining?: ModelIntInput | null,
  superPremiumTokensRemaining?: ModelIntInput | null,
  reasoningTokensRemaining?: ModelIntInput | null,
  standardCallsRemaining?: ModelIntInput | null,
  premiumCallsRemaining?: ModelIntInput | null,
  superPremiumCallsRemaining?: ModelIntInput | null,
  reasoningCallsRemaining?: ModelIntInput | null,
  standardTokenUnlimited?: ModelBooleanInput | null,
  premiumTokenUnlimited?: ModelBooleanInput | null,
  superPremiumTokenUnlimited?: ModelBooleanInput | null,
  reasoningTokenUnlimited?: ModelBooleanInput | null,
  standardCallUnlimited?: ModelBooleanInput | null,
  premiumCallUnlimited?: ModelBooleanInput | null,
  superPremiumCallUnlimited?: ModelBooleanInput | null,
  reasoningCallUnlimited?: ModelBooleanInput | null,
  and?: Array< ModelLLMCustomerConditionInput | null > | null,
  or?: Array< ModelLLMCustomerConditionInput | null > | null,
  not?: ModelLLMCustomerConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMCustomer = {
  __typename: "LLMCustomer",
  id: string,
  name?: string | null,
  status: string,
  tokensRemaining: number,
  lastCallMadeAt?: string | null,
  numberOfCallsMade?: number | null,
  projectId: string,
  loadSheddingTier: number,
  dataResidency: string,
  createdAt: string,
  enterpriseUser?: boolean | null,
  tokenReplenishmentAmount?: number | null,
  tokenReplenishmentPeriod?: string | null,
  lastReplenishedAt?: string | null,
  nextReplenishAt?: string | null,
  usageTierId?: string | null,
  usageTier?: LLMUsageTier | null,
  nextUsageTierId?: string | null,
  nextUsageTier?: LLMUsageTier | null,
  nextUsageTierAt?: string | null,
  usageLimitAction?: LLMUsageLimitAction | null,
  standardTokensRemaining?: number | null,
  premiumTokensRemaining?: number | null,
  superPremiumTokensRemaining?: number | null,
  reasoningTokensRemaining?: number | null,
  standardCallsRemaining?: number | null,
  premiumCallsRemaining?: number | null,
  superPremiumCallsRemaining?: number | null,
  reasoningCallsRemaining?: number | null,
  standardTokenUnlimited?: boolean | null,
  premiumTokenUnlimited?: boolean | null,
  superPremiumTokenUnlimited?: boolean | null,
  reasoningTokenUnlimited?: boolean | null,
  standardCallUnlimited?: boolean | null,
  premiumCallUnlimited?: boolean | null,
  superPremiumCallUnlimited?: boolean | null,
  reasoningCallUnlimited?: boolean | null,
  updatedAt: string,
};

export type UpdateLLMCustomerInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  tokensRemaining?: number | null,
  lastCallMadeAt?: string | null,
  numberOfCallsMade?: number | null,
  projectId?: string | null,
  loadSheddingTier?: number | null,
  dataResidency?: string | null,
  createdAt?: string | null,
  enterpriseUser?: boolean | null,
  tokenReplenishmentAmount?: number | null,
  tokenReplenishmentPeriod?: string | null,
  lastReplenishedAt?: string | null,
  nextReplenishAt?: string | null,
  usageTierId?: string | null,
  nextUsageTierId?: string | null,
  nextUsageTierAt?: string | null,
  usageLimitAction?: LLMUsageLimitAction | null,
  standardTokensRemaining?: number | null,
  premiumTokensRemaining?: number | null,
  superPremiumTokensRemaining?: number | null,
  reasoningTokensRemaining?: number | null,
  standardCallsRemaining?: number | null,
  premiumCallsRemaining?: number | null,
  superPremiumCallsRemaining?: number | null,
  reasoningCallsRemaining?: number | null,
  standardTokenUnlimited?: boolean | null,
  premiumTokenUnlimited?: boolean | null,
  superPremiumTokenUnlimited?: boolean | null,
  reasoningTokenUnlimited?: boolean | null,
  standardCallUnlimited?: boolean | null,
  premiumCallUnlimited?: boolean | null,
  superPremiumCallUnlimited?: boolean | null,
  reasoningCallUnlimited?: boolean | null,
};

export type DeleteLLMCustomerInput = {
  id: string,
};

export type CreateLLMCallInput = {
  id?: string | null,
  projectId: string,
  status: string,
  customerId?: string | null,
  serviceId?: string | null,
  modelId?: string | null,
  requestHash?: string | null,
  messages?: string | null,
  prompt?: string | null,
  response?: string | null,
  tokenCountPrompt?: number | null,
  tokenCountResponse?: number | null,
  createdAt?: string | null,
  hash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  quality?: number | null,
  qualityComment?: string | null,
  apiKeyType?: string | null,
  toxicity?: string | null,
  randomGroup?: number | null,
  agentId?: string | null,
  conversationId?: string | null,
  timings?: string | null,
  customer_user_id?: string | null,
  customer_user_name?: string | null,
  customer_user_email?: string | null,
  batch?: boolean | null,
  callbackUrl?: string | null,
  batchId?: string | null,
  batchCustomId?: string | null,
  batchRequest?: string | null,
  executionMode?: string | null,
  pricingMode?: string | null,
  vendorBatchId?: string | null,
  vendorResponseId?: string | null,
  vendorStatus?: string | null,
  resolvedModelId?: string | null,
  usageTapCallId?: string | null,
  usageTapStripeCustomerId?: string | null,
  error?: string | null,
  cacheReadTokens?: number | null,
  cacheWriteTokens?: number | null,
  cacheStatus?: string | null,
  compactionTriggered?: boolean | null,
  compactionTokensSaved?: number | null,
  curatedTokensSaved?: number | null,
  curatedItems?: number | null,
};

export type ModelLLMCallConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  customerId?: ModelIDInput | null,
  serviceId?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  requestHash?: ModelStringInput | null,
  messages?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  response?: ModelStringInput | null,
  tokenCountPrompt?: ModelIntInput | null,
  tokenCountResponse?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  hash?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  quality?: ModelIntInput | null,
  qualityComment?: ModelStringInput | null,
  apiKeyType?: ModelStringInput | null,
  toxicity?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  agentId?: ModelIDInput | null,
  conversationId?: ModelIDInput | null,
  timings?: ModelStringInput | null,
  customer_user_id?: ModelStringInput | null,
  customer_user_name?: ModelStringInput | null,
  customer_user_email?: ModelStringInput | null,
  batch?: ModelBooleanInput | null,
  callbackUrl?: ModelStringInput | null,
  batchId?: ModelIDInput | null,
  batchCustomId?: ModelStringInput | null,
  batchRequest?: ModelStringInput | null,
  executionMode?: ModelStringInput | null,
  pricingMode?: ModelStringInput | null,
  vendorBatchId?: ModelStringInput | null,
  vendorResponseId?: ModelStringInput | null,
  vendorStatus?: ModelStringInput | null,
  resolvedModelId?: ModelStringInput | null,
  usageTapCallId?: ModelStringInput | null,
  usageTapStripeCustomerId?: ModelStringInput | null,
  error?: ModelStringInput | null,
  cacheReadTokens?: ModelIntInput | null,
  cacheWriteTokens?: ModelIntInput | null,
  cacheStatus?: ModelStringInput | null,
  compactionTriggered?: ModelBooleanInput | null,
  compactionTokensSaved?: ModelIntInput | null,
  curatedTokensSaved?: ModelIntInput | null,
  curatedItems?: ModelIntInput | null,
  and?: Array< ModelLLMCallConditionInput | null > | null,
  or?: Array< ModelLLMCallConditionInput | null > | null,
  not?: ModelLLMCallConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMCall = {
  __typename: "LLMCall",
  id: string,
  projectId: string,
  status: string,
  customerId?: string | null,
  customer?: LLMCustomer | null,
  serviceId?: string | null,
  service?: LLMService | null,
  modelId?: string | null,
  model?: LLMModel | null,
  requestHash?: string | null,
  messages?: string | null,
  prompt?: string | null,
  response?: string | null,
  tokenCountPrompt?: number | null,
  tokenCountResponse?: number | null,
  createdAt: string,
  hash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  quality?: number | null,
  qualityComment?: string | null,
  apiKeyType?: string | null,
  toxicity?: string | null,
  randomGroup?: number | null,
  agentId?: string | null,
  conversationId?: string | null,
  timings?: string | null,
  customer_user_id?: string | null,
  customer_user_name?: string | null,
  customer_user_email?: string | null,
  batch?: boolean | null,
  callbackUrl?: string | null,
  batchId?: string | null,
  batchCustomId?: string | null,
  batchRequest?: string | null,
  executionMode?: string | null,
  pricingMode?: string | null,
  vendorBatchId?: string | null,
  vendorResponseId?: string | null,
  vendorStatus?: string | null,
  resolvedModelId?: string | null,
  usageTapCallId?: string | null,
  usageTapStripeCustomerId?: string | null,
  error?: string | null,
  cacheReadTokens?: number | null,
  cacheWriteTokens?: number | null,
  cacheStatus?: string | null,
  compactionTriggered?: boolean | null,
  compactionTokensSaved?: number | null,
  curatedTokensSaved?: number | null,
  curatedItems?: number | null,
  updatedAt: string,
};

export type LLMModel = {
  __typename: "LLMModel",
  id: string,
  status: string,
  vendor: string,
  host: string,
  supported: boolean,
  name: string,
  description?: string | null,
  modelKey?: string | null,
  modelKeyLatest?: string | null,
  inputTokenPrice?: number | null,
  cachedTokenPrice?: number | null,
  outputTokenPrice?: number | null,
  inputTokenBatchPrice?: number | null,
  outputTokenBatchPrice?: number | null,
  searchCost?: number | null,
  supportsSearch?: boolean | null,
  textInputSupport?: boolean | null,
  imageInputSupport?: boolean | null,
  audioInputSupport?: boolean | null,
  textOutputSupport?: boolean | null,
  imageOutputSupport?: boolean | null,
  audioOutputSupport?: boolean | null,
  thinkingSupport?: boolean | null,
  contextWindowTokens?: number | null,
  maxResponseTokens?: number | null,
  knowledgeCutoffDate?: string | null,
  lastCheckedDate?: string | null,
  supportedLanguages?: string | null,
  warningDate?: string | null,
  warningMessage?: string | null,
  deprecationDate?: string | null,
  deprecationMessage?: string | null,
  defaultServiceGroup?: string | null,
  defaultEnabled?: boolean | null,
  displayOrder?: number | null,
  recommendedUseCase?: string | null,
  performanceRating?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMCallInput = {
  id: string,
  projectId?: string | null,
  status?: string | null,
  customerId?: string | null,
  serviceId?: string | null,
  modelId?: string | null,
  requestHash?: string | null,
  messages?: string | null,
  prompt?: string | null,
  response?: string | null,
  tokenCountPrompt?: number | null,
  tokenCountResponse?: number | null,
  createdAt?: string | null,
  hash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  quality?: number | null,
  qualityComment?: string | null,
  apiKeyType?: string | null,
  toxicity?: string | null,
  randomGroup?: number | null,
  agentId?: string | null,
  conversationId?: string | null,
  timings?: string | null,
  customer_user_id?: string | null,
  customer_user_name?: string | null,
  customer_user_email?: string | null,
  batch?: boolean | null,
  callbackUrl?: string | null,
  batchId?: string | null,
  batchCustomId?: string | null,
  batchRequest?: string | null,
  executionMode?: string | null,
  pricingMode?: string | null,
  vendorBatchId?: string | null,
  vendorResponseId?: string | null,
  vendorStatus?: string | null,
  resolvedModelId?: string | null,
  usageTapCallId?: string | null,
  usageTapStripeCustomerId?: string | null,
  error?: string | null,
  cacheReadTokens?: number | null,
  cacheWriteTokens?: number | null,
  cacheStatus?: string | null,
  compactionTriggered?: boolean | null,
  compactionTokensSaved?: number | null,
  curatedTokensSaved?: number | null,
  curatedItems?: number | null,
};

export type DeleteLLMCallInput = {
  id: string,
};

export type CreateLLMBatchInput = {
  id?: string | null,
  projectId: string,
  status: string,
  vendor: string,
  vendorBatchId?: string | null,
  vendorInputFileId?: string | null,
  vendorOutputFileId?: string | null,
  vendorErrorFileId?: string | null,
  requestCount: number,
  completedCount: number,
  failedCount: number,
  nextPollAt: string,
  callbackUrl?: string | null,
  callbackSecret?: string | null,
  callbackStatus?: string | null,
  callbackAttempts?: number | null,
  callbackLastError?: string | null,
  idempotencyKeyHash?: string | null,
  requestHash?: string | null,
  error?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateLLMBatchInput = {
  id: string,
  projectId?: string | null,
  status?: string | null,
  vendor?: string | null,
  vendorBatchId?: string | null,
  vendorInputFileId?: string | null,
  vendorOutputFileId?: string | null,
  vendorErrorFileId?: string | null,
  requestCount?: number | null,
  completedCount?: number | null,
  failedCount?: number | null,
  nextPollAt?: string | null,
  callbackUrl?: string | null,
  callbackSecret?: string | null,
  callbackStatus?: string | null,
  callbackAttempts?: number | null,
  callbackLastError?: string | null,
  idempotencyKeyHash?: string | null,
  requestHash?: string | null,
  error?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type CreateLLMPromptInput = {
  id?: string | null,
  projectId: string,
  status: string,
  name: string,
  description?: string | null,
  prompt?: string | null,
  key: string,
};

export type ModelLLMPromptConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  key?: ModelStringInput | null,
  and?: Array< ModelLLMPromptConditionInput | null > | null,
  or?: Array< ModelLLMPromptConditionInput | null > | null,
  not?: ModelLLMPromptConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMPrompt = {
  __typename: "LLMPrompt",
  id: string,
  projectId: string,
  status: string,
  name: string,
  description?: string | null,
  prompt?: string | null,
  key: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMPromptInput = {
  id: string,
  projectId?: string | null,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  prompt?: string | null,
  key?: string | null,
};

export type DeleteLLMPromptInput = {
  id: string,
};

export type CreateLLMCallLogFileInput = {
  id?: string | null,
  projectId: string,
  fromDate?: string | null,
  toDate?: string | null,
  chunk?: number | null,
  count?: number | null,
  status: string,
  bucket: string,
  key: string,
  url?: string | null,
  urlExpiresAt?: string | null,
  deleteFileAfter?: string | null,
  createdAt?: string | null,
  randomGroup?: number | null,
};

export type ModelLLMCallLogFileConditionInput = {
  projectId?: ModelIDInput | null,
  fromDate?: ModelStringInput | null,
  toDate?: ModelStringInput | null,
  chunk?: ModelIntInput | null,
  count?: ModelIntInput | null,
  status?: ModelStringInput | null,
  bucket?: ModelStringInput | null,
  key?: ModelStringInput | null,
  url?: ModelStringInput | null,
  urlExpiresAt?: ModelStringInput | null,
  deleteFileAfter?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  and?: Array< ModelLLMCallLogFileConditionInput | null > | null,
  or?: Array< ModelLLMCallLogFileConditionInput | null > | null,
  not?: ModelLLMCallLogFileConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMCallLogFile = {
  __typename: "LLMCallLogFile",
  id: string,
  projectId: string,
  fromDate?: string | null,
  toDate?: string | null,
  chunk?: number | null,
  count?: number | null,
  status: string,
  bucket: string,
  key: string,
  url?: string | null,
  urlExpiresAt?: string | null,
  deleteFileAfter?: string | null,
  createdAt: string,
  randomGroup?: number | null,
  updatedAt: string,
};

export type UpdateLLMCallLogFileInput = {
  id: string,
  projectId?: string | null,
  fromDate?: string | null,
  toDate?: string | null,
  chunk?: number | null,
  count?: number | null,
  status?: string | null,
  bucket?: string | null,
  key?: string | null,
  url?: string | null,
  urlExpiresAt?: string | null,
  deleteFileAfter?: string | null,
  createdAt?: string | null,
  randomGroup?: number | null,
};

export type DeleteLLMCallLogFileInput = {
  id: string,
};

export type CreateLLMAgentInput = {
  id?: string | null,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  displayTheme?: string | null,
  cssUrl?: string | null,
  displayTitle?: string | null,
  displayStartMessageOrPrompt?: string | null,
  displayInitialMessageOrPrompt?: string | null,
  displayPromptTemplate?: string | null,
  displayFollowOnPrompts?: string | null,
  displayActions?: string | null,
  displayWidth?: string | null,
  displayHeight?: string | null,
  displayPlaceholder?: string | null,
  displayHideInitialPrompt?: boolean | null,
  displayShowSaveButton?: boolean | null,
  displayShowEmailButton?: boolean | null,
  displayShowCallToAction?: boolean | null,
  displayCallToActionButtonText?: string | null,
  displayCallToActionEmailAddress?: string | null,
  displayCallToActionEmailSubject?: string | null,
  displayCallToActionMustSendEmail?: boolean | null,
  displayScrollToEnd?: boolean | null,
  groupId?: string | null,
  data?: string | null,
  ragQueryLimit?: number | null,
  ragRankLimit?: number | null,
  ragIncludeCitations?: boolean | null,
  ragDoRerank?: boolean | null,
  ragSkipChecksOnContext?: boolean | null,
  ragShadowRead?: boolean | null,
  visibility?: LLMVisibility | null,
  createConversationOnFirstChat?: boolean | null,
  customerEmailCaptureMode?: LLMEmailCaptureMode | null,
  customerEmailCapturePlaceholder?: string | null,
  enableRAG?: boolean | null,
  enableMCP?: boolean | null,
  injectMemories?: number | null,
  injectKnowledgeGraph?: number | null,
  enableWebSearch?: boolean | null,
  linkedFileTypes?: string | null,
  thinkingDepth?: LLMThinkingDepth | null,
  enablePromptCaching?: boolean | null,
  compactionPolicy?: string | null,
  compactionThreshold?: number | null,
  curateToolResults?: boolean | null,
  curateAfterTurns?: number | null,
};

export enum LLMVisibility {
  PUBLIC = "PUBLIC",
  ENTERPRISE = "ENTERPRISE",
  APPLICATION = "APPLICATION",
  ALL = "ALL",
}


export enum LLMEmailCaptureMode {
  HIDE = "HIDE",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}


export enum LLMThinkingDepth {
  OFF = "OFF",
  AUTO = "AUTO",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}


export type ModelLLMAgentConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  displayTheme?: ModelStringInput | null,
  cssUrl?: ModelStringInput | null,
  displayTitle?: ModelStringInput | null,
  displayStartMessageOrPrompt?: ModelStringInput | null,
  displayInitialMessageOrPrompt?: ModelStringInput | null,
  displayPromptTemplate?: ModelStringInput | null,
  displayFollowOnPrompts?: ModelStringInput | null,
  displayActions?: ModelStringInput | null,
  displayWidth?: ModelStringInput | null,
  displayHeight?: ModelStringInput | null,
  displayPlaceholder?: ModelStringInput | null,
  displayHideInitialPrompt?: ModelBooleanInput | null,
  displayShowSaveButton?: ModelBooleanInput | null,
  displayShowEmailButton?: ModelBooleanInput | null,
  displayShowCallToAction?: ModelBooleanInput | null,
  displayCallToActionButtonText?: ModelStringInput | null,
  displayCallToActionEmailAddress?: ModelStringInput | null,
  displayCallToActionEmailSubject?: ModelStringInput | null,
  displayCallToActionMustSendEmail?: ModelBooleanInput | null,
  displayScrollToEnd?: ModelBooleanInput | null,
  groupId?: ModelStringInput | null,
  data?: ModelStringInput | null,
  ragQueryLimit?: ModelIntInput | null,
  ragRankLimit?: ModelIntInput | null,
  ragIncludeCitations?: ModelBooleanInput | null,
  ragDoRerank?: ModelBooleanInput | null,
  ragSkipChecksOnContext?: ModelBooleanInput | null,
  ragShadowRead?: ModelBooleanInput | null,
  visibility?: ModelLLMVisibilityInput | null,
  createConversationOnFirstChat?: ModelBooleanInput | null,
  customerEmailCaptureMode?: ModelLLMEmailCaptureModeInput | null,
  customerEmailCapturePlaceholder?: ModelStringInput | null,
  enableRAG?: ModelBooleanInput | null,
  enableMCP?: ModelBooleanInput | null,
  injectMemories?: ModelIntInput | null,
  injectKnowledgeGraph?: ModelIntInput | null,
  enableWebSearch?: ModelBooleanInput | null,
  linkedFileTypes?: ModelStringInput | null,
  thinkingDepth?: ModelLLMThinkingDepthInput | null,
  enablePromptCaching?: ModelBooleanInput | null,
  compactionPolicy?: ModelStringInput | null,
  compactionThreshold?: ModelIntInput | null,
  curateToolResults?: ModelBooleanInput | null,
  curateAfterTurns?: ModelIntInput | null,
  and?: Array< ModelLLMAgentConditionInput | null > | null,
  or?: Array< ModelLLMAgentConditionInput | null > | null,
  not?: ModelLLMAgentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMVisibilityInput = {
  eq?: LLMVisibility | null,
  ne?: LLMVisibility | null,
};

export type ModelLLMEmailCaptureModeInput = {
  eq?: LLMEmailCaptureMode | null,
  ne?: LLMEmailCaptureMode | null,
};

export type ModelLLMThinkingDepthInput = {
  eq?: LLMThinkingDepth | null,
  ne?: LLMThinkingDepth | null,
};

export type LLMAgent = {
  __typename: "LLMAgent",
  id: string,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  displayTheme?: string | null,
  cssUrl?: string | null,
  displayTitle?: string | null,
  displayStartMessageOrPrompt?: string | null,
  displayInitialMessageOrPrompt?: string | null,
  displayPromptTemplate?: string | null,
  displayFollowOnPrompts?: string | null,
  displayActions?: string | null,
  displayWidth?: string | null,
  displayHeight?: string | null,
  displayPlaceholder?: string | null,
  displayHideInitialPrompt?: boolean | null,
  displayShowSaveButton?: boolean | null,
  displayShowEmailButton?: boolean | null,
  displayShowCallToAction?: boolean | null,
  displayCallToActionButtonText?: string | null,
  displayCallToActionEmailAddress?: string | null,
  displayCallToActionEmailSubject?: string | null,
  displayCallToActionMustSendEmail?: boolean | null,
  displayScrollToEnd?: boolean | null,
  groupId?: string | null,
  data?: string | null,
  calls?: ModelLLMCallConnection | null,
  documents?: ModelLLMAgentDocumentConnection | null,
  mcpServers?: ModelLLMAgentMCPConnection | null,
  ragQueryLimit?: number | null,
  ragRankLimit?: number | null,
  ragIncludeCitations?: boolean | null,
  ragDoRerank?: boolean | null,
  ragSkipChecksOnContext?: boolean | null,
  ragShadowRead?: boolean | null,
  visibility?: LLMVisibility | null,
  createConversationOnFirstChat?: boolean | null,
  customerEmailCaptureMode?: LLMEmailCaptureMode | null,
  customerEmailCapturePlaceholder?: string | null,
  enableRAG?: boolean | null,
  enableMCP?: boolean | null,
  injectMemories?: number | null,
  injectKnowledgeGraph?: number | null,
  enableWebSearch?: boolean | null,
  linkedFileTypes?: string | null,
  thinkingDepth?: LLMThinkingDepth | null,
  enablePromptCaching?: boolean | null,
  compactionPolicy?: string | null,
  compactionThreshold?: number | null,
  curateToolResults?: boolean | null,
  curateAfterTurns?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLLMCallConnection = {
  __typename: "ModelLLMCallConnection",
  items:  Array<LLMCall | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentDocumentConnection = {
  __typename: "ModelLLMAgentDocumentConnection",
  items:  Array<LLMAgentDocument | null >,
  nextToken?: string | null,
};

export type LLMAgentDocument = {
  __typename: "LLMAgentDocument",
  id: string,
  projectId: string,
  agentId: string,
  status: string,
  fileName?: string | null,
  fileSize?: string | null,
  fileType?: string | null,
  uploadDate?: string | null,
  uploader?: string | null,
  lastModifiedDate?: string | null,
  ownershipAttestation?: string | null,
  location?: string | null,
  type?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLLMAgentMCPConnection = {
  __typename: "ModelLLMAgentMCPConnection",
  items:  Array<LLMAgentMCP | null >,
  nextToken?: string | null,
};

export type LLMAgentMCP = {
  __typename: "LLMAgentMCP",
  id: string,
  projectId: string,
  agentId: string,
  status: string,
  approvalMode?: LLMMCPApprovalMode | null,
  executionMode?: LLMMCPExecutionMode | null,
  url?: string | null,
  accessToken?: string | null,
  headers?: string | null,
  stdioCommand?: string | null,
  stdioArgs?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum LLMMCPApprovalMode {
  ALWAYS = "ALWAYS",
  NEVER = "NEVER",
}


export enum LLMMCPExecutionMode {
  CLIENT = "CLIENT",
  SERVER = "SERVER",
}


export type UpdateLLMAgentInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  projectId?: string | null,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  displayTheme?: string | null,
  cssUrl?: string | null,
  displayTitle?: string | null,
  displayStartMessageOrPrompt?: string | null,
  displayInitialMessageOrPrompt?: string | null,
  displayPromptTemplate?: string | null,
  displayFollowOnPrompts?: string | null,
  displayActions?: string | null,
  displayWidth?: string | null,
  displayHeight?: string | null,
  displayPlaceholder?: string | null,
  displayHideInitialPrompt?: boolean | null,
  displayShowSaveButton?: boolean | null,
  displayShowEmailButton?: boolean | null,
  displayShowCallToAction?: boolean | null,
  displayCallToActionButtonText?: string | null,
  displayCallToActionEmailAddress?: string | null,
  displayCallToActionEmailSubject?: string | null,
  displayCallToActionMustSendEmail?: boolean | null,
  displayScrollToEnd?: boolean | null,
  groupId?: string | null,
  data?: string | null,
  ragQueryLimit?: number | null,
  ragRankLimit?: number | null,
  ragIncludeCitations?: boolean | null,
  ragDoRerank?: boolean | null,
  ragSkipChecksOnContext?: boolean | null,
  ragShadowRead?: boolean | null,
  visibility?: LLMVisibility | null,
  createConversationOnFirstChat?: boolean | null,
  customerEmailCaptureMode?: LLMEmailCaptureMode | null,
  customerEmailCapturePlaceholder?: string | null,
  enableRAG?: boolean | null,
  enableMCP?: boolean | null,
  injectMemories?: number | null,
  injectKnowledgeGraph?: number | null,
  enableWebSearch?: boolean | null,
  linkedFileTypes?: string | null,
  thinkingDepth?: LLMThinkingDepth | null,
  enablePromptCaching?: boolean | null,
  compactionPolicy?: string | null,
  compactionThreshold?: number | null,
  curateToolResults?: boolean | null,
  curateAfterTurns?: number | null,
};

export type DeleteLLMAgentInput = {
  id: string,
};

export type CreateLLMAgentMCPInput = {
  id?: string | null,
  projectId: string,
  agentId: string,
  status: string,
  approvalMode?: LLMMCPApprovalMode | null,
  executionMode?: LLMMCPExecutionMode | null,
  url?: string | null,
  accessToken?: string | null,
  headers?: string | null,
  stdioCommand?: string | null,
  stdioArgs?: string | null,
};

export type ModelLLMAgentMCPConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  approvalMode?: ModelLLMMCPApprovalModeInput | null,
  executionMode?: ModelLLMMCPExecutionModeInput | null,
  url?: ModelStringInput | null,
  accessToken?: ModelStringInput | null,
  headers?: ModelStringInput | null,
  stdioCommand?: ModelStringInput | null,
  stdioArgs?: ModelStringInput | null,
  and?: Array< ModelLLMAgentMCPConditionInput | null > | null,
  or?: Array< ModelLLMAgentMCPConditionInput | null > | null,
  not?: ModelLLMAgentMCPConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMMCPApprovalModeInput = {
  eq?: LLMMCPApprovalMode | null,
  ne?: LLMMCPApprovalMode | null,
};

export type ModelLLMMCPExecutionModeInput = {
  eq?: LLMMCPExecutionMode | null,
  ne?: LLMMCPExecutionMode | null,
};

export type UpdateLLMAgentMCPInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  status?: string | null,
  approvalMode?: LLMMCPApprovalMode | null,
  executionMode?: LLMMCPExecutionMode | null,
  url?: string | null,
  accessToken?: string | null,
  headers?: string | null,
  stdioCommand?: string | null,
  stdioArgs?: string | null,
};

export type DeleteLLMAgentMCPInput = {
  id: string,
};

export type CreateLLMAgentDocumentInput = {
  id?: string | null,
  projectId: string,
  agentId: string,
  status: string,
  fileName?: string | null,
  fileSize?: string | null,
  fileType?: string | null,
  uploadDate?: string | null,
  uploader?: string | null,
  lastModifiedDate?: string | null,
  ownershipAttestation?: string | null,
  location?: string | null,
  type?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
};

export type ModelLLMAgentDocumentConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileSize?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  uploadDate?: ModelStringInput | null,
  uploader?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  ownershipAttestation?: ModelStringInput | null,
  location?: ModelStringInput | null,
  type?: ModelStringInput | null,
  ragSplitter?: ModelStringInput | null,
  ragChunkSize?: ModelIntInput | null,
  ragChunkOverlap?: ModelIntInput | null,
  and?: Array< ModelLLMAgentDocumentConditionInput | null > | null,
  or?: Array< ModelLLMAgentDocumentConditionInput | null > | null,
  not?: ModelLLMAgentDocumentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMAgentDocumentInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  status?: string | null,
  fileName?: string | null,
  fileSize?: string | null,
  fileType?: string | null,
  uploadDate?: string | null,
  uploader?: string | null,
  lastModifiedDate?: string | null,
  ownershipAttestation?: string | null,
  location?: string | null,
  type?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
};

export type DeleteLLMAgentDocumentInput = {
  id: string,
};

export type CreateLLMOpenAIAgentDocumentInput = {
  id?: string | null,
  projectId: string,
  projectBackend: string,
  documentId: string,
  agentId?: string | null,
  backend: string,
  status: string,
  vectorStoreId?: string | null,
  openaiFileIds?: Array< string | null > | null,
  sourceType?: string | null,
  sourceLocation?: string | null,
  fileName?: string | null,
  fileType?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
  chunkCount?: number | null,
  providerVersion?: string | null,
  lastError?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  readyAt?: string | null,
  deletedAt?: string | null,
};

export type ModelLLMOpenAIAgentDocumentConditionInput = {
  projectId?: ModelIDInput | null,
  projectBackend?: ModelStringInput | null,
  documentId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  backend?: ModelStringInput | null,
  status?: ModelStringInput | null,
  vectorStoreId?: ModelStringInput | null,
  openaiFileIds?: ModelStringInput | null,
  sourceType?: ModelStringInput | null,
  sourceLocation?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  ragSplitter?: ModelStringInput | null,
  ragChunkSize?: ModelIntInput | null,
  ragChunkOverlap?: ModelIntInput | null,
  chunkCount?: ModelIntInput | null,
  providerVersion?: ModelStringInput | null,
  lastError?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  readyAt?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  and?: Array< ModelLLMOpenAIAgentDocumentConditionInput | null > | null,
  or?: Array< ModelLLMOpenAIAgentDocumentConditionInput | null > | null,
  not?: ModelLLMOpenAIAgentDocumentConditionInput | null,
};

export type LLMOpenAIAgentDocument = {
  __typename: "LLMOpenAIAgentDocument",
  id: string,
  projectId: string,
  projectBackend: string,
  documentId: string,
  agentId?: string | null,
  backend: string,
  status: string,
  vectorStoreId?: string | null,
  openaiFileIds?: Array< string | null > | null,
  sourceType?: string | null,
  sourceLocation?: string | null,
  fileName?: string | null,
  fileType?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
  chunkCount?: number | null,
  providerVersion?: string | null,
  lastError?: string | null,
  createdAt: string,
  updatedAt: string,
  readyAt?: string | null,
  deletedAt?: string | null,
};

export type UpdateLLMOpenAIAgentDocumentInput = {
  id: string,
  projectId?: string | null,
  projectBackend?: string | null,
  documentId?: string | null,
  agentId?: string | null,
  backend?: string | null,
  status?: string | null,
  vectorStoreId?: string | null,
  openaiFileIds?: Array< string | null > | null,
  sourceType?: string | null,
  sourceLocation?: string | null,
  fileName?: string | null,
  fileType?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
  chunkCount?: number | null,
  providerVersion?: string | null,
  lastError?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  readyAt?: string | null,
  deletedAt?: string | null,
};

export type DeleteLLMOpenAIAgentDocumentInput = {
  id: string,
};

export type CreateLLMConversationInput = {
  id?: string | null,
  projectId: string,
  agentId?: string | null,
  customerId?: string | null,
  createdAt?: string | null,
  status: string,
  title: string,
  summary?: string | null,
  timezone?: string | null,
  language?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  emailAddress?: string | null,
  thumbsupClicked?: number | null,
  thumbsdownClicked?: number | null,
  copyClicked?: number | null,
  emailClicked?: number | null,
  saveClicked?: number | null,
  ctaClicked?: number | null,
  suggestionClicked?: number | null,
  actionClicked?: number | null,
  intelligence?: string | null,
  endedAt?: string | null,
};

export type ModelLLMConversationConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  status?: ModelStringInput | null,
  title?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  language?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  emailAddress?: ModelStringInput | null,
  thumbsupClicked?: ModelIntInput | null,
  thumbsdownClicked?: ModelIntInput | null,
  copyClicked?: ModelIntInput | null,
  emailClicked?: ModelIntInput | null,
  saveClicked?: ModelIntInput | null,
  ctaClicked?: ModelIntInput | null,
  suggestionClicked?: ModelIntInput | null,
  actionClicked?: ModelIntInput | null,
  intelligence?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  and?: Array< ModelLLMConversationConditionInput | null > | null,
  or?: Array< ModelLLMConversationConditionInput | null > | null,
  not?: ModelLLMConversationConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMConversation = {
  __typename: "LLMConversation",
  id: string,
  projectId: string,
  agentId?: string | null,
  agent?: LLMAgent | null,
  customerId?: string | null,
  customer?: LLMCustomer | null,
  createdAt: string,
  status: string,
  title: string,
  summary?: string | null,
  timezone?: string | null,
  language?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  calls?: ModelLLMCallConnection | null,
  emailAddress?: string | null,
  thumbsupClicked?: number | null,
  thumbsdownClicked?: number | null,
  copyClicked?: number | null,
  emailClicked?: number | null,
  saveClicked?: number | null,
  ctaClicked?: number | null,
  suggestionClicked?: number | null,
  actionClicked?: number | null,
  intelligence?: string | null,
  endedAt?: string | null,
  updatedAt: string,
};

export type UpdateLLMConversationInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  customerId?: string | null,
  createdAt?: string | null,
  status?: string | null,
  title?: string | null,
  summary?: string | null,
  timezone?: string | null,
  language?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  emailAddress?: string | null,
  thumbsupClicked?: number | null,
  thumbsdownClicked?: number | null,
  copyClicked?: number | null,
  emailClicked?: number | null,
  saveClicked?: number | null,
  ctaClicked?: number | null,
  suggestionClicked?: number | null,
  actionClicked?: number | null,
  intelligence?: string | null,
  endedAt?: string | null,
};

export type DeleteLLMConversationInput = {
  id: string,
};

export type CreateLLMModelInput = {
  id?: string | null,
  status: string,
  vendor: string,
  host: string,
  supported: boolean,
  name: string,
  description?: string | null,
  modelKey?: string | null,
  modelKeyLatest?: string | null,
  inputTokenPrice?: number | null,
  cachedTokenPrice?: number | null,
  outputTokenPrice?: number | null,
  inputTokenBatchPrice?: number | null,
  outputTokenBatchPrice?: number | null,
  searchCost?: number | null,
  supportsSearch?: boolean | null,
  textInputSupport?: boolean | null,
  imageInputSupport?: boolean | null,
  audioInputSupport?: boolean | null,
  textOutputSupport?: boolean | null,
  imageOutputSupport?: boolean | null,
  audioOutputSupport?: boolean | null,
  thinkingSupport?: boolean | null,
  contextWindowTokens?: number | null,
  maxResponseTokens?: number | null,
  knowledgeCutoffDate?: string | null,
  lastCheckedDate?: string | null,
  supportedLanguages?: string | null,
  warningDate?: string | null,
  warningMessage?: string | null,
  deprecationDate?: string | null,
  deprecationMessage?: string | null,
  defaultServiceGroup?: string | null,
  defaultEnabled?: boolean | null,
  displayOrder?: number | null,
  recommendedUseCase?: string | null,
  performanceRating?: string | null,
};

export type ModelLLMModelConditionInput = {
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  host?: ModelStringInput | null,
  supported?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  modelKey?: ModelStringInput | null,
  modelKeyLatest?: ModelStringInput | null,
  inputTokenPrice?: ModelFloatInput | null,
  cachedTokenPrice?: ModelFloatInput | null,
  outputTokenPrice?: ModelFloatInput | null,
  inputTokenBatchPrice?: ModelFloatInput | null,
  outputTokenBatchPrice?: ModelFloatInput | null,
  searchCost?: ModelFloatInput | null,
  supportsSearch?: ModelBooleanInput | null,
  textInputSupport?: ModelBooleanInput | null,
  imageInputSupport?: ModelBooleanInput | null,
  audioInputSupport?: ModelBooleanInput | null,
  textOutputSupport?: ModelBooleanInput | null,
  imageOutputSupport?: ModelBooleanInput | null,
  audioOutputSupport?: ModelBooleanInput | null,
  thinkingSupport?: ModelBooleanInput | null,
  contextWindowTokens?: ModelIntInput | null,
  maxResponseTokens?: ModelIntInput | null,
  knowledgeCutoffDate?: ModelStringInput | null,
  lastCheckedDate?: ModelStringInput | null,
  supportedLanguages?: ModelStringInput | null,
  warningDate?: ModelStringInput | null,
  warningMessage?: ModelStringInput | null,
  deprecationDate?: ModelStringInput | null,
  deprecationMessage?: ModelStringInput | null,
  defaultServiceGroup?: ModelStringInput | null,
  defaultEnabled?: ModelBooleanInput | null,
  displayOrder?: ModelIntInput | null,
  recommendedUseCase?: ModelStringInput | null,
  performanceRating?: ModelStringInput | null,
  and?: Array< ModelLLMModelConditionInput | null > | null,
  or?: Array< ModelLLMModelConditionInput | null > | null,
  not?: ModelLLMModelConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMModelInput = {
  id: string,
  status?: string | null,
  vendor?: string | null,
  host?: string | null,
  supported?: boolean | null,
  name?: string | null,
  description?: string | null,
  modelKey?: string | null,
  modelKeyLatest?: string | null,
  inputTokenPrice?: number | null,
  cachedTokenPrice?: number | null,
  outputTokenPrice?: number | null,
  inputTokenBatchPrice?: number | null,
  outputTokenBatchPrice?: number | null,
  searchCost?: number | null,
  supportsSearch?: boolean | null,
  textInputSupport?: boolean | null,
  imageInputSupport?: boolean | null,
  audioInputSupport?: boolean | null,
  textOutputSupport?: boolean | null,
  imageOutputSupport?: boolean | null,
  audioOutputSupport?: boolean | null,
  thinkingSupport?: boolean | null,
  contextWindowTokens?: number | null,
  maxResponseTokens?: number | null,
  knowledgeCutoffDate?: string | null,
  lastCheckedDate?: string | null,
  supportedLanguages?: string | null,
  warningDate?: string | null,
  warningMessage?: string | null,
  deprecationDate?: string | null,
  deprecationMessage?: string | null,
  defaultServiceGroup?: string | null,
  defaultEnabled?: boolean | null,
  displayOrder?: number | null,
  recommendedUseCase?: string | null,
  performanceRating?: string | null,
};

export type DeleteLLMModelInput = {
  id: string,
};

export type CreateLLMProviderInput = {
  id?: string | null,
  displayName: string,
  contactUrl?: string | null,
  description?: string | null,
  defaultIsModerated?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelLLMProviderConditionInput = {
  displayName?: ModelStringInput | null,
  contactUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  defaultIsModerated?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMProviderConditionInput | null > | null,
  or?: Array< ModelLLMProviderConditionInput | null > | null,
  not?: ModelLLMProviderConditionInput | null,
};

export type LLMProvider = {
  __typename: "LLMProvider",
  id: string,
  displayName: string,
  contactUrl?: string | null,
  description?: string | null,
  defaultIsModerated?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateLLMProviderInput = {
  id: string,
  displayName?: string | null,
  contactUrl?: string | null,
  description?: string | null,
  defaultIsModerated?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLLMProviderInput = {
  id: string,
};

export type CreateLLMOpenRouterModelInput = {
  id?: string | null,
  providerId: string,
  canonicalSlug?: string | null,
  name: string,
  description?: string | null,
  tokenizer?: string | null,
  instructType?: string | null,
  contextLength?: number | null,
  maxCompletionTokens?: number | null,
  isModerated?: boolean | null,
  architectureModality?: string | null,
  architectureInputModalities?: string | null,
  architectureOutputModalities?: string | null,
  supportedParameters?: string | null,
  defaultParameters?: string | null,
  huggingFaceId?: string | null,
  latestPricingSnapshotId?: string | null,
  isDeprecated?: boolean | null,
  deprecatedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelLLMOpenRouterModelConditionInput = {
  providerId?: ModelIDInput | null,
  canonicalSlug?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  tokenizer?: ModelStringInput | null,
  instructType?: ModelStringInput | null,
  contextLength?: ModelIntInput | null,
  maxCompletionTokens?: ModelIntInput | null,
  isModerated?: ModelBooleanInput | null,
  architectureModality?: ModelStringInput | null,
  architectureInputModalities?: ModelStringInput | null,
  architectureOutputModalities?: ModelStringInput | null,
  supportedParameters?: ModelStringInput | null,
  defaultParameters?: ModelStringInput | null,
  huggingFaceId?: ModelStringInput | null,
  latestPricingSnapshotId?: ModelIDInput | null,
  isDeprecated?: ModelBooleanInput | null,
  deprecatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMOpenRouterModelConditionInput | null > | null,
  or?: Array< ModelLLMOpenRouterModelConditionInput | null > | null,
  not?: ModelLLMOpenRouterModelConditionInput | null,
};

export type LLMOpenRouterModel = {
  __typename: "LLMOpenRouterModel",
  id: string,
  providerId: string,
  provider?: LLMProvider | null,
  canonicalSlug?: string | null,
  name: string,
  description?: string | null,
  tokenizer?: string | null,
  instructType?: string | null,
  contextLength?: number | null,
  maxCompletionTokens?: number | null,
  isModerated?: boolean | null,
  architectureModality?: string | null,
  architectureInputModalities?: string | null,
  architectureOutputModalities?: string | null,
  supportedParameters?: string | null,
  defaultParameters?: string | null,
  huggingFaceId?: string | null,
  latestPricingSnapshotId?: string | null,
  isDeprecated?: boolean | null,
  deprecatedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateLLMOpenRouterModelInput = {
  id: string,
  providerId?: string | null,
  canonicalSlug?: string | null,
  name?: string | null,
  description?: string | null,
  tokenizer?: string | null,
  instructType?: string | null,
  contextLength?: number | null,
  maxCompletionTokens?: number | null,
  isModerated?: boolean | null,
  architectureModality?: string | null,
  architectureInputModalities?: string | null,
  architectureOutputModalities?: string | null,
  supportedParameters?: string | null,
  defaultParameters?: string | null,
  huggingFaceId?: string | null,
  latestPricingSnapshotId?: string | null,
  isDeprecated?: boolean | null,
  deprecatedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLLMOpenRouterModelInput = {
  id: string,
};

export type CreateLLMModelPricingSnapshotInput = {
  id?: string | null,
  modelId: string,
  source: LLMModelPricingSource,
  fetchedAt: string,
  currency: string,
  promptTokenUsdNano?: string | null,
  completionTokenUsdNano?: string | null,
  cacheReadTokenUsdNano?: string | null,
  cacheWriteTokenUsdNano?: string | null,
  reasoningTokenUsdNano?: string | null,
  webSearchUsdNano?: string | null,
  requestUsdNano?: string | null,
  imageUsdNano?: string | null,
  audioUsdNano?: string | null,
  internalNotes?: string | null,
  isCurrent?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum LLMModelPricingSource {
  OPENROUTER = "OPENROUTER",
}


export type ModelLLMModelPricingSnapshotConditionInput = {
  modelId?: ModelIDInput | null,
  source?: ModelLLMModelPricingSourceInput | null,
  fetchedAt?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  promptTokenUsdNano?: ModelStringInput | null,
  completionTokenUsdNano?: ModelStringInput | null,
  cacheReadTokenUsdNano?: ModelStringInput | null,
  cacheWriteTokenUsdNano?: ModelStringInput | null,
  reasoningTokenUsdNano?: ModelStringInput | null,
  webSearchUsdNano?: ModelStringInput | null,
  requestUsdNano?: ModelStringInput | null,
  imageUsdNano?: ModelStringInput | null,
  audioUsdNano?: ModelStringInput | null,
  internalNotes?: ModelStringInput | null,
  isCurrent?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMModelPricingSnapshotConditionInput | null > | null,
  or?: Array< ModelLLMModelPricingSnapshotConditionInput | null > | null,
  not?: ModelLLMModelPricingSnapshotConditionInput | null,
};

export type ModelLLMModelPricingSourceInput = {
  eq?: LLMModelPricingSource | null,
  ne?: LLMModelPricingSource | null,
};

export type LLMModelPricingSnapshot = {
  __typename: "LLMModelPricingSnapshot",
  id: string,
  modelId: string,
  model?: LLMOpenRouterModel | null,
  source: LLMModelPricingSource,
  fetchedAt: string,
  currency: string,
  promptTokenUsdNano?: string | null,
  completionTokenUsdNano?: string | null,
  cacheReadTokenUsdNano?: string | null,
  cacheWriteTokenUsdNano?: string | null,
  reasoningTokenUsdNano?: string | null,
  webSearchUsdNano?: string | null,
  requestUsdNano?: string | null,
  imageUsdNano?: string | null,
  audioUsdNano?: string | null,
  internalNotes?: string | null,
  isCurrent?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateLLMModelPricingSnapshotInput = {
  id: string,
  modelId?: string | null,
  source?: LLMModelPricingSource | null,
  fetchedAt?: string | null,
  currency?: string | null,
  promptTokenUsdNano?: string | null,
  completionTokenUsdNano?: string | null,
  cacheReadTokenUsdNano?: string | null,
  cacheWriteTokenUsdNano?: string | null,
  reasoningTokenUsdNano?: string | null,
  webSearchUsdNano?: string | null,
  requestUsdNano?: string | null,
  imageUsdNano?: string | null,
  audioUsdNano?: string | null,
  internalNotes?: string | null,
  isCurrent?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLLMModelPricingSnapshotInput = {
  id: string,
};

export type CreateLLMModelCapabilityInput = {
  id?: string | null,
  modelId: string,
  category: string,
  value: string,
  metadata?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelLLMModelCapabilityConditionInput = {
  modelId?: ModelIDInput | null,
  category?: ModelStringInput | null,
  value?: ModelStringInput | null,
  metadata?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMModelCapabilityConditionInput | null > | null,
  or?: Array< ModelLLMModelCapabilityConditionInput | null > | null,
  not?: ModelLLMModelCapabilityConditionInput | null,
};

export type LLMModelCapability = {
  __typename: "LLMModelCapability",
  id: string,
  modelId: string,
  model?: LLMOpenRouterModel | null,
  category: string,
  value: string,
  metadata?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateLLMModelCapabilityInput = {
  id: string,
  modelId?: string | null,
  category?: string | null,
  value?: string | null,
  metadata?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteLLMModelCapabilityInput = {
  id: string,
};

export type CreateLLMScheduledPromptInput = {
  id?: string | null,
  projectId: string,
  status: LLMScheduledPromptStatus,
  agentId: string,
  title?: string | null,
  data?: string | null,
  prompt: string,
  scheduledAt: string,
  priorScheduledPromptId?: string | null,
  nextScheduledPromptId?: string | null,
  processedAt?: string | null,
  response?: string | null,
  failedTimes?: number | null,
  errorMessage?: string | null,
  notificationEmailAddresses?: string | null,
  notificationEmailSubject?: string | null,
  repeatIntervalHours?: number | null,
  followOnAgentId?: string | null,
  followOnFollowOnAgentId?: string | null,
  followOnTitle?: string | null,
  followOnPrompt?: string | null,
  followOnScheduledAtHours?: number | null,
  followOnNotificationEmailAddresses?: string | null,
  followOnNotificationEmailSubject?: string | null,
  followOnRepeatIntervalHours?: number | null,
};

export enum LLMScheduledPromptStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  TEMPLATE = "TEMPLATE",
}


export type ModelLLMScheduledPromptConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelLLMScheduledPromptStatusInput | null,
  agentId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  data?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  scheduledAt?: ModelStringInput | null,
  priorScheduledPromptId?: ModelIDInput | null,
  nextScheduledPromptId?: ModelIDInput | null,
  processedAt?: ModelStringInput | null,
  response?: ModelStringInput | null,
  failedTimes?: ModelIntInput | null,
  errorMessage?: ModelStringInput | null,
  notificationEmailAddresses?: ModelStringInput | null,
  notificationEmailSubject?: ModelStringInput | null,
  repeatIntervalHours?: ModelIntInput | null,
  followOnAgentId?: ModelIDInput | null,
  followOnFollowOnAgentId?: ModelIDInput | null,
  followOnTitle?: ModelStringInput | null,
  followOnPrompt?: ModelStringInput | null,
  followOnScheduledAtHours?: ModelIntInput | null,
  followOnNotificationEmailAddresses?: ModelStringInput | null,
  followOnNotificationEmailSubject?: ModelStringInput | null,
  followOnRepeatIntervalHours?: ModelIntInput | null,
  and?: Array< ModelLLMScheduledPromptConditionInput | null > | null,
  or?: Array< ModelLLMScheduledPromptConditionInput | null > | null,
  not?: ModelLLMScheduledPromptConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMScheduledPromptStatusInput = {
  eq?: LLMScheduledPromptStatus | null,
  ne?: LLMScheduledPromptStatus | null,
};

export type LLMScheduledPrompt = {
  __typename: "LLMScheduledPrompt",
  id: string,
  projectId: string,
  status: LLMScheduledPromptStatus,
  agentId: string,
  agent?: LLMAgent | null,
  title?: string | null,
  data?: string | null,
  prompt: string,
  scheduledAt: string,
  priorScheduledPromptId?: string | null,
  nextScheduledPromptId?: string | null,
  processedAt?: string | null,
  response?: string | null,
  failedTimes?: number | null,
  errorMessage?: string | null,
  notificationEmailAddresses?: string | null,
  notificationEmailSubject?: string | null,
  repeatIntervalHours?: number | null,
  followOnAgentId?: string | null,
  followOnFollowOnAgentId?: string | null,
  followOnTitle?: string | null,
  followOnPrompt?: string | null,
  followOnScheduledAtHours?: number | null,
  followOnNotificationEmailAddresses?: string | null,
  followOnNotificationEmailSubject?: string | null,
  followOnRepeatIntervalHours?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMScheduledPromptInput = {
  id: string,
  projectId?: string | null,
  status?: LLMScheduledPromptStatus | null,
  agentId?: string | null,
  title?: string | null,
  data?: string | null,
  prompt?: string | null,
  scheduledAt?: string | null,
  priorScheduledPromptId?: string | null,
  nextScheduledPromptId?: string | null,
  processedAt?: string | null,
  response?: string | null,
  failedTimes?: number | null,
  errorMessage?: string | null,
  notificationEmailAddresses?: string | null,
  notificationEmailSubject?: string | null,
  repeatIntervalHours?: number | null,
  followOnAgentId?: string | null,
  followOnFollowOnAgentId?: string | null,
  followOnTitle?: string | null,
  followOnPrompt?: string | null,
  followOnScheduledAtHours?: number | null,
  followOnNotificationEmailAddresses?: string | null,
  followOnNotificationEmailSubject?: string | null,
  followOnRepeatIntervalHours?: number | null,
};

export type DeleteLLMScheduledPromptInput = {
  id: string,
};

export type CreateLLMTriggerInput = {
  id?: string | null,
  projectId: string,
  status: LLMTriggerStatus,
  triggerType: string,
  scheduledPromptId?: string | null,
};

export enum LLMTriggerStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}


export type ModelLLMTriggerConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelLLMTriggerStatusInput | null,
  triggerType?: ModelStringInput | null,
  scheduledPromptId?: ModelIDInput | null,
  and?: Array< ModelLLMTriggerConditionInput | null > | null,
  or?: Array< ModelLLMTriggerConditionInput | null > | null,
  not?: ModelLLMTriggerConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMTriggerStatusInput = {
  eq?: LLMTriggerStatus | null,
  ne?: LLMTriggerStatus | null,
};

export type LLMTrigger = {
  __typename: "LLMTrigger",
  id: string,
  projectId: string,
  status: LLMTriggerStatus,
  triggerType: string,
  scheduledPromptId?: string | null,
  scheduledPrompt?: LLMScheduledPrompt | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMTriggerInput = {
  id: string,
  projectId?: string | null,
  status?: LLMTriggerStatus | null,
  triggerType?: string | null,
  scheduledPromptId?: string | null,
};

export type DeleteLLMTriggerInput = {
  id: string,
};

export type CreateLLMMemoryInput = {
  id?: string | null,
  projectId: string,
  status: string,
  entityType: LLMMemoryEntityType,
  customerId?: string | null,
  agentId?: string | null,
  key: string,
  data: string,
  tags?: Array< string | null > | null,
  memoryType: LLMMemoryType,
  createdAt?: string | null,
};

export enum LLMMemoryEntityType {
  CUSTOMER = "CUSTOMER",
  PROJECT = "PROJECT",
  AGENT = "AGENT",
}


export enum LLMMemoryType {
  PREFERENCE = "PREFERENCE",
  FACT = "FACT",
  CONTEXT = "CONTEXT",
  INSTRUCTION = "INSTRUCTION",
  FEEDBACK = "FEEDBACK",
  OTHER = "OTHER",
}


export type ModelLLMMemoryConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  entityType?: ModelLLMMemoryEntityTypeInput | null,
  customerId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  key?: ModelStringInput | null,
  data?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  memoryType?: ModelLLMMemoryTypeInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLLMMemoryConditionInput | null > | null,
  or?: Array< ModelLLMMemoryConditionInput | null > | null,
  not?: ModelLLMMemoryConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMMemoryEntityTypeInput = {
  eq?: LLMMemoryEntityType | null,
  ne?: LLMMemoryEntityType | null,
};

export type ModelLLMMemoryTypeInput = {
  eq?: LLMMemoryType | null,
  ne?: LLMMemoryType | null,
};

export type LLMMemory = {
  __typename: "LLMMemory",
  id: string,
  projectId: string,
  status: string,
  entityType: LLMMemoryEntityType,
  customerId?: string | null,
  agentId?: string | null,
  customer?: LLMCustomer | null,
  key: string,
  data: string,
  tags?: Array< string | null > | null,
  memoryType: LLMMemoryType,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMMemoryInput = {
  id: string,
  projectId?: string | null,
  status?: string | null,
  entityType?: LLMMemoryEntityType | null,
  customerId?: string | null,
  agentId?: string | null,
  key?: string | null,
  data?: string | null,
  tags?: Array< string | null > | null,
  memoryType?: LLMMemoryType | null,
  createdAt?: string | null,
};

export type DeleteLLMMemoryInput = {
  id: string,
};

export type CreateLLMKnowledgeGraphInput = {
  id?: string | null,
  projectId: string,
  customerId: string,
  status: LLMKnowledgeGraphStatus,
  version: number,
  title?: string | null,
  description?: string | null,
  graphData: string,
  memoryCount?: number | null,
  generatedFromMemoryIds?: Array< string | null > | null,
  createdAt?: string | null,
};

export enum LLMKnowledgeGraphStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}


export type ModelLLMKnowledgeGraphConditionInput = {
  projectId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  status?: ModelLLMKnowledgeGraphStatusInput | null,
  version?: ModelIntInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  graphData?: ModelStringInput | null,
  memoryCount?: ModelIntInput | null,
  generatedFromMemoryIds?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLLMKnowledgeGraphConditionInput | null > | null,
  or?: Array< ModelLLMKnowledgeGraphConditionInput | null > | null,
  not?: ModelLLMKnowledgeGraphConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMKnowledgeGraphStatusInput = {
  eq?: LLMKnowledgeGraphStatus | null,
  ne?: LLMKnowledgeGraphStatus | null,
};

export type LLMKnowledgeGraph = {
  __typename: "LLMKnowledgeGraph",
  id: string,
  projectId: string,
  customerId: string,
  customer?: LLMCustomer | null,
  status: LLMKnowledgeGraphStatus,
  version: number,
  title?: string | null,
  description?: string | null,
  graphData: string,
  memoryCount?: number | null,
  generatedFromMemoryIds?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMKnowledgeGraphInput = {
  id: string,
  projectId?: string | null,
  customerId?: string | null,
  status?: LLMKnowledgeGraphStatus | null,
  version?: number | null,
  title?: string | null,
  description?: string | null,
  graphData?: string | null,
  memoryCount?: number | null,
  generatedFromMemoryIds?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteLLMKnowledgeGraphInput = {
  id: string,
};

export type CreateLLMAgentValidationInput = {
  id?: string | null,
  projectId: string,
  agentId: string,
  name?: string | null,
  description?: string | null,
  operator: ValidationOperator,
  expectedValue?: string | null,
  customPromptTemplate?: string | null,
  status: string,
  createdAt?: string | null,
};

export enum ValidationOperator {
  SHOULD_CONTAIN = "SHOULD_CONTAIN",
  SHOULD_NOT_CONTAIN = "SHOULD_NOT_CONTAIN",
  SHOULD_RUN_TOOL = "SHOULD_RUN_TOOL",
  SHOULD_NOT_RUN_TOOL = "SHOULD_NOT_RUN_TOOL",
  CUSTOM_LLM_JUDGE = "CUSTOM_LLM_JUDGE",
}


export type ModelLLMAgentValidationConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  operator?: ModelValidationOperatorInput | null,
  expectedValue?: ModelStringInput | null,
  customPromptTemplate?: ModelStringInput | null,
  status?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentValidationConditionInput | null > | null,
  or?: Array< ModelLLMAgentValidationConditionInput | null > | null,
  not?: ModelLLMAgentValidationConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelValidationOperatorInput = {
  eq?: ValidationOperator | null,
  ne?: ValidationOperator | null,
};

export type LLMAgentValidation = {
  __typename: "LLMAgentValidation",
  id: string,
  projectId: string,
  agentId: string,
  name?: string | null,
  description?: string | null,
  operator: ValidationOperator,
  expectedValue?: string | null,
  customPromptTemplate?: string | null,
  status: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMAgentValidationInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  name?: string | null,
  description?: string | null,
  operator?: ValidationOperator | null,
  expectedValue?: string | null,
  customPromptTemplate?: string | null,
  status?: string | null,
  createdAt?: string | null,
};

export type DeleteLLMAgentValidationInput = {
  id: string,
};

export type ModelLLMProjectFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  description?: ModelStringInput | null,
  stripeCustomerId?: ModelIDInput | null,
  newCustomerTokenCount?: ModelIntInput | null,
  cacheResponsesForSeconds?: ModelIntInput | null,
  loadSheddingTier?: ModelIntInput | null,
  newCustomerLoadSheddingTier?: ModelIntInput | null,
  maintenanceMode?: ModelBooleanInput | null,
  maintenanceModeMessage?: ModelStringInput | null,
  loadBalancingMode?: ModelStringInput | null,
  piiRedactionScope?: ModelStringInput | null,
  systemInstructions?: ModelStringInput | null,
  piiScope?: ModelStringInput | null,
  piiGroupId?: ModelStringInput | null,
  piiMessage?: ModelStringInput | null,
  promptBlacklist?: ModelStringInput | null,
  blacklistGroupId?: ModelStringInput | null,
  blacklistMessage?: ModelStringInput | null,
  safety?: ModelFloatInput | null,
  safetyGroupId?: ModelStringInput | null,
  safetyMessage?: ModelStringInput | null,
  strongModelGroupId?: ModelStringInput | null,
  routeModel?: ModelStringInput | null,
  trialTokensRemaining?: ModelIntInput | null,
  logfileRetentionPeriod?: ModelIntInput | null,
  callRetentionPeriod?: ModelIntInput | null,
  logInterval?: ModelStringInput | null,
  lastLogGeneratedAt?: ModelStringInput | null,
  logGenerationCursor?: ModelStringInput | null,
  enterpriseAllowChat?: ModelBooleanInput | null,
  enterpriseAcceptableUsePolicy?: ModelStringInput | null,
  enterpriseAccessRequestEmail?: ModelStringInput | null,
  enterpriseSupportEmail?: ModelStringInput | null,
  enterpriseDomainWhitelist?: ModelStringInput | null,
  enterpriseTokenBudget?: ModelIntInput | null,
  enterpriseTokenBudgetPeriod?: ModelStringInput | null,
  enterpriseImageUrl?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  apiCreditRemaining?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  summaryEmailPeriod?: ModelIntInput | null,
  summaryEmailAddresses?: ModelStringInput | null,
  lastSummaryEmailSentAt?: ModelStringInput | null,
  mcpServerWhitelist?: ModelStringInput | null,
  automaticModelManagement?: ModelBooleanInput | null,
  supersmallGroupModels?: ModelStringInput | null,
  standardGroupModels?: ModelStringInput | null,
  premiumGroupModels?: ModelStringInput | null,
  reasoningGroupModels?: ModelStringInput | null,
  superpremiumGroupModels?: ModelStringInput | null,
  openrouterStandardGroupModels?: ModelStringInput | null,
  openrouterPremiumGroupModels?: ModelStringInput | null,
  azureOpenaiBaseUrl?: ModelStringInput | null,
  azureOpenaiApiVersion?: ModelStringInput | null,
  awsBedrockRegion?: ModelStringInput | null,
  newCustomerUsageTierId?: ModelIDInput | null,
  usageTapUsageApiKey?: ModelStringInput | null,
  lowApiCreditNotificationEmails?: ModelStringInput | null,
  lowApiCreditNotificationMinimumCredit?: ModelFloatInput | null,
  lastLowApiCreditNotificationSentAt?: ModelStringInput | null,
  integrationApiKey1Hash?: ModelStringInput | null,
  integrationApiKey1Status?: ModelStringInput | null,
  integrationApiKey1Prefix?: ModelStringInput | null,
  integrationApiKey1LastRotatedAt?: ModelStringInput | null,
  integrationApiKey1Scopes?: ModelStringInput | null,
  integrationApiKey2Hash?: ModelStringInput | null,
  integrationApiKey2Status?: ModelStringInput | null,
  integrationApiKey2Prefix?: ModelStringInput | null,
  integrationApiKey2LastRotatedAt?: ModelStringInput | null,
  integrationApiKey2Scopes?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMProjectFilterInput | null > | null,
  or?: Array< ModelLLMProjectFilterInput | null > | null,
  not?: ModelLLMProjectFilterInput | null,
};

export type ModelLLMProjectConnection = {
  __typename: "ModelLLMProjectConnection",
  items:  Array<LLMProject | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelLLMUsageTierFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelLLMUsageTierStatusInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  version?: ModelIntInput | null,
  activeAt?: ModelStringInput | null,
  inactiveAt?: ModelStringInput | null,
  priorUsageTierId?: ModelIDInput | null,
  baseUsageTierId?: ModelIDInput | null,
  replenishmentPeriod?: ModelLLMPeriodInput | null,
  replenishmentMethod?: ModelLLMReplenishmentMethodInput | null,
  usageLimitAction?: ModelLLMUsageLimitActionInput | null,
  standardTokenReplenishmentAmount?: ModelIntInput | null,
  premiumTokenReplenishmentAmount?: ModelIntInput | null,
  superPremiumTokenReplenishmentAmount?: ModelIntInput | null,
  reasoningTokenReplenishmentAmount?: ModelIntInput | null,
  standardCallReplenishmentAmount?: ModelIntInput | null,
  premiumCallReplenishmentAmount?: ModelIntInput | null,
  superPremiumCallReplenishmentAmount?: ModelIntInput | null,
  reasoningCallReplenishmentAmount?: ModelIntInput | null,
  standardTokenUnlimited?: ModelBooleanInput | null,
  premiumTokenUnlimited?: ModelBooleanInput | null,
  superPremiumTokenUnlimited?: ModelBooleanInput | null,
  reasoningTokenUnlimited?: ModelBooleanInput | null,
  standardCallUnlimited?: ModelBooleanInput | null,
  premiumCallUnlimited?: ModelBooleanInput | null,
  superPremiumCallUnlimited?: ModelBooleanInput | null,
  reasoningCallUnlimited?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMUsageTierFilterInput | null > | null,
  or?: Array< ModelLLMUsageTierFilterInput | null > | null,
  not?: ModelLLMUsageTierFilterInput | null,
};

export type ModelLLMUsageTierConnection = {
  __typename: "ModelLLMUsageTierConnection",
  items:  Array<LLMUsageTier | null >,
  nextToken?: string | null,
};

export type ModelLLMProjectSubscriptionFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  quantity?: ModelIntInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionStartDate?: ModelStringInput | null,
  subscriptionEndDate?: ModelStringInput | null,
  subscriptionStatus?: ModelStringInput | null,
  subscriptionProduct?: ModelStringInput | null,
  subscriptionInterval?: ModelStringInput | null,
  subscriptionEndedAt?: ModelStringInput | null,
  subscriptionCancelAtPeriodEnd?: ModelStringInput | null,
  usageSubscriptionId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMProjectSubscriptionFilterInput | null > | null,
  or?: Array< ModelLLMProjectSubscriptionFilterInput | null > | null,
  not?: ModelLLMProjectSubscriptionFilterInput | null,
};

export type ModelLLMProjectSubscriptionConnection = {
  __typename: "ModelLLMProjectSubscriptionConnection",
  items:  Array<LLMProjectSubscription | null >,
  nextToken?: string | null,
};

export type ModelLLMUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  acceptedTermsOfService?: ModelBooleanInput | null,
  acceptedGDPRTerms?: ModelBooleanInput | null,
  projectId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMUserFilterInput | null > | null,
  or?: Array< ModelLLMUserFilterInput | null > | null,
  not?: ModelLLMUserFilterInput | null,
};

export type ModelLLMServiceFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  endpoint?: ModelStringInput | null,
  body?: ModelStringInput | null,
  header?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  loadProportion?: ModelIntInput | null,
  inputTokenPricePerMillion?: ModelFloatInput | null,
  outputTokenPricePerMillion?: ModelFloatInput | null,
  groupId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMServiceFilterInput | null > | null,
  or?: Array< ModelLLMServiceFilterInput | null > | null,
  not?: ModelLLMServiceFilterInput | null,
};

export type ModelLLMGroupFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  order?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMGroupFilterInput | null > | null,
  or?: Array< ModelLLMGroupFilterInput | null > | null,
  not?: ModelLLMGroupFilterInput | null,
};

export type ModelLLMGroupConnection = {
  __typename: "ModelLLMGroupConnection",
  items:  Array<LLMGroup | null >,
  nextToken?: string | null,
};

export type ModelLLMCustomerFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  tokensRemaining?: ModelIntInput | null,
  lastCallMadeAt?: ModelStringInput | null,
  numberOfCallsMade?: ModelIntInput | null,
  projectId?: ModelIDInput | null,
  loadSheddingTier?: ModelIntInput | null,
  dataResidency?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  enterpriseUser?: ModelBooleanInput | null,
  tokenReplenishmentAmount?: ModelIntInput | null,
  tokenReplenishmentPeriod?: ModelStringInput | null,
  lastReplenishedAt?: ModelStringInput | null,
  nextReplenishAt?: ModelStringInput | null,
  usageTierId?: ModelIDInput | null,
  nextUsageTierId?: ModelIDInput | null,
  nextUsageTierAt?: ModelStringInput | null,
  usageLimitAction?: ModelLLMUsageLimitActionInput | null,
  standardTokensRemaining?: ModelIntInput | null,
  premiumTokensRemaining?: ModelIntInput | null,
  superPremiumTokensRemaining?: ModelIntInput | null,
  reasoningTokensRemaining?: ModelIntInput | null,
  standardCallsRemaining?: ModelIntInput | null,
  premiumCallsRemaining?: ModelIntInput | null,
  superPremiumCallsRemaining?: ModelIntInput | null,
  reasoningCallsRemaining?: ModelIntInput | null,
  standardTokenUnlimited?: ModelBooleanInput | null,
  premiumTokenUnlimited?: ModelBooleanInput | null,
  superPremiumTokenUnlimited?: ModelBooleanInput | null,
  reasoningTokenUnlimited?: ModelBooleanInput | null,
  standardCallUnlimited?: ModelBooleanInput | null,
  premiumCallUnlimited?: ModelBooleanInput | null,
  superPremiumCallUnlimited?: ModelBooleanInput | null,
  reasoningCallUnlimited?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCustomerFilterInput | null > | null,
  or?: Array< ModelLLMCustomerFilterInput | null > | null,
  not?: ModelLLMCustomerFilterInput | null,
};

export type ModelLLMCustomerConnection = {
  __typename: "ModelLLMCustomerConnection",
  items:  Array<LLMCustomer | null >,
  nextToken?: string | null,
};

export type ModelLLMCallFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  customerId?: ModelIDInput | null,
  serviceId?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  requestHash?: ModelStringInput | null,
  messages?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  response?: ModelStringInput | null,
  tokenCountPrompt?: ModelIntInput | null,
  tokenCountResponse?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  hash?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  quality?: ModelIntInput | null,
  qualityComment?: ModelStringInput | null,
  apiKeyType?: ModelStringInput | null,
  toxicity?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  agentId?: ModelIDInput | null,
  conversationId?: ModelIDInput | null,
  timings?: ModelStringInput | null,
  customer_user_id?: ModelStringInput | null,
  customer_user_name?: ModelStringInput | null,
  customer_user_email?: ModelStringInput | null,
  batch?: ModelBooleanInput | null,
  callbackUrl?: ModelStringInput | null,
  batchId?: ModelIDInput | null,
  batchCustomId?: ModelStringInput | null,
  batchRequest?: ModelStringInput | null,
  executionMode?: ModelStringInput | null,
  pricingMode?: ModelStringInput | null,
  vendorBatchId?: ModelStringInput | null,
  vendorResponseId?: ModelStringInput | null,
  vendorStatus?: ModelStringInput | null,
  resolvedModelId?: ModelStringInput | null,
  usageTapCallId?: ModelStringInput | null,
  usageTapStripeCustomerId?: ModelStringInput | null,
  error?: ModelStringInput | null,
  cacheReadTokens?: ModelIntInput | null,
  cacheWriteTokens?: ModelIntInput | null,
  cacheStatus?: ModelStringInput | null,
  compactionTriggered?: ModelBooleanInput | null,
  compactionTokensSaved?: ModelIntInput | null,
  curatedTokensSaved?: ModelIntInput | null,
  curatedItems?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCallFilterInput | null > | null,
  or?: Array< ModelLLMCallFilterInput | null > | null,
  not?: ModelLLMCallFilterInput | null,
};

export type ModelLLMBatchFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  vendorBatchId?: ModelStringInput | null,
  vendorInputFileId?: ModelStringInput | null,
  vendorOutputFileId?: ModelStringInput | null,
  vendorErrorFileId?: ModelStringInput | null,
  requestCount?: ModelIntInput | null,
  completedCount?: ModelIntInput | null,
  failedCount?: ModelIntInput | null,
  nextPollAt?: ModelStringInput | null,
  callbackUrl?: ModelStringInput | null,
  callbackSecret?: ModelStringInput | null,
  callbackStatus?: ModelStringInput | null,
  callbackAttempts?: ModelIntInput | null,
  callbackLastError?: ModelStringInput | null,
  idempotencyKeyHash?: ModelStringInput | null,
  requestHash?: ModelStringInput | null,
  error?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMBatchFilterInput | null > | null,
  or?: Array< ModelLLMBatchFilterInput | null > | null,
  not?: ModelLLMBatchFilterInput | null,
};

export type ModelLLMBatchConnection = {
  __typename: "ModelLLMBatchConnection",
  items:  Array<LLMBatch | null >,
  nextToken?: string | null,
};

export type ModelLLMPromptFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  key?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMPromptFilterInput | null > | null,
  or?: Array< ModelLLMPromptFilterInput | null > | null,
  not?: ModelLLMPromptFilterInput | null,
};

export type ModelLLMPromptConnection = {
  __typename: "ModelLLMPromptConnection",
  items:  Array<LLMPrompt | null >,
  nextToken?: string | null,
};

export type ModelLLMCallLogFileFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  fromDate?: ModelStringInput | null,
  toDate?: ModelStringInput | null,
  chunk?: ModelIntInput | null,
  count?: ModelIntInput | null,
  status?: ModelStringInput | null,
  bucket?: ModelStringInput | null,
  key?: ModelStringInput | null,
  url?: ModelStringInput | null,
  urlExpiresAt?: ModelStringInput | null,
  deleteFileAfter?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCallLogFileFilterInput | null > | null,
  or?: Array< ModelLLMCallLogFileFilterInput | null > | null,
  not?: ModelLLMCallLogFileFilterInput | null,
};

export type ModelLLMCallLogFileConnection = {
  __typename: "ModelLLMCallLogFileConnection",
  items:  Array<LLMCallLogFile | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  displayTheme?: ModelStringInput | null,
  cssUrl?: ModelStringInput | null,
  displayTitle?: ModelStringInput | null,
  displayStartMessageOrPrompt?: ModelStringInput | null,
  displayInitialMessageOrPrompt?: ModelStringInput | null,
  displayPromptTemplate?: ModelStringInput | null,
  displayFollowOnPrompts?: ModelStringInput | null,
  displayActions?: ModelStringInput | null,
  displayWidth?: ModelStringInput | null,
  displayHeight?: ModelStringInput | null,
  displayPlaceholder?: ModelStringInput | null,
  displayHideInitialPrompt?: ModelBooleanInput | null,
  displayShowSaveButton?: ModelBooleanInput | null,
  displayShowEmailButton?: ModelBooleanInput | null,
  displayShowCallToAction?: ModelBooleanInput | null,
  displayCallToActionButtonText?: ModelStringInput | null,
  displayCallToActionEmailAddress?: ModelStringInput | null,
  displayCallToActionEmailSubject?: ModelStringInput | null,
  displayCallToActionMustSendEmail?: ModelBooleanInput | null,
  displayScrollToEnd?: ModelBooleanInput | null,
  groupId?: ModelStringInput | null,
  data?: ModelStringInput | null,
  ragQueryLimit?: ModelIntInput | null,
  ragRankLimit?: ModelIntInput | null,
  ragIncludeCitations?: ModelBooleanInput | null,
  ragDoRerank?: ModelBooleanInput | null,
  ragSkipChecksOnContext?: ModelBooleanInput | null,
  ragShadowRead?: ModelBooleanInput | null,
  visibility?: ModelLLMVisibilityInput | null,
  createConversationOnFirstChat?: ModelBooleanInput | null,
  customerEmailCaptureMode?: ModelLLMEmailCaptureModeInput | null,
  customerEmailCapturePlaceholder?: ModelStringInput | null,
  enableRAG?: ModelBooleanInput | null,
  enableMCP?: ModelBooleanInput | null,
  injectMemories?: ModelIntInput | null,
  injectKnowledgeGraph?: ModelIntInput | null,
  enableWebSearch?: ModelBooleanInput | null,
  linkedFileTypes?: ModelStringInput | null,
  thinkingDepth?: ModelLLMThinkingDepthInput | null,
  enablePromptCaching?: ModelBooleanInput | null,
  compactionPolicy?: ModelStringInput | null,
  compactionThreshold?: ModelIntInput | null,
  curateToolResults?: ModelBooleanInput | null,
  curateAfterTurns?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentFilterInput | null > | null,
  or?: Array< ModelLLMAgentFilterInput | null > | null,
  not?: ModelLLMAgentFilterInput | null,
};

export type ModelLLMAgentConnection = {
  __typename: "ModelLLMAgentConnection",
  items:  Array<LLMAgent | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentMCPFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  approvalMode?: ModelLLMMCPApprovalModeInput | null,
  executionMode?: ModelLLMMCPExecutionModeInput | null,
  url?: ModelStringInput | null,
  accessToken?: ModelStringInput | null,
  headers?: ModelStringInput | null,
  stdioCommand?: ModelStringInput | null,
  stdioArgs?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentMCPFilterInput | null > | null,
  or?: Array< ModelLLMAgentMCPFilterInput | null > | null,
  not?: ModelLLMAgentMCPFilterInput | null,
};

export type ModelLLMAgentDocumentFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileSize?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  uploadDate?: ModelStringInput | null,
  uploader?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  ownershipAttestation?: ModelStringInput | null,
  location?: ModelStringInput | null,
  type?: ModelStringInput | null,
  ragSplitter?: ModelStringInput | null,
  ragChunkSize?: ModelIntInput | null,
  ragChunkOverlap?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentDocumentFilterInput | null > | null,
  or?: Array< ModelLLMAgentDocumentFilterInput | null > | null,
  not?: ModelLLMAgentDocumentFilterInput | null,
};

export type ModelLLMOpenAIAgentDocumentFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  projectBackend?: ModelStringInput | null,
  documentId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  backend?: ModelStringInput | null,
  status?: ModelStringInput | null,
  vectorStoreId?: ModelStringInput | null,
  openaiFileIds?: ModelStringInput | null,
  sourceType?: ModelStringInput | null,
  sourceLocation?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  ragSplitter?: ModelStringInput | null,
  ragChunkSize?: ModelIntInput | null,
  ragChunkOverlap?: ModelIntInput | null,
  chunkCount?: ModelIntInput | null,
  providerVersion?: ModelStringInput | null,
  lastError?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  readyAt?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  and?: Array< ModelLLMOpenAIAgentDocumentFilterInput | null > | null,
  or?: Array< ModelLLMOpenAIAgentDocumentFilterInput | null > | null,
  not?: ModelLLMOpenAIAgentDocumentFilterInput | null,
};

export type ModelLLMOpenAIAgentDocumentConnection = {
  __typename: "ModelLLMOpenAIAgentDocumentConnection",
  items:  Array<LLMOpenAIAgentDocument | null >,
  nextToken?: string | null,
};

export type ModelLLMConversationFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  status?: ModelStringInput | null,
  title?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  language?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  emailAddress?: ModelStringInput | null,
  thumbsupClicked?: ModelIntInput | null,
  thumbsdownClicked?: ModelIntInput | null,
  copyClicked?: ModelIntInput | null,
  emailClicked?: ModelIntInput | null,
  saveClicked?: ModelIntInput | null,
  ctaClicked?: ModelIntInput | null,
  suggestionClicked?: ModelIntInput | null,
  actionClicked?: ModelIntInput | null,
  intelligence?: ModelStringInput | null,
  endedAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMConversationFilterInput | null > | null,
  or?: Array< ModelLLMConversationFilterInput | null > | null,
  not?: ModelLLMConversationFilterInput | null,
};

export type ModelLLMConversationConnection = {
  __typename: "ModelLLMConversationConnection",
  items:  Array<LLMConversation | null >,
  nextToken?: string | null,
};

export type ModelLLMModelFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  host?: ModelStringInput | null,
  supported?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  modelKey?: ModelStringInput | null,
  modelKeyLatest?: ModelStringInput | null,
  inputTokenPrice?: ModelFloatInput | null,
  cachedTokenPrice?: ModelFloatInput | null,
  outputTokenPrice?: ModelFloatInput | null,
  inputTokenBatchPrice?: ModelFloatInput | null,
  outputTokenBatchPrice?: ModelFloatInput | null,
  searchCost?: ModelFloatInput | null,
  supportsSearch?: ModelBooleanInput | null,
  textInputSupport?: ModelBooleanInput | null,
  imageInputSupport?: ModelBooleanInput | null,
  audioInputSupport?: ModelBooleanInput | null,
  textOutputSupport?: ModelBooleanInput | null,
  imageOutputSupport?: ModelBooleanInput | null,
  audioOutputSupport?: ModelBooleanInput | null,
  thinkingSupport?: ModelBooleanInput | null,
  contextWindowTokens?: ModelIntInput | null,
  maxResponseTokens?: ModelIntInput | null,
  knowledgeCutoffDate?: ModelStringInput | null,
  lastCheckedDate?: ModelStringInput | null,
  supportedLanguages?: ModelStringInput | null,
  warningDate?: ModelStringInput | null,
  warningMessage?: ModelStringInput | null,
  deprecationDate?: ModelStringInput | null,
  deprecationMessage?: ModelStringInput | null,
  defaultServiceGroup?: ModelStringInput | null,
  defaultEnabled?: ModelBooleanInput | null,
  displayOrder?: ModelIntInput | null,
  recommendedUseCase?: ModelStringInput | null,
  performanceRating?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMModelFilterInput | null > | null,
  or?: Array< ModelLLMModelFilterInput | null > | null,
  not?: ModelLLMModelFilterInput | null,
};

export type ModelLLMModelConnection = {
  __typename: "ModelLLMModelConnection",
  items:  Array<LLMModel | null >,
  nextToken?: string | null,
};

export type ModelLLMProviderFilterInput = {
  id?: ModelIDInput | null,
  displayName?: ModelStringInput | null,
  contactUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  defaultIsModerated?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMProviderFilterInput | null > | null,
  or?: Array< ModelLLMProviderFilterInput | null > | null,
  not?: ModelLLMProviderFilterInput | null,
};

export type ModelLLMProviderConnection = {
  __typename: "ModelLLMProviderConnection",
  items:  Array<LLMProvider | null >,
  nextToken?: string | null,
};

export type ModelLLMOpenRouterModelFilterInput = {
  id?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  canonicalSlug?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  tokenizer?: ModelStringInput | null,
  instructType?: ModelStringInput | null,
  contextLength?: ModelIntInput | null,
  maxCompletionTokens?: ModelIntInput | null,
  isModerated?: ModelBooleanInput | null,
  architectureModality?: ModelStringInput | null,
  architectureInputModalities?: ModelStringInput | null,
  architectureOutputModalities?: ModelStringInput | null,
  supportedParameters?: ModelStringInput | null,
  defaultParameters?: ModelStringInput | null,
  huggingFaceId?: ModelStringInput | null,
  latestPricingSnapshotId?: ModelIDInput | null,
  isDeprecated?: ModelBooleanInput | null,
  deprecatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMOpenRouterModelFilterInput | null > | null,
  or?: Array< ModelLLMOpenRouterModelFilterInput | null > | null,
  not?: ModelLLMOpenRouterModelFilterInput | null,
};

export type ModelLLMOpenRouterModelConnection = {
  __typename: "ModelLLMOpenRouterModelConnection",
  items:  Array<LLMOpenRouterModel | null >,
  nextToken?: string | null,
};

export type ModelLLMModelPricingSnapshotFilterInput = {
  id?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  source?: ModelLLMModelPricingSourceInput | null,
  fetchedAt?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  promptTokenUsdNano?: ModelStringInput | null,
  completionTokenUsdNano?: ModelStringInput | null,
  cacheReadTokenUsdNano?: ModelStringInput | null,
  cacheWriteTokenUsdNano?: ModelStringInput | null,
  reasoningTokenUsdNano?: ModelStringInput | null,
  webSearchUsdNano?: ModelStringInput | null,
  requestUsdNano?: ModelStringInput | null,
  imageUsdNano?: ModelStringInput | null,
  audioUsdNano?: ModelStringInput | null,
  internalNotes?: ModelStringInput | null,
  isCurrent?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMModelPricingSnapshotFilterInput | null > | null,
  or?: Array< ModelLLMModelPricingSnapshotFilterInput | null > | null,
  not?: ModelLLMModelPricingSnapshotFilterInput | null,
};

export type ModelLLMModelPricingSnapshotConnection = {
  __typename: "ModelLLMModelPricingSnapshotConnection",
  items:  Array<LLMModelPricingSnapshot | null >,
  nextToken?: string | null,
};

export type ModelLLMModelCapabilityFilterInput = {
  id?: ModelIDInput | null,
  modelId?: ModelIDInput | null,
  category?: ModelStringInput | null,
  value?: ModelStringInput | null,
  metadata?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMModelCapabilityFilterInput | null > | null,
  or?: Array< ModelLLMModelCapabilityFilterInput | null > | null,
  not?: ModelLLMModelCapabilityFilterInput | null,
};

export type ModelLLMModelCapabilityConnection = {
  __typename: "ModelLLMModelCapabilityConnection",
  items:  Array<LLMModelCapability | null >,
  nextToken?: string | null,
};

export type ModelLLMScheduledPromptFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelLLMScheduledPromptStatusInput | null,
  agentId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  data?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  scheduledAt?: ModelStringInput | null,
  priorScheduledPromptId?: ModelIDInput | null,
  nextScheduledPromptId?: ModelIDInput | null,
  processedAt?: ModelStringInput | null,
  response?: ModelStringInput | null,
  failedTimes?: ModelIntInput | null,
  errorMessage?: ModelStringInput | null,
  notificationEmailAddresses?: ModelStringInput | null,
  notificationEmailSubject?: ModelStringInput | null,
  repeatIntervalHours?: ModelIntInput | null,
  followOnAgentId?: ModelIDInput | null,
  followOnFollowOnAgentId?: ModelIDInput | null,
  followOnTitle?: ModelStringInput | null,
  followOnPrompt?: ModelStringInput | null,
  followOnScheduledAtHours?: ModelIntInput | null,
  followOnNotificationEmailAddresses?: ModelStringInput | null,
  followOnNotificationEmailSubject?: ModelStringInput | null,
  followOnRepeatIntervalHours?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMScheduledPromptFilterInput | null > | null,
  or?: Array< ModelLLMScheduledPromptFilterInput | null > | null,
  not?: ModelLLMScheduledPromptFilterInput | null,
};

export type ModelLLMScheduledPromptConnection = {
  __typename: "ModelLLMScheduledPromptConnection",
  items:  Array<LLMScheduledPrompt | null >,
  nextToken?: string | null,
};

export type ModelLLMTriggerFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelLLMTriggerStatusInput | null,
  triggerType?: ModelStringInput | null,
  scheduledPromptId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMTriggerFilterInput | null > | null,
  or?: Array< ModelLLMTriggerFilterInput | null > | null,
  not?: ModelLLMTriggerFilterInput | null,
};

export type ModelLLMTriggerConnection = {
  __typename: "ModelLLMTriggerConnection",
  items:  Array<LLMTrigger | null >,
  nextToken?: string | null,
};

export type ModelLLMMemoryFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  entityType?: ModelLLMMemoryEntityTypeInput | null,
  customerId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  key?: ModelStringInput | null,
  data?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  memoryType?: ModelLLMMemoryTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMMemoryFilterInput | null > | null,
  or?: Array< ModelLLMMemoryFilterInput | null > | null,
  not?: ModelLLMMemoryFilterInput | null,
};

export type ModelLLMMemoryConnection = {
  __typename: "ModelLLMMemoryConnection",
  items:  Array<LLMMemory | null >,
  nextToken?: string | null,
};

export type ModelLLMKnowledgeGraphFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  status?: ModelLLMKnowledgeGraphStatusInput | null,
  version?: ModelIntInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  graphData?: ModelStringInput | null,
  memoryCount?: ModelIntInput | null,
  generatedFromMemoryIds?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMKnowledgeGraphFilterInput | null > | null,
  or?: Array< ModelLLMKnowledgeGraphFilterInput | null > | null,
  not?: ModelLLMKnowledgeGraphFilterInput | null,
};

export type ModelLLMKnowledgeGraphConnection = {
  __typename: "ModelLLMKnowledgeGraphConnection",
  items:  Array<LLMKnowledgeGraph | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentValidationFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  operator?: ModelValidationOperatorInput | null,
  expectedValue?: ModelStringInput | null,
  customPromptTemplate?: ModelStringInput | null,
  status?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentValidationFilterInput | null > | null,
  or?: Array< ModelLLMAgentValidationFilterInput | null > | null,
  not?: ModelLLMAgentValidationFilterInput | null,
};

export type ModelLLMAgentValidationConnection = {
  __typename: "ModelLLMAgentValidationConnection",
  items:  Array<LLMAgentValidation | null >,
  nextToken?: string | null,
};

export type DeleteLLMProjectMutationVariables = {
  input: DeleteLLMProjectInput,
  condition?: ModelLLMProjectConditionInput | null,
};

export type DeleteLLMProjectMutation = {
  deleteLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          logGenerationCursor?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          mcpServerWhitelist?: string | null,
          automaticModelManagement?: boolean | null,
          supersmallGroupModels?: string | null,
          standardGroupModels?: string | null,
          premiumGroupModels?: string | null,
          reasoningGroupModels?: string | null,
          superpremiumGroupModels?: string | null,
          openrouterStandardGroupModels?: string | null,
          openrouterPremiumGroupModels?: string | null,
          azureOpenaiBaseUrl?: string | null,
          azureOpenaiApiVersion?: string | null,
          awsBedrockRegion?: string | null,
          newCustomerUsageTierId?: string | null,
          usageTapUsageApiKey?: string | null,
          lowApiCreditNotificationEmails?: string | null,
          lowApiCreditNotificationMinimumCredit?: number | null,
          lastLowApiCreditNotificationSentAt?: string | null,
          integrationApiKey1Hash?: string | null,
          integrationApiKey1Status?: string | null,
          integrationApiKey1Prefix?: string | null,
          integrationApiKey1LastRotatedAt?: string | null,
          integrationApiKey1Scopes?: Array< string > | null,
          integrationApiKey2Hash?: string | null,
          integrationApiKey2Status?: string | null,
          integrationApiKey2Prefix?: string | null,
          integrationApiKey2LastRotatedAt?: string | null,
          integrationApiKey2Scopes?: Array< string > | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    logGenerationCursor?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    mcpServerWhitelist?: string | null,
    automaticModelManagement?: boolean | null,
    supersmallGroupModels?: string | null,
    standardGroupModels?: string | null,
    premiumGroupModels?: string | null,
    reasoningGroupModels?: string | null,
    superpremiumGroupModels?: string | null,
    openrouterStandardGroupModels?: string | null,
    openrouterPremiumGroupModels?: string | null,
    azureOpenaiBaseUrl?: string | null,
    azureOpenaiApiVersion?: string | null,
    awsBedrockRegion?: string | null,
    newCustomerUsageTierId?: string | null,
    newCustomerUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usageTapUsageApiKey?: string | null,
    lowApiCreditNotificationEmails?: string | null,
    lowApiCreditNotificationMinimumCredit?: number | null,
    lastLowApiCreditNotificationSentAt?: string | null,
    integrationApiKey1Hash?: string | null,
    integrationApiKey1Status?: string | null,
    integrationApiKey1Prefix?: string | null,
    integrationApiKey1LastRotatedAt?: string | null,
    integrationApiKey1Scopes?: Array< string > | null,
    integrationApiKey2Hash?: string | null,
    integrationApiKey2Status?: string | null,
    integrationApiKey2Prefix?: string | null,
    integrationApiKey2LastRotatedAt?: string | null,
    integrationApiKey2Scopes?: Array< string > | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMBatchMutationVariables = {
  input: DeleteLLMBatchInput,
  condition?: ModelLLMBatchConditionInput | null,
};

export type DeleteLLMBatchMutation = {
  deleteLLMBatch?:  {
    __typename: "LLMBatch",
    id: string,
    projectId: string,
    status: string,
    vendor: string,
    vendorBatchId?: string | null,
    vendorInputFileId?: string | null,
    vendorOutputFileId?: string | null,
    vendorErrorFileId?: string | null,
    requestCount: number,
    completedCount: number,
    failedCount: number,
    nextPollAt: string,
    callbackUrl?: string | null,
    callbackSecret?: string | null,
    callbackStatus?: string | null,
    callbackAttempts?: number | null,
    callbackLastError?: string | null,
    idempotencyKeyHash?: string | null,
    requestHash?: string | null,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMProjectMutationVariables = {
  input: CreateLLMProjectInput,
  condition?: ModelLLMProjectConditionInput | null,
};

export type CreateLLMProjectMutation = {
  createLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          logGenerationCursor?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          mcpServerWhitelist?: string | null,
          automaticModelManagement?: boolean | null,
          supersmallGroupModels?: string | null,
          standardGroupModels?: string | null,
          premiumGroupModels?: string | null,
          reasoningGroupModels?: string | null,
          superpremiumGroupModels?: string | null,
          openrouterStandardGroupModels?: string | null,
          openrouterPremiumGroupModels?: string | null,
          azureOpenaiBaseUrl?: string | null,
          azureOpenaiApiVersion?: string | null,
          awsBedrockRegion?: string | null,
          newCustomerUsageTierId?: string | null,
          usageTapUsageApiKey?: string | null,
          lowApiCreditNotificationEmails?: string | null,
          lowApiCreditNotificationMinimumCredit?: number | null,
          lastLowApiCreditNotificationSentAt?: string | null,
          integrationApiKey1Hash?: string | null,
          integrationApiKey1Status?: string | null,
          integrationApiKey1Prefix?: string | null,
          integrationApiKey1LastRotatedAt?: string | null,
          integrationApiKey1Scopes?: Array< string > | null,
          integrationApiKey2Hash?: string | null,
          integrationApiKey2Status?: string | null,
          integrationApiKey2Prefix?: string | null,
          integrationApiKey2LastRotatedAt?: string | null,
          integrationApiKey2Scopes?: Array< string > | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    logGenerationCursor?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    mcpServerWhitelist?: string | null,
    automaticModelManagement?: boolean | null,
    supersmallGroupModels?: string | null,
    standardGroupModels?: string | null,
    premiumGroupModels?: string | null,
    reasoningGroupModels?: string | null,
    superpremiumGroupModels?: string | null,
    openrouterStandardGroupModels?: string | null,
    openrouterPremiumGroupModels?: string | null,
    azureOpenaiBaseUrl?: string | null,
    azureOpenaiApiVersion?: string | null,
    awsBedrockRegion?: string | null,
    newCustomerUsageTierId?: string | null,
    newCustomerUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usageTapUsageApiKey?: string | null,
    lowApiCreditNotificationEmails?: string | null,
    lowApiCreditNotificationMinimumCredit?: number | null,
    lastLowApiCreditNotificationSentAt?: string | null,
    integrationApiKey1Hash?: string | null,
    integrationApiKey1Status?: string | null,
    integrationApiKey1Prefix?: string | null,
    integrationApiKey1LastRotatedAt?: string | null,
    integrationApiKey1Scopes?: Array< string > | null,
    integrationApiKey2Hash?: string | null,
    integrationApiKey2Status?: string | null,
    integrationApiKey2Prefix?: string | null,
    integrationApiKey2LastRotatedAt?: string | null,
    integrationApiKey2Scopes?: Array< string > | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMProjectMutationVariables = {
  input: UpdateLLMProjectInput,
  condition?: ModelLLMProjectConditionInput | null,
};

export type UpdateLLMProjectMutation = {
  updateLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          logGenerationCursor?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          mcpServerWhitelist?: string | null,
          automaticModelManagement?: boolean | null,
          supersmallGroupModels?: string | null,
          standardGroupModels?: string | null,
          premiumGroupModels?: string | null,
          reasoningGroupModels?: string | null,
          superpremiumGroupModels?: string | null,
          openrouterStandardGroupModels?: string | null,
          openrouterPremiumGroupModels?: string | null,
          azureOpenaiBaseUrl?: string | null,
          azureOpenaiApiVersion?: string | null,
          awsBedrockRegion?: string | null,
          newCustomerUsageTierId?: string | null,
          usageTapUsageApiKey?: string | null,
          lowApiCreditNotificationEmails?: string | null,
          lowApiCreditNotificationMinimumCredit?: number | null,
          lastLowApiCreditNotificationSentAt?: string | null,
          integrationApiKey1Hash?: string | null,
          integrationApiKey1Status?: string | null,
          integrationApiKey1Prefix?: string | null,
          integrationApiKey1LastRotatedAt?: string | null,
          integrationApiKey1Scopes?: Array< string > | null,
          integrationApiKey2Hash?: string | null,
          integrationApiKey2Status?: string | null,
          integrationApiKey2Prefix?: string | null,
          integrationApiKey2LastRotatedAt?: string | null,
          integrationApiKey2Scopes?: Array< string > | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    logGenerationCursor?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    mcpServerWhitelist?: string | null,
    automaticModelManagement?: boolean | null,
    supersmallGroupModels?: string | null,
    standardGroupModels?: string | null,
    premiumGroupModels?: string | null,
    reasoningGroupModels?: string | null,
    superpremiumGroupModels?: string | null,
    openrouterStandardGroupModels?: string | null,
    openrouterPremiumGroupModels?: string | null,
    azureOpenaiBaseUrl?: string | null,
    azureOpenaiApiVersion?: string | null,
    awsBedrockRegion?: string | null,
    newCustomerUsageTierId?: string | null,
    newCustomerUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usageTapUsageApiKey?: string | null,
    lowApiCreditNotificationEmails?: string | null,
    lowApiCreditNotificationMinimumCredit?: number | null,
    lastLowApiCreditNotificationSentAt?: string | null,
    integrationApiKey1Hash?: string | null,
    integrationApiKey1Status?: string | null,
    integrationApiKey1Prefix?: string | null,
    integrationApiKey1LastRotatedAt?: string | null,
    integrationApiKey1Scopes?: Array< string > | null,
    integrationApiKey2Hash?: string | null,
    integrationApiKey2Status?: string | null,
    integrationApiKey2Prefix?: string | null,
    integrationApiKey2LastRotatedAt?: string | null,
    integrationApiKey2Scopes?: Array< string > | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMUsageTierMutationVariables = {
  input: CreateLLMUsageTierInput,
  condition?: ModelLLMUsageTierConditionInput | null,
};

export type CreateLLMUsageTierMutation = {
  createLLMUsageTier?:  {
    __typename: "LLMUsageTier",
    id: string,
    projectId: string,
    status: LLMUsageTierStatus,
    name: string,
    description?: string | null,
    version: number,
    activeAt?: string | null,
    inactiveAt?: string | null,
    priorUsageTierId?: string | null,
    priorUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    baseUsageTierId?: string | null,
    baseUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    replenishmentPeriod?: LLMPeriod | null,
    replenishmentMethod?: LLMReplenishmentMethod | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokenReplenishmentAmount?: number | null,
    premiumTokenReplenishmentAmount?: number | null,
    superPremiumTokenReplenishmentAmount?: number | null,
    reasoningTokenReplenishmentAmount?: number | null,
    standardCallReplenishmentAmount?: number | null,
    premiumCallReplenishmentAmount?: number | null,
    superPremiumCallReplenishmentAmount?: number | null,
    reasoningCallReplenishmentAmount?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMUsageTierMutationVariables = {
  input: UpdateLLMUsageTierInput,
  condition?: ModelLLMUsageTierConditionInput | null,
};

export type UpdateLLMUsageTierMutation = {
  updateLLMUsageTier?:  {
    __typename: "LLMUsageTier",
    id: string,
    projectId: string,
    status: LLMUsageTierStatus,
    name: string,
    description?: string | null,
    version: number,
    activeAt?: string | null,
    inactiveAt?: string | null,
    priorUsageTierId?: string | null,
    priorUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    baseUsageTierId?: string | null,
    baseUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    replenishmentPeriod?: LLMPeriod | null,
    replenishmentMethod?: LLMReplenishmentMethod | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokenReplenishmentAmount?: number | null,
    premiumTokenReplenishmentAmount?: number | null,
    superPremiumTokenReplenishmentAmount?: number | null,
    reasoningTokenReplenishmentAmount?: number | null,
    standardCallReplenishmentAmount?: number | null,
    premiumCallReplenishmentAmount?: number | null,
    superPremiumCallReplenishmentAmount?: number | null,
    reasoningCallReplenishmentAmount?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMUsageTierMutationVariables = {
  input: DeleteLLMUsageTierInput,
  condition?: ModelLLMUsageTierConditionInput | null,
};

export type DeleteLLMUsageTierMutation = {
  deleteLLMUsageTier?:  {
    __typename: "LLMUsageTier",
    id: string,
    projectId: string,
    status: LLMUsageTierStatus,
    name: string,
    description?: string | null,
    version: number,
    activeAt?: string | null,
    inactiveAt?: string | null,
    priorUsageTierId?: string | null,
    priorUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    baseUsageTierId?: string | null,
    baseUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    replenishmentPeriod?: LLMPeriod | null,
    replenishmentMethod?: LLMReplenishmentMethod | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokenReplenishmentAmount?: number | null,
    premiumTokenReplenishmentAmount?: number | null,
    superPremiumTokenReplenishmentAmount?: number | null,
    reasoningTokenReplenishmentAmount?: number | null,
    standardCallReplenishmentAmount?: number | null,
    premiumCallReplenishmentAmount?: number | null,
    superPremiumCallReplenishmentAmount?: number | null,
    reasoningCallReplenishmentAmount?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMProjectSubscriptionMutationVariables = {
  input: CreateLLMProjectSubscriptionInput,
  condition?: ModelLLMProjectSubscriptionConditionInput | null,
};

export type CreateLLMProjectSubscriptionMutation = {
  createLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMProjectSubscriptionMutationVariables = {
  input: UpdateLLMProjectSubscriptionInput,
  condition?: ModelLLMProjectSubscriptionConditionInput | null,
};

export type UpdateLLMProjectSubscriptionMutation = {
  updateLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMProjectSubscriptionMutationVariables = {
  input: DeleteLLMProjectSubscriptionInput,
  condition?: ModelLLMProjectSubscriptionConditionInput | null,
};

export type DeleteLLMProjectSubscriptionMutation = {
  deleteLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMUserMutationVariables = {
  input: CreateLLMUserInput,
  condition?: ModelLLMUserConditionInput | null,
};

export type CreateLLMUserMutation = {
  createLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMUserMutationVariables = {
  input: UpdateLLMUserInput,
  condition?: ModelLLMUserConditionInput | null,
};

export type UpdateLLMUserMutation = {
  updateLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMUserMutationVariables = {
  input: DeleteLLMUserInput,
  condition?: ModelLLMUserConditionInput | null,
};

export type DeleteLLMUserMutation = {
  deleteLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMServiceMutationVariables = {
  input: CreateLLMServiceInput,
  condition?: ModelLLMServiceConditionInput | null,
};

export type CreateLLMServiceMutation = {
  createLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMServiceMutationVariables = {
  input: UpdateLLMServiceInput,
  condition?: ModelLLMServiceConditionInput | null,
};

export type UpdateLLMServiceMutation = {
  updateLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMServiceMutationVariables = {
  input: DeleteLLMServiceInput,
  condition?: ModelLLMServiceConditionInput | null,
};

export type DeleteLLMServiceMutation = {
  deleteLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMGroupMutationVariables = {
  input: CreateLLMGroupInput,
  condition?: ModelLLMGroupConditionInput | null,
};

export type CreateLLMGroupMutation = {
  createLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMGroupMutationVariables = {
  input: UpdateLLMGroupInput,
  condition?: ModelLLMGroupConditionInput | null,
};

export type UpdateLLMGroupMutation = {
  updateLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMGroupMutationVariables = {
  input: DeleteLLMGroupInput,
  condition?: ModelLLMGroupConditionInput | null,
};

export type DeleteLLMGroupMutation = {
  deleteLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMCustomerMutationVariables = {
  input: CreateLLMCustomerInput,
  condition?: ModelLLMCustomerConditionInput | null,
};

export type CreateLLMCustomerMutation = {
  createLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    nextReplenishAt?: string | null,
    usageTierId?: string | null,
    usageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierId?: string | null,
    nextUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierAt?: string | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokensRemaining?: number | null,
    premiumTokensRemaining?: number | null,
    superPremiumTokensRemaining?: number | null,
    reasoningTokensRemaining?: number | null,
    standardCallsRemaining?: number | null,
    premiumCallsRemaining?: number | null,
    superPremiumCallsRemaining?: number | null,
    reasoningCallsRemaining?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMCustomerMutationVariables = {
  input: UpdateLLMCustomerInput,
  condition?: ModelLLMCustomerConditionInput | null,
};

export type UpdateLLMCustomerMutation = {
  updateLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    nextReplenishAt?: string | null,
    usageTierId?: string | null,
    usageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierId?: string | null,
    nextUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierAt?: string | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokensRemaining?: number | null,
    premiumTokensRemaining?: number | null,
    superPremiumTokensRemaining?: number | null,
    reasoningTokensRemaining?: number | null,
    standardCallsRemaining?: number | null,
    premiumCallsRemaining?: number | null,
    superPremiumCallsRemaining?: number | null,
    reasoningCallsRemaining?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMCustomerMutationVariables = {
  input: DeleteLLMCustomerInput,
  condition?: ModelLLMCustomerConditionInput | null,
};

export type DeleteLLMCustomerMutation = {
  deleteLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    nextReplenishAt?: string | null,
    usageTierId?: string | null,
    usageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierId?: string | null,
    nextUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierAt?: string | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokensRemaining?: number | null,
    premiumTokensRemaining?: number | null,
    superPremiumTokensRemaining?: number | null,
    reasoningTokensRemaining?: number | null,
    standardCallsRemaining?: number | null,
    premiumCallsRemaining?: number | null,
    superPremiumCallsRemaining?: number | null,
    reasoningCallsRemaining?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMCallMutationVariables = {
  input: CreateLLMCallInput,
  condition?: ModelLLMCallConditionInput | null,
};

export type CreateLLMCallMutation = {
  createLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    modelId?: string | null,
    model?:  {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    customer_user_id?: string | null,
    customer_user_name?: string | null,
    customer_user_email?: string | null,
    batch?: boolean | null,
    callbackUrl?: string | null,
    batchId?: string | null,
    batchCustomId?: string | null,
    batchRequest?: string | null,
    executionMode?: string | null,
    pricingMode?: string | null,
    vendorBatchId?: string | null,
    vendorResponseId?: string | null,
    vendorStatus?: string | null,
    resolvedModelId?: string | null,
    usageTapCallId?: string | null,
    usageTapStripeCustomerId?: string | null,
    error?: string | null,
    cacheReadTokens?: number | null,
    cacheWriteTokens?: number | null,
    cacheStatus?: string | null,
    compactionTriggered?: boolean | null,
    compactionTokensSaved?: number | null,
    curatedTokensSaved?: number | null,
    curatedItems?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMCallMutationVariables = {
  input: UpdateLLMCallInput,
  condition?: ModelLLMCallConditionInput | null,
};

export type UpdateLLMCallMutation = {
  updateLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    modelId?: string | null,
    model?:  {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    customer_user_id?: string | null,
    customer_user_name?: string | null,
    customer_user_email?: string | null,
    batch?: boolean | null,
    callbackUrl?: string | null,
    batchId?: string | null,
    batchCustomId?: string | null,
    batchRequest?: string | null,
    executionMode?: string | null,
    pricingMode?: string | null,
    vendorBatchId?: string | null,
    vendorResponseId?: string | null,
    vendorStatus?: string | null,
    resolvedModelId?: string | null,
    usageTapCallId?: string | null,
    usageTapStripeCustomerId?: string | null,
    error?: string | null,
    cacheReadTokens?: number | null,
    cacheWriteTokens?: number | null,
    cacheStatus?: string | null,
    compactionTriggered?: boolean | null,
    compactionTokensSaved?: number | null,
    curatedTokensSaved?: number | null,
    curatedItems?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMCallMutationVariables = {
  input: DeleteLLMCallInput,
  condition?: ModelLLMCallConditionInput | null,
};

export type DeleteLLMCallMutation = {
  deleteLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    modelId?: string | null,
    model?:  {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    customer_user_id?: string | null,
    customer_user_name?: string | null,
    customer_user_email?: string | null,
    batch?: boolean | null,
    callbackUrl?: string | null,
    batchId?: string | null,
    batchCustomId?: string | null,
    batchRequest?: string | null,
    executionMode?: string | null,
    pricingMode?: string | null,
    vendorBatchId?: string | null,
    vendorResponseId?: string | null,
    vendorStatus?: string | null,
    resolvedModelId?: string | null,
    usageTapCallId?: string | null,
    usageTapStripeCustomerId?: string | null,
    error?: string | null,
    cacheReadTokens?: number | null,
    cacheWriteTokens?: number | null,
    cacheStatus?: string | null,
    compactionTriggered?: boolean | null,
    compactionTokensSaved?: number | null,
    curatedTokensSaved?: number | null,
    curatedItems?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMBatchMutationVariables = {
  input: CreateLLMBatchInput,
  condition?: ModelLLMBatchConditionInput | null,
};

export type CreateLLMBatchMutation = {
  createLLMBatch?:  {
    __typename: "LLMBatch",
    id: string,
    projectId: string,
    status: string,
    vendor: string,
    vendorBatchId?: string | null,
    vendorInputFileId?: string | null,
    vendorOutputFileId?: string | null,
    vendorErrorFileId?: string | null,
    requestCount: number,
    completedCount: number,
    failedCount: number,
    nextPollAt: string,
    callbackUrl?: string | null,
    callbackSecret?: string | null,
    callbackStatus?: string | null,
    callbackAttempts?: number | null,
    callbackLastError?: string | null,
    idempotencyKeyHash?: string | null,
    requestHash?: string | null,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMBatchMutationVariables = {
  input: UpdateLLMBatchInput,
  condition?: ModelLLMBatchConditionInput | null,
};

export type UpdateLLMBatchMutation = {
  updateLLMBatch?:  {
    __typename: "LLMBatch",
    id: string,
    projectId: string,
    status: string,
    vendor: string,
    vendorBatchId?: string | null,
    vendorInputFileId?: string | null,
    vendorOutputFileId?: string | null,
    vendorErrorFileId?: string | null,
    requestCount: number,
    completedCount: number,
    failedCount: number,
    nextPollAt: string,
    callbackUrl?: string | null,
    callbackSecret?: string | null,
    callbackStatus?: string | null,
    callbackAttempts?: number | null,
    callbackLastError?: string | null,
    idempotencyKeyHash?: string | null,
    requestHash?: string | null,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMPromptMutationVariables = {
  input: CreateLLMPromptInput,
  condition?: ModelLLMPromptConditionInput | null,
};

export type CreateLLMPromptMutation = {
  createLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMPromptMutationVariables = {
  input: UpdateLLMPromptInput,
  condition?: ModelLLMPromptConditionInput | null,
};

export type UpdateLLMPromptMutation = {
  updateLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMPromptMutationVariables = {
  input: DeleteLLMPromptInput,
  condition?: ModelLLMPromptConditionInput | null,
};

export type DeleteLLMPromptMutation = {
  deleteLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMCallLogFileMutationVariables = {
  input: CreateLLMCallLogFileInput,
  condition?: ModelLLMCallLogFileConditionInput | null,
};

export type CreateLLMCallLogFileMutation = {
  createLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMCallLogFileMutationVariables = {
  input: UpdateLLMCallLogFileInput,
  condition?: ModelLLMCallLogFileConditionInput | null,
};

export type UpdateLLMCallLogFileMutation = {
  updateLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMCallLogFileMutationVariables = {
  input: DeleteLLMCallLogFileInput,
  condition?: ModelLLMCallLogFileConditionInput | null,
};

export type DeleteLLMCallLogFileMutation = {
  deleteLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentMutationVariables = {
  input: CreateLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null,
};

export type CreateLLMAgentMutation = {
  createLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        approvalMode?: LLMMCPApprovalMode | null,
        executionMode?: LLMMCPExecutionMode | null,
        url?: string | null,
        accessToken?: string | null,
        headers?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    ragSkipChecksOnContext?: boolean | null,
    ragShadowRead?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    injectMemories?: number | null,
    injectKnowledgeGraph?: number | null,
    enableWebSearch?: boolean | null,
    linkedFileTypes?: string | null,
    thinkingDepth?: LLMThinkingDepth | null,
    enablePromptCaching?: boolean | null,
    compactionPolicy?: string | null,
    compactionThreshold?: number | null,
    curateToolResults?: boolean | null,
    curateAfterTurns?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentMutationVariables = {
  input: UpdateLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null,
};

export type UpdateLLMAgentMutation = {
  updateLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        approvalMode?: LLMMCPApprovalMode | null,
        executionMode?: LLMMCPExecutionMode | null,
        url?: string | null,
        accessToken?: string | null,
        headers?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    ragSkipChecksOnContext?: boolean | null,
    ragShadowRead?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    injectMemories?: number | null,
    injectKnowledgeGraph?: number | null,
    enableWebSearch?: boolean | null,
    linkedFileTypes?: string | null,
    thinkingDepth?: LLMThinkingDepth | null,
    enablePromptCaching?: boolean | null,
    compactionPolicy?: string | null,
    compactionThreshold?: number | null,
    curateToolResults?: boolean | null,
    curateAfterTurns?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentMutationVariables = {
  input: DeleteLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null,
};

export type DeleteLLMAgentMutation = {
  deleteLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        approvalMode?: LLMMCPApprovalMode | null,
        executionMode?: LLMMCPExecutionMode | null,
        url?: string | null,
        accessToken?: string | null,
        headers?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    ragSkipChecksOnContext?: boolean | null,
    ragShadowRead?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    injectMemories?: number | null,
    injectKnowledgeGraph?: number | null,
    enableWebSearch?: boolean | null,
    linkedFileTypes?: string | null,
    thinkingDepth?: LLMThinkingDepth | null,
    enablePromptCaching?: boolean | null,
    compactionPolicy?: string | null,
    compactionThreshold?: number | null,
    curateToolResults?: boolean | null,
    curateAfterTurns?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentMCPMutationVariables = {
  input: CreateLLMAgentMCPInput,
  condition?: ModelLLMAgentMCPConditionInput | null,
};

export type CreateLLMAgentMCPMutation = {
  createLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    approvalMode?: LLMMCPApprovalMode | null,
    executionMode?: LLMMCPExecutionMode | null,
    url?: string | null,
    accessToken?: string | null,
    headers?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentMCPMutationVariables = {
  input: UpdateLLMAgentMCPInput,
  condition?: ModelLLMAgentMCPConditionInput | null,
};

export type UpdateLLMAgentMCPMutation = {
  updateLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    approvalMode?: LLMMCPApprovalMode | null,
    executionMode?: LLMMCPExecutionMode | null,
    url?: string | null,
    accessToken?: string | null,
    headers?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentMCPMutationVariables = {
  input: DeleteLLMAgentMCPInput,
  condition?: ModelLLMAgentMCPConditionInput | null,
};

export type DeleteLLMAgentMCPMutation = {
  deleteLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    approvalMode?: LLMMCPApprovalMode | null,
    executionMode?: LLMMCPExecutionMode | null,
    url?: string | null,
    accessToken?: string | null,
    headers?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentDocumentMutationVariables = {
  input: CreateLLMAgentDocumentInput,
  condition?: ModelLLMAgentDocumentConditionInput | null,
};

export type CreateLLMAgentDocumentMutation = {
  createLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentDocumentMutationVariables = {
  input: UpdateLLMAgentDocumentInput,
  condition?: ModelLLMAgentDocumentConditionInput | null,
};

export type UpdateLLMAgentDocumentMutation = {
  updateLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentDocumentMutationVariables = {
  input: DeleteLLMAgentDocumentInput,
  condition?: ModelLLMAgentDocumentConditionInput | null,
};

export type DeleteLLMAgentDocumentMutation = {
  deleteLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMOpenAIAgentDocumentMutationVariables = {
  input: CreateLLMOpenAIAgentDocumentInput,
  condition?: ModelLLMOpenAIAgentDocumentConditionInput | null,
};

export type CreateLLMOpenAIAgentDocumentMutation = {
  createLLMOpenAIAgentDocument?:  {
    __typename: "LLMOpenAIAgentDocument",
    id: string,
    projectId: string,
    projectBackend: string,
    documentId: string,
    agentId?: string | null,
    backend: string,
    status: string,
    vectorStoreId?: string | null,
    openaiFileIds?: Array< string | null > | null,
    sourceType?: string | null,
    sourceLocation?: string | null,
    fileName?: string | null,
    fileType?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    chunkCount?: number | null,
    providerVersion?: string | null,
    lastError?: string | null,
    createdAt: string,
    updatedAt: string,
    readyAt?: string | null,
    deletedAt?: string | null,
  } | null,
};

export type UpdateLLMOpenAIAgentDocumentMutationVariables = {
  input: UpdateLLMOpenAIAgentDocumentInput,
  condition?: ModelLLMOpenAIAgentDocumentConditionInput | null,
};

export type UpdateLLMOpenAIAgentDocumentMutation = {
  updateLLMOpenAIAgentDocument?:  {
    __typename: "LLMOpenAIAgentDocument",
    id: string,
    projectId: string,
    projectBackend: string,
    documentId: string,
    agentId?: string | null,
    backend: string,
    status: string,
    vectorStoreId?: string | null,
    openaiFileIds?: Array< string | null > | null,
    sourceType?: string | null,
    sourceLocation?: string | null,
    fileName?: string | null,
    fileType?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    chunkCount?: number | null,
    providerVersion?: string | null,
    lastError?: string | null,
    createdAt: string,
    updatedAt: string,
    readyAt?: string | null,
    deletedAt?: string | null,
  } | null,
};

export type DeleteLLMOpenAIAgentDocumentMutationVariables = {
  input: DeleteLLMOpenAIAgentDocumentInput,
  condition?: ModelLLMOpenAIAgentDocumentConditionInput | null,
};

export type DeleteLLMOpenAIAgentDocumentMutation = {
  deleteLLMOpenAIAgentDocument?:  {
    __typename: "LLMOpenAIAgentDocument",
    id: string,
    projectId: string,
    projectBackend: string,
    documentId: string,
    agentId?: string | null,
    backend: string,
    status: string,
    vectorStoreId?: string | null,
    openaiFileIds?: Array< string | null > | null,
    sourceType?: string | null,
    sourceLocation?: string | null,
    fileName?: string | null,
    fileType?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    chunkCount?: number | null,
    providerVersion?: string | null,
    lastError?: string | null,
    createdAt: string,
    updatedAt: string,
    readyAt?: string | null,
    deletedAt?: string | null,
  } | null,
};

export type CreateLLMConversationMutationVariables = {
  input: CreateLLMConversationInput,
  condition?: ModelLLMConversationConditionInput | null,
};

export type CreateLLMConversationMutation = {
  createLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    endedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMConversationMutationVariables = {
  input: UpdateLLMConversationInput,
  condition?: ModelLLMConversationConditionInput | null,
};

export type UpdateLLMConversationMutation = {
  updateLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    endedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMConversationMutationVariables = {
  input: DeleteLLMConversationInput,
  condition?: ModelLLMConversationConditionInput | null,
};

export type DeleteLLMConversationMutation = {
  deleteLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    endedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMModelMutationVariables = {
  input: CreateLLMModelInput,
  condition?: ModelLLMModelConditionInput | null,
};

export type CreateLLMModelMutation = {
  createLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host: string,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    supportsSearch?: boolean | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    defaultServiceGroup?: string | null,
    defaultEnabled?: boolean | null,
    displayOrder?: number | null,
    recommendedUseCase?: string | null,
    performanceRating?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMModelMutationVariables = {
  input: UpdateLLMModelInput,
  condition?: ModelLLMModelConditionInput | null,
};

export type UpdateLLMModelMutation = {
  updateLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host: string,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    supportsSearch?: boolean | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    defaultServiceGroup?: string | null,
    defaultEnabled?: boolean | null,
    displayOrder?: number | null,
    recommendedUseCase?: string | null,
    performanceRating?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMModelMutationVariables = {
  input: DeleteLLMModelInput,
  condition?: ModelLLMModelConditionInput | null,
};

export type DeleteLLMModelMutation = {
  deleteLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host: string,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    supportsSearch?: boolean | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    defaultServiceGroup?: string | null,
    defaultEnabled?: boolean | null,
    displayOrder?: number | null,
    recommendedUseCase?: string | null,
    performanceRating?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMProviderMutationVariables = {
  input: CreateLLMProviderInput,
  condition?: ModelLLMProviderConditionInput | null,
};

export type CreateLLMProviderMutation = {
  createLLMProvider?:  {
    __typename: "LLMProvider",
    id: string,
    displayName: string,
    contactUrl?: string | null,
    description?: string | null,
    defaultIsModerated?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateLLMProviderMutationVariables = {
  input: UpdateLLMProviderInput,
  condition?: ModelLLMProviderConditionInput | null,
};

export type UpdateLLMProviderMutation = {
  updateLLMProvider?:  {
    __typename: "LLMProvider",
    id: string,
    displayName: string,
    contactUrl?: string | null,
    description?: string | null,
    defaultIsModerated?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteLLMProviderMutationVariables = {
  input: DeleteLLMProviderInput,
  condition?: ModelLLMProviderConditionInput | null,
};

export type DeleteLLMProviderMutation = {
  deleteLLMProvider?:  {
    __typename: "LLMProvider",
    id: string,
    displayName: string,
    contactUrl?: string | null,
    description?: string | null,
    defaultIsModerated?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateLLMOpenRouterModelMutationVariables = {
  input: CreateLLMOpenRouterModelInput,
  condition?: ModelLLMOpenRouterModelConditionInput | null,
};

export type CreateLLMOpenRouterModelMutation = {
  createLLMOpenRouterModel?:  {
    __typename: "LLMOpenRouterModel",
    id: string,
    providerId: string,
    provider?:  {
      __typename: "LLMProvider",
      id: string,
      displayName: string,
      contactUrl?: string | null,
      description?: string | null,
      defaultIsModerated?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    canonicalSlug?: string | null,
    name: string,
    description?: string | null,
    tokenizer?: string | null,
    instructType?: string | null,
    contextLength?: number | null,
    maxCompletionTokens?: number | null,
    isModerated?: boolean | null,
    architectureModality?: string | null,
    architectureInputModalities?: string | null,
    architectureOutputModalities?: string | null,
    supportedParameters?: string | null,
    defaultParameters?: string | null,
    huggingFaceId?: string | null,
    latestPricingSnapshotId?: string | null,
    isDeprecated?: boolean | null,
    deprecatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateLLMOpenRouterModelMutationVariables = {
  input: UpdateLLMOpenRouterModelInput,
  condition?: ModelLLMOpenRouterModelConditionInput | null,
};

export type UpdateLLMOpenRouterModelMutation = {
  updateLLMOpenRouterModel?:  {
    __typename: "LLMOpenRouterModel",
    id: string,
    providerId: string,
    provider?:  {
      __typename: "LLMProvider",
      id: string,
      displayName: string,
      contactUrl?: string | null,
      description?: string | null,
      defaultIsModerated?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    canonicalSlug?: string | null,
    name: string,
    description?: string | null,
    tokenizer?: string | null,
    instructType?: string | null,
    contextLength?: number | null,
    maxCompletionTokens?: number | null,
    isModerated?: boolean | null,
    architectureModality?: string | null,
    architectureInputModalities?: string | null,
    architectureOutputModalities?: string | null,
    supportedParameters?: string | null,
    defaultParameters?: string | null,
    huggingFaceId?: string | null,
    latestPricingSnapshotId?: string | null,
    isDeprecated?: boolean | null,
    deprecatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteLLMOpenRouterModelMutationVariables = {
  input: DeleteLLMOpenRouterModelInput,
  condition?: ModelLLMOpenRouterModelConditionInput | null,
};

export type DeleteLLMOpenRouterModelMutation = {
  deleteLLMOpenRouterModel?:  {
    __typename: "LLMOpenRouterModel",
    id: string,
    providerId: string,
    provider?:  {
      __typename: "LLMProvider",
      id: string,
      displayName: string,
      contactUrl?: string | null,
      description?: string | null,
      defaultIsModerated?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    canonicalSlug?: string | null,
    name: string,
    description?: string | null,
    tokenizer?: string | null,
    instructType?: string | null,
    contextLength?: number | null,
    maxCompletionTokens?: number | null,
    isModerated?: boolean | null,
    architectureModality?: string | null,
    architectureInputModalities?: string | null,
    architectureOutputModalities?: string | null,
    supportedParameters?: string | null,
    defaultParameters?: string | null,
    huggingFaceId?: string | null,
    latestPricingSnapshotId?: string | null,
    isDeprecated?: boolean | null,
    deprecatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateLLMModelPricingSnapshotMutationVariables = {
  input: CreateLLMModelPricingSnapshotInput,
  condition?: ModelLLMModelPricingSnapshotConditionInput | null,
};

export type CreateLLMModelPricingSnapshotMutation = {
  createLLMModelPricingSnapshot?:  {
    __typename: "LLMModelPricingSnapshot",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    source: LLMModelPricingSource,
    fetchedAt: string,
    currency: string,
    promptTokenUsdNano?: string | null,
    completionTokenUsdNano?: string | null,
    cacheReadTokenUsdNano?: string | null,
    cacheWriteTokenUsdNano?: string | null,
    reasoningTokenUsdNano?: string | null,
    webSearchUsdNano?: string | null,
    requestUsdNano?: string | null,
    imageUsdNano?: string | null,
    audioUsdNano?: string | null,
    internalNotes?: string | null,
    isCurrent?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateLLMModelPricingSnapshotMutationVariables = {
  input: UpdateLLMModelPricingSnapshotInput,
  condition?: ModelLLMModelPricingSnapshotConditionInput | null,
};

export type UpdateLLMModelPricingSnapshotMutation = {
  updateLLMModelPricingSnapshot?:  {
    __typename: "LLMModelPricingSnapshot",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    source: LLMModelPricingSource,
    fetchedAt: string,
    currency: string,
    promptTokenUsdNano?: string | null,
    completionTokenUsdNano?: string | null,
    cacheReadTokenUsdNano?: string | null,
    cacheWriteTokenUsdNano?: string | null,
    reasoningTokenUsdNano?: string | null,
    webSearchUsdNano?: string | null,
    requestUsdNano?: string | null,
    imageUsdNano?: string | null,
    audioUsdNano?: string | null,
    internalNotes?: string | null,
    isCurrent?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteLLMModelPricingSnapshotMutationVariables = {
  input: DeleteLLMModelPricingSnapshotInput,
  condition?: ModelLLMModelPricingSnapshotConditionInput | null,
};

export type DeleteLLMModelPricingSnapshotMutation = {
  deleteLLMModelPricingSnapshot?:  {
    __typename: "LLMModelPricingSnapshot",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    source: LLMModelPricingSource,
    fetchedAt: string,
    currency: string,
    promptTokenUsdNano?: string | null,
    completionTokenUsdNano?: string | null,
    cacheReadTokenUsdNano?: string | null,
    cacheWriteTokenUsdNano?: string | null,
    reasoningTokenUsdNano?: string | null,
    webSearchUsdNano?: string | null,
    requestUsdNano?: string | null,
    imageUsdNano?: string | null,
    audioUsdNano?: string | null,
    internalNotes?: string | null,
    isCurrent?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateLLMModelCapabilityMutationVariables = {
  input: CreateLLMModelCapabilityInput,
  condition?: ModelLLMModelCapabilityConditionInput | null,
};

export type CreateLLMModelCapabilityMutation = {
  createLLMModelCapability?:  {
    __typename: "LLMModelCapability",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    category: string,
    value: string,
    metadata?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateLLMModelCapabilityMutationVariables = {
  input: UpdateLLMModelCapabilityInput,
  condition?: ModelLLMModelCapabilityConditionInput | null,
};

export type UpdateLLMModelCapabilityMutation = {
  updateLLMModelCapability?:  {
    __typename: "LLMModelCapability",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    category: string,
    value: string,
    metadata?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteLLMModelCapabilityMutationVariables = {
  input: DeleteLLMModelCapabilityInput,
  condition?: ModelLLMModelCapabilityConditionInput | null,
};

export type DeleteLLMModelCapabilityMutation = {
  deleteLLMModelCapability?:  {
    __typename: "LLMModelCapability",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    category: string,
    value: string,
    metadata?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateLLMScheduledPromptMutationVariables = {
  input: CreateLLMScheduledPromptInput,
  condition?: ModelLLMScheduledPromptConditionInput | null,
};

export type CreateLLMScheduledPromptMutation = {
  createLLMScheduledPrompt?:  {
    __typename: "LLMScheduledPrompt",
    id: string,
    projectId: string,
    status: LLMScheduledPromptStatus,
    agentId: string,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    data?: string | null,
    prompt: string,
    scheduledAt: string,
    priorScheduledPromptId?: string | null,
    nextScheduledPromptId?: string | null,
    processedAt?: string | null,
    response?: string | null,
    failedTimes?: number | null,
    errorMessage?: string | null,
    notificationEmailAddresses?: string | null,
    notificationEmailSubject?: string | null,
    repeatIntervalHours?: number | null,
    followOnAgentId?: string | null,
    followOnFollowOnAgentId?: string | null,
    followOnTitle?: string | null,
    followOnPrompt?: string | null,
    followOnScheduledAtHours?: number | null,
    followOnNotificationEmailAddresses?: string | null,
    followOnNotificationEmailSubject?: string | null,
    followOnRepeatIntervalHours?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMScheduledPromptMutationVariables = {
  input: UpdateLLMScheduledPromptInput,
  condition?: ModelLLMScheduledPromptConditionInput | null,
};

export type UpdateLLMScheduledPromptMutation = {
  updateLLMScheduledPrompt?:  {
    __typename: "LLMScheduledPrompt",
    id: string,
    projectId: string,
    status: LLMScheduledPromptStatus,
    agentId: string,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    data?: string | null,
    prompt: string,
    scheduledAt: string,
    priorScheduledPromptId?: string | null,
    nextScheduledPromptId?: string | null,
    processedAt?: string | null,
    response?: string | null,
    failedTimes?: number | null,
    errorMessage?: string | null,
    notificationEmailAddresses?: string | null,
    notificationEmailSubject?: string | null,
    repeatIntervalHours?: number | null,
    followOnAgentId?: string | null,
    followOnFollowOnAgentId?: string | null,
    followOnTitle?: string | null,
    followOnPrompt?: string | null,
    followOnScheduledAtHours?: number | null,
    followOnNotificationEmailAddresses?: string | null,
    followOnNotificationEmailSubject?: string | null,
    followOnRepeatIntervalHours?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMScheduledPromptMutationVariables = {
  input: DeleteLLMScheduledPromptInput,
  condition?: ModelLLMScheduledPromptConditionInput | null,
};

export type DeleteLLMScheduledPromptMutation = {
  deleteLLMScheduledPrompt?:  {
    __typename: "LLMScheduledPrompt",
    id: string,
    projectId: string,
    status: LLMScheduledPromptStatus,
    agentId: string,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    data?: string | null,
    prompt: string,
    scheduledAt: string,
    priorScheduledPromptId?: string | null,
    nextScheduledPromptId?: string | null,
    processedAt?: string | null,
    response?: string | null,
    failedTimes?: number | null,
    errorMessage?: string | null,
    notificationEmailAddresses?: string | null,
    notificationEmailSubject?: string | null,
    repeatIntervalHours?: number | null,
    followOnAgentId?: string | null,
    followOnFollowOnAgentId?: string | null,
    followOnTitle?: string | null,
    followOnPrompt?: string | null,
    followOnScheduledAtHours?: number | null,
    followOnNotificationEmailAddresses?: string | null,
    followOnNotificationEmailSubject?: string | null,
    followOnRepeatIntervalHours?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMTriggerMutationVariables = {
  input: CreateLLMTriggerInput,
  condition?: ModelLLMTriggerConditionInput | null,
};

export type CreateLLMTriggerMutation = {
  createLLMTrigger?:  {
    __typename: "LLMTrigger",
    id: string,
    projectId: string,
    status: LLMTriggerStatus,
    triggerType: string,
    scheduledPromptId?: string | null,
    scheduledPrompt?:  {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMTriggerMutationVariables = {
  input: UpdateLLMTriggerInput,
  condition?: ModelLLMTriggerConditionInput | null,
};

export type UpdateLLMTriggerMutation = {
  updateLLMTrigger?:  {
    __typename: "LLMTrigger",
    id: string,
    projectId: string,
    status: LLMTriggerStatus,
    triggerType: string,
    scheduledPromptId?: string | null,
    scheduledPrompt?:  {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMTriggerMutationVariables = {
  input: DeleteLLMTriggerInput,
  condition?: ModelLLMTriggerConditionInput | null,
};

export type DeleteLLMTriggerMutation = {
  deleteLLMTrigger?:  {
    __typename: "LLMTrigger",
    id: string,
    projectId: string,
    status: LLMTriggerStatus,
    triggerType: string,
    scheduledPromptId?: string | null,
    scheduledPrompt?:  {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMMemoryMutationVariables = {
  input: CreateLLMMemoryInput,
  condition?: ModelLLMMemoryConditionInput | null,
};

export type CreateLLMMemoryMutation = {
  createLLMMemory?:  {
    __typename: "LLMMemory",
    id: string,
    projectId: string,
    status: string,
    entityType: LLMMemoryEntityType,
    customerId?: string | null,
    agentId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    key: string,
    data: string,
    tags?: Array< string | null > | null,
    memoryType: LLMMemoryType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMMemoryMutationVariables = {
  input: UpdateLLMMemoryInput,
  condition?: ModelLLMMemoryConditionInput | null,
};

export type UpdateLLMMemoryMutation = {
  updateLLMMemory?:  {
    __typename: "LLMMemory",
    id: string,
    projectId: string,
    status: string,
    entityType: LLMMemoryEntityType,
    customerId?: string | null,
    agentId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    key: string,
    data: string,
    tags?: Array< string | null > | null,
    memoryType: LLMMemoryType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMMemoryMutationVariables = {
  input: DeleteLLMMemoryInput,
  condition?: ModelLLMMemoryConditionInput | null,
};

export type DeleteLLMMemoryMutation = {
  deleteLLMMemory?:  {
    __typename: "LLMMemory",
    id: string,
    projectId: string,
    status: string,
    entityType: LLMMemoryEntityType,
    customerId?: string | null,
    agentId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    key: string,
    data: string,
    tags?: Array< string | null > | null,
    memoryType: LLMMemoryType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMKnowledgeGraphMutationVariables = {
  input: CreateLLMKnowledgeGraphInput,
  condition?: ModelLLMKnowledgeGraphConditionInput | null,
};

export type CreateLLMKnowledgeGraphMutation = {
  createLLMKnowledgeGraph?:  {
    __typename: "LLMKnowledgeGraph",
    id: string,
    projectId: string,
    customerId: string,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    status: LLMKnowledgeGraphStatus,
    version: number,
    title?: string | null,
    description?: string | null,
    graphData: string,
    memoryCount?: number | null,
    generatedFromMemoryIds?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMKnowledgeGraphMutationVariables = {
  input: UpdateLLMKnowledgeGraphInput,
  condition?: ModelLLMKnowledgeGraphConditionInput | null,
};

export type UpdateLLMKnowledgeGraphMutation = {
  updateLLMKnowledgeGraph?:  {
    __typename: "LLMKnowledgeGraph",
    id: string,
    projectId: string,
    customerId: string,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    status: LLMKnowledgeGraphStatus,
    version: number,
    title?: string | null,
    description?: string | null,
    graphData: string,
    memoryCount?: number | null,
    generatedFromMemoryIds?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMKnowledgeGraphMutationVariables = {
  input: DeleteLLMKnowledgeGraphInput,
  condition?: ModelLLMKnowledgeGraphConditionInput | null,
};

export type DeleteLLMKnowledgeGraphMutation = {
  deleteLLMKnowledgeGraph?:  {
    __typename: "LLMKnowledgeGraph",
    id: string,
    projectId: string,
    customerId: string,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    status: LLMKnowledgeGraphStatus,
    version: number,
    title?: string | null,
    description?: string | null,
    graphData: string,
    memoryCount?: number | null,
    generatedFromMemoryIds?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentValidationMutationVariables = {
  input: CreateLLMAgentValidationInput,
  condition?: ModelLLMAgentValidationConditionInput | null,
};

export type CreateLLMAgentValidationMutation = {
  createLLMAgentValidation?:  {
    __typename: "LLMAgentValidation",
    id: string,
    projectId: string,
    agentId: string,
    name?: string | null,
    description?: string | null,
    operator: ValidationOperator,
    expectedValue?: string | null,
    customPromptTemplate?: string | null,
    status: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentValidationMutationVariables = {
  input: UpdateLLMAgentValidationInput,
  condition?: ModelLLMAgentValidationConditionInput | null,
};

export type UpdateLLMAgentValidationMutation = {
  updateLLMAgentValidation?:  {
    __typename: "LLMAgentValidation",
    id: string,
    projectId: string,
    agentId: string,
    name?: string | null,
    description?: string | null,
    operator: ValidationOperator,
    expectedValue?: string | null,
    customPromptTemplate?: string | null,
    status: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentValidationMutationVariables = {
  input: DeleteLLMAgentValidationInput,
  condition?: ModelLLMAgentValidationConditionInput | null,
};

export type DeleteLLMAgentValidationMutation = {
  deleteLLMAgentValidation?:  {
    __typename: "LLMAgentValidation",
    id: string,
    projectId: string,
    agentId: string,
    name?: string | null,
    description?: string | null,
    operator: ValidationOperator,
    expectedValue?: string | null,
    customPromptTemplate?: string | null,
    status: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetLLMProjectQueryVariables = {
  id: string,
};

export type GetLLMProjectQuery = {
  getLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          logGenerationCursor?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          mcpServerWhitelist?: string | null,
          automaticModelManagement?: boolean | null,
          supersmallGroupModels?: string | null,
          standardGroupModels?: string | null,
          premiumGroupModels?: string | null,
          reasoningGroupModels?: string | null,
          superpremiumGroupModels?: string | null,
          openrouterStandardGroupModels?: string | null,
          openrouterPremiumGroupModels?: string | null,
          azureOpenaiBaseUrl?: string | null,
          azureOpenaiApiVersion?: string | null,
          awsBedrockRegion?: string | null,
          newCustomerUsageTierId?: string | null,
          usageTapUsageApiKey?: string | null,
          lowApiCreditNotificationEmails?: string | null,
          lowApiCreditNotificationMinimumCredit?: number | null,
          lastLowApiCreditNotificationSentAt?: string | null,
          integrationApiKey1Hash?: string | null,
          integrationApiKey1Status?: string | null,
          integrationApiKey1Prefix?: string | null,
          integrationApiKey1LastRotatedAt?: string | null,
          integrationApiKey1Scopes?: Array< string > | null,
          integrationApiKey2Hash?: string | null,
          integrationApiKey2Status?: string | null,
          integrationApiKey2Prefix?: string | null,
          integrationApiKey2LastRotatedAt?: string | null,
          integrationApiKey2Scopes?: Array< string > | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    logGenerationCursor?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    mcpServerWhitelist?: string | null,
    automaticModelManagement?: boolean | null,
    supersmallGroupModels?: string | null,
    standardGroupModels?: string | null,
    premiumGroupModels?: string | null,
    reasoningGroupModels?: string | null,
    superpremiumGroupModels?: string | null,
    openrouterStandardGroupModels?: string | null,
    openrouterPremiumGroupModels?: string | null,
    azureOpenaiBaseUrl?: string | null,
    azureOpenaiApiVersion?: string | null,
    awsBedrockRegion?: string | null,
    newCustomerUsageTierId?: string | null,
    newCustomerUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usageTapUsageApiKey?: string | null,
    lowApiCreditNotificationEmails?: string | null,
    lowApiCreditNotificationMinimumCredit?: number | null,
    lastLowApiCreditNotificationSentAt?: string | null,
    integrationApiKey1Hash?: string | null,
    integrationApiKey1Status?: string | null,
    integrationApiKey1Prefix?: string | null,
    integrationApiKey1LastRotatedAt?: string | null,
    integrationApiKey1Scopes?: Array< string > | null,
    integrationApiKey2Hash?: string | null,
    integrationApiKey2Status?: string | null,
    integrationApiKey2Prefix?: string | null,
    integrationApiKey2LastRotatedAt?: string | null,
    integrationApiKey2Scopes?: Array< string > | null,
    updatedAt: string,
  } | null,
};

export type ListLLMProjectsQueryVariables = {
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMProjectsQuery = {
  listLLMProjects?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByLogIntervalAndLastLogGeneratedAtQueryVariables = {
  logInterval: string,
  lastLogGeneratedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByLogIntervalAndLastLogGeneratedAtQuery = {
  projectsByLogIntervalAndLastLogGeneratedAt?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByRandomGroupAndCreatedAtQueryVariables = {
  randomGroup: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByRandomGroupAndCreatedAtQuery = {
  projectsByRandomGroupAndCreatedAt?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByRandomGroupAndSummaryEmailPeriodQueryVariables = {
  randomGroup: number,
  summaryEmailPeriod?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByRandomGroupAndSummaryEmailPeriodQuery = {
  projectsByRandomGroupAndSummaryEmailPeriod?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByIntegrationApiKey1HashQueryVariables = {
  integrationApiKey1Hash: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByIntegrationApiKey1HashQuery = {
  projectsByIntegrationApiKey1Hash?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByIntegrationApiKey2HashQueryVariables = {
  integrationApiKey2Hash: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByIntegrationApiKey2HashQuery = {
  projectsByIntegrationApiKey2Hash?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMUsageTierQueryVariables = {
  id: string,
};

export type GetLLMUsageTierQuery = {
  getLLMUsageTier?:  {
    __typename: "LLMUsageTier",
    id: string,
    projectId: string,
    status: LLMUsageTierStatus,
    name: string,
    description?: string | null,
    version: number,
    activeAt?: string | null,
    inactiveAt?: string | null,
    priorUsageTierId?: string | null,
    priorUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    baseUsageTierId?: string | null,
    baseUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    replenishmentPeriod?: LLMPeriod | null,
    replenishmentMethod?: LLMReplenishmentMethod | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokenReplenishmentAmount?: number | null,
    premiumTokenReplenishmentAmount?: number | null,
    superPremiumTokenReplenishmentAmount?: number | null,
    reasoningTokenReplenishmentAmount?: number | null,
    standardCallReplenishmentAmount?: number | null,
    premiumCallReplenishmentAmount?: number | null,
    superPremiumCallReplenishmentAmount?: number | null,
    reasoningCallReplenishmentAmount?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMUsageTiersQueryVariables = {
  filter?: ModelLLMUsageTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMUsageTiersQuery = {
  listLLMUsageTiers?:  {
    __typename: "ModelLLMUsageTierConnection",
    items:  Array< {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsageTiersByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMUsageTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsageTiersByProjectIdQuery = {
  usageTiersByProjectId?:  {
    __typename: "ModelLLMUsageTierConnection",
    items:  Array< {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsageTiersByBaseUsageTierIdAndVersionQueryVariables = {
  baseUsageTierId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMUsageTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsageTiersByBaseUsageTierIdAndVersionQuery = {
  usageTiersByBaseUsageTierIdAndVersion?:  {
    __typename: "ModelLLMUsageTierConnection",
    items:  Array< {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMProjectSubscriptionQueryVariables = {
  id: string,
};

export type GetLLMProjectSubscriptionQuery = {
  getLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMProjectSubscriptionsQueryVariables = {
  filter?: ModelLLMProjectSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMProjectSubscriptionsQuery = {
  listLLMProjectSubscriptions?:  {
    __typename: "ModelLLMProjectSubscriptionConnection",
    items:  Array< {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMUserQueryVariables = {
  id: string,
};

export type GetLLMUserQuery = {
  getLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      logGenerationCursor?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      mcpServerWhitelist?: string | null,
      automaticModelManagement?: boolean | null,
      supersmallGroupModels?: string | null,
      standardGroupModels?: string | null,
      premiumGroupModels?: string | null,
      reasoningGroupModels?: string | null,
      superpremiumGroupModels?: string | null,
      openrouterStandardGroupModels?: string | null,
      openrouterPremiumGroupModels?: string | null,
      azureOpenaiBaseUrl?: string | null,
      azureOpenaiApiVersion?: string | null,
      awsBedrockRegion?: string | null,
      newCustomerUsageTierId?: string | null,
      newCustomerUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      usageTapUsageApiKey?: string | null,
      lowApiCreditNotificationEmails?: string | null,
      lowApiCreditNotificationMinimumCredit?: number | null,
      lastLowApiCreditNotificationSentAt?: string | null,
      integrationApiKey1Hash?: string | null,
      integrationApiKey1Status?: string | null,
      integrationApiKey1Prefix?: string | null,
      integrationApiKey1LastRotatedAt?: string | null,
      integrationApiKey1Scopes?: Array< string > | null,
      integrationApiKey2Hash?: string | null,
      integrationApiKey2Status?: string | null,
      integrationApiKey2Prefix?: string | null,
      integrationApiKey2LastRotatedAt?: string | null,
      integrationApiKey2Scopes?: Array< string > | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMUsersQueryVariables = {
  filter?: ModelLLMUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMUsersQuery = {
  listLLMUsers?:  {
    __typename: "ModelLLMUserConnection",
    items:  Array< {
      __typename: "LLMUser",
      id: string,
      email: string,
      status: string,
      displayName?: string | null,
      acceptedTermsOfService?: boolean | null,
      acceptedGDPRTerms?: boolean | null,
      projectId: string,
      project?:  {
        __typename: "LLMProject",
        id: string,
        name: string,
        status: string,
        description?: string | null,
        users?:  {
          __typename: "ModelLLMUserConnection",
          nextToken?: string | null,
        } | null,
        services?:  {
          __typename: "ModelLLMServiceConnection",
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        subscription?:  {
          __typename: "LLMProjectSubscription",
          id: string,
          projectId?: string | null,
          quantity?: number | null,
          subscriptionId?: string | null,
          subscriptionStartDate?: string | null,
          subscriptionEndDate?: string | null,
          subscriptionStatus?: string | null,
          subscriptionProduct?: string | null,
          subscriptionInterval?: string | null,
          subscriptionEndedAt?: string | null,
          subscriptionCancelAtPeriodEnd?: string | null,
          usageSubscriptionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        newCustomerTokenCount?: number | null,
        cacheResponsesForSeconds?: number | null,
        loadSheddingTier: number,
        newCustomerLoadSheddingTier?: number | null,
        maintenanceMode: boolean,
        maintenanceModeMessage?: string | null,
        loadBalancingMode: string,
        piiRedactionScope?: string | null,
        systemInstructions?: string | null,
        piiScope?: string | null,
        piiGroupId?: string | null,
        piiMessage?: string | null,
        promptBlacklist?: string | null,
        blacklistGroupId?: string | null,
        blacklistMessage?: string | null,
        safety?: number | null,
        safetyGroupId?: string | null,
        safetyMessage?: string | null,
        strongModelGroupId?: string | null,
        routeModel?: string | null,
        trialTokensRemaining?: number | null,
        logfileRetentionPeriod?: number | null,
        callRetentionPeriod?: number | null,
        logInterval?: string | null,
        lastLogGeneratedAt?: string | null,
        logGenerationCursor?: string | null,
        enterpriseAllowChat?: boolean | null,
        enterpriseAcceptableUsePolicy?: string | null,
        enterpriseAccessRequestEmail?: string | null,
        enterpriseSupportEmail?: string | null,
        enterpriseDomainWhitelist?: string | null,
        enterpriseTokenBudget?: number | null,
        enterpriseTokenBudgetPeriod?: string | null,
        enterpriseImageUrl?: string | null,
        randomGroup?: number | null,
        apiCreditRemaining?: number | null,
        createdAt: string,
        summaryEmailPeriod?: number | null,
        summaryEmailAddresses?: string | null,
        lastSummaryEmailSentAt?: string | null,
        mcpServerWhitelist?: string | null,
        automaticModelManagement?: boolean | null,
        supersmallGroupModels?: string | null,
        standardGroupModels?: string | null,
        premiumGroupModels?: string | null,
        reasoningGroupModels?: string | null,
        superpremiumGroupModels?: string | null,
        openrouterStandardGroupModels?: string | null,
        openrouterPremiumGroupModels?: string | null,
        azureOpenaiBaseUrl?: string | null,
        azureOpenaiApiVersion?: string | null,
        awsBedrockRegion?: string | null,
        newCustomerUsageTierId?: string | null,
        newCustomerUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        usageTapUsageApiKey?: string | null,
        lowApiCreditNotificationEmails?: string | null,
        lowApiCreditNotificationMinimumCredit?: number | null,
        lastLowApiCreditNotificationSentAt?: string | null,
        integrationApiKey1Hash?: string | null,
        integrationApiKey1Status?: string | null,
        integrationApiKey1Prefix?: string | null,
        integrationApiKey1LastRotatedAt?: string | null,
        integrationApiKey1Scopes?: Array< string > | null,
        integrationApiKey2Hash?: string | null,
        integrationApiKey2Status?: string | null,
        integrationApiKey2Prefix?: string | null,
        integrationApiKey2LastRotatedAt?: string | null,
        integrationApiKey2Scopes?: Array< string > | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailQuery = {
  usersByEmail?:  {
    __typename: "ModelLLMUserConnection",
    items:  Array< {
      __typename: "LLMUser",
      id: string,
      email: string,
      status: string,
      displayName?: string | null,
      acceptedTermsOfService?: boolean | null,
      acceptedGDPRTerms?: boolean | null,
      projectId: string,
      project?:  {
        __typename: "LLMProject",
        id: string,
        name: string,
        status: string,
        description?: string | null,
        users?:  {
          __typename: "ModelLLMUserConnection",
          nextToken?: string | null,
        } | null,
        services?:  {
          __typename: "ModelLLMServiceConnection",
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        subscription?:  {
          __typename: "LLMProjectSubscription",
          id: string,
          projectId?: string | null,
          quantity?: number | null,
          subscriptionId?: string | null,
          subscriptionStartDate?: string | null,
          subscriptionEndDate?: string | null,
          subscriptionStatus?: string | null,
          subscriptionProduct?: string | null,
          subscriptionInterval?: string | null,
          subscriptionEndedAt?: string | null,
          subscriptionCancelAtPeriodEnd?: string | null,
          usageSubscriptionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        newCustomerTokenCount?: number | null,
        cacheResponsesForSeconds?: number | null,
        loadSheddingTier: number,
        newCustomerLoadSheddingTier?: number | null,
        maintenanceMode: boolean,
        maintenanceModeMessage?: string | null,
        loadBalancingMode: string,
        piiRedactionScope?: string | null,
        systemInstructions?: string | null,
        piiScope?: string | null,
        piiGroupId?: string | null,
        piiMessage?: string | null,
        promptBlacklist?: string | null,
        blacklistGroupId?: string | null,
        blacklistMessage?: string | null,
        safety?: number | null,
        safetyGroupId?: string | null,
        safetyMessage?: string | null,
        strongModelGroupId?: string | null,
        routeModel?: string | null,
        trialTokensRemaining?: number | null,
        logfileRetentionPeriod?: number | null,
        callRetentionPeriod?: number | null,
        logInterval?: string | null,
        lastLogGeneratedAt?: string | null,
        logGenerationCursor?: string | null,
        enterpriseAllowChat?: boolean | null,
        enterpriseAcceptableUsePolicy?: string | null,
        enterpriseAccessRequestEmail?: string | null,
        enterpriseSupportEmail?: string | null,
        enterpriseDomainWhitelist?: string | null,
        enterpriseTokenBudget?: number | null,
        enterpriseTokenBudgetPeriod?: string | null,
        enterpriseImageUrl?: string | null,
        randomGroup?: number | null,
        apiCreditRemaining?: number | null,
        createdAt: string,
        summaryEmailPeriod?: number | null,
        summaryEmailAddresses?: string | null,
        lastSummaryEmailSentAt?: string | null,
        mcpServerWhitelist?: string | null,
        automaticModelManagement?: boolean | null,
        supersmallGroupModels?: string | null,
        standardGroupModels?: string | null,
        premiumGroupModels?: string | null,
        reasoningGroupModels?: string | null,
        superpremiumGroupModels?: string | null,
        openrouterStandardGroupModels?: string | null,
        openrouterPremiumGroupModels?: string | null,
        azureOpenaiBaseUrl?: string | null,
        azureOpenaiApiVersion?: string | null,
        awsBedrockRegion?: string | null,
        newCustomerUsageTierId?: string | null,
        newCustomerUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        usageTapUsageApiKey?: string | null,
        lowApiCreditNotificationEmails?: string | null,
        lowApiCreditNotificationMinimumCredit?: number | null,
        lastLowApiCreditNotificationSentAt?: string | null,
        integrationApiKey1Hash?: string | null,
        integrationApiKey1Status?: string | null,
        integrationApiKey1Prefix?: string | null,
        integrationApiKey1LastRotatedAt?: string | null,
        integrationApiKey1Scopes?: Array< string > | null,
        integrationApiKey2Hash?: string | null,
        integrationApiKey2Status?: string | null,
        integrationApiKey2Prefix?: string | null,
        integrationApiKey2LastRotatedAt?: string | null,
        integrationApiKey2Scopes?: Array< string > | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByProjectIdQuery = {
  usersByProjectId?:  {
    __typename: "ModelLLMUserConnection",
    items:  Array< {
      __typename: "LLMUser",
      id: string,
      email: string,
      status: string,
      displayName?: string | null,
      acceptedTermsOfService?: boolean | null,
      acceptedGDPRTerms?: boolean | null,
      projectId: string,
      project?:  {
        __typename: "LLMProject",
        id: string,
        name: string,
        status: string,
        description?: string | null,
        users?:  {
          __typename: "ModelLLMUserConnection",
          nextToken?: string | null,
        } | null,
        services?:  {
          __typename: "ModelLLMServiceConnection",
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        subscription?:  {
          __typename: "LLMProjectSubscription",
          id: string,
          projectId?: string | null,
          quantity?: number | null,
          subscriptionId?: string | null,
          subscriptionStartDate?: string | null,
          subscriptionEndDate?: string | null,
          subscriptionStatus?: string | null,
          subscriptionProduct?: string | null,
          subscriptionInterval?: string | null,
          subscriptionEndedAt?: string | null,
          subscriptionCancelAtPeriodEnd?: string | null,
          usageSubscriptionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        newCustomerTokenCount?: number | null,
        cacheResponsesForSeconds?: number | null,
        loadSheddingTier: number,
        newCustomerLoadSheddingTier?: number | null,
        maintenanceMode: boolean,
        maintenanceModeMessage?: string | null,
        loadBalancingMode: string,
        piiRedactionScope?: string | null,
        systemInstructions?: string | null,
        piiScope?: string | null,
        piiGroupId?: string | null,
        piiMessage?: string | null,
        promptBlacklist?: string | null,
        blacklistGroupId?: string | null,
        blacklistMessage?: string | null,
        safety?: number | null,
        safetyGroupId?: string | null,
        safetyMessage?: string | null,
        strongModelGroupId?: string | null,
        routeModel?: string | null,
        trialTokensRemaining?: number | null,
        logfileRetentionPeriod?: number | null,
        callRetentionPeriod?: number | null,
        logInterval?: string | null,
        lastLogGeneratedAt?: string | null,
        logGenerationCursor?: string | null,
        enterpriseAllowChat?: boolean | null,
        enterpriseAcceptableUsePolicy?: string | null,
        enterpriseAccessRequestEmail?: string | null,
        enterpriseSupportEmail?: string | null,
        enterpriseDomainWhitelist?: string | null,
        enterpriseTokenBudget?: number | null,
        enterpriseTokenBudgetPeriod?: string | null,
        enterpriseImageUrl?: string | null,
        randomGroup?: number | null,
        apiCreditRemaining?: number | null,
        createdAt: string,
        summaryEmailPeriod?: number | null,
        summaryEmailAddresses?: string | null,
        lastSummaryEmailSentAt?: string | null,
        mcpServerWhitelist?: string | null,
        automaticModelManagement?: boolean | null,
        supersmallGroupModels?: string | null,
        standardGroupModels?: string | null,
        premiumGroupModels?: string | null,
        reasoningGroupModels?: string | null,
        superpremiumGroupModels?: string | null,
        openrouterStandardGroupModels?: string | null,
        openrouterPremiumGroupModels?: string | null,
        azureOpenaiBaseUrl?: string | null,
        azureOpenaiApiVersion?: string | null,
        awsBedrockRegion?: string | null,
        newCustomerUsageTierId?: string | null,
        newCustomerUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        usageTapUsageApiKey?: string | null,
        lowApiCreditNotificationEmails?: string | null,
        lowApiCreditNotificationMinimumCredit?: number | null,
        lastLowApiCreditNotificationSentAt?: string | null,
        integrationApiKey1Hash?: string | null,
        integrationApiKey1Status?: string | null,
        integrationApiKey1Prefix?: string | null,
        integrationApiKey1LastRotatedAt?: string | null,
        integrationApiKey1Scopes?: Array< string > | null,
        integrationApiKey2Hash?: string | null,
        integrationApiKey2Status?: string | null,
        integrationApiKey2Prefix?: string | null,
        integrationApiKey2LastRotatedAt?: string | null,
        integrationApiKey2Scopes?: Array< string > | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMServiceQueryVariables = {
  id: string,
};

export type GetLLMServiceQuery = {
  getLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMServicesQueryVariables = {
  filter?: ModelLLMServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMServicesQuery = {
  listLLMServices?:  {
    __typename: "ModelLLMServiceConnection",
    items:  Array< {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ServicesByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ServicesByProjectIdQuery = {
  servicesByProjectId?:  {
    __typename: "ModelLLMServiceConnection",
    items:  Array< {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMGroupQueryVariables = {
  id: string,
};

export type GetLLMGroupQuery = {
  getLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMGroupsQueryVariables = {
  filter?: ModelLLMGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMGroupsQuery = {
  listLLMGroups?:  {
    __typename: "ModelLLMGroupConnection",
    items:  Array< {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GroupsByProjectIdQueryVariables = {
  projectId: string,
  order?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GroupsByProjectIdQuery = {
  groupsByProjectId?:  {
    __typename: "ModelLLMGroupConnection",
    items:  Array< {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMCustomerQueryVariables = {
  id: string,
};

export type GetLLMCustomerQuery = {
  getLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    nextReplenishAt?: string | null,
    usageTierId?: string | null,
    usageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierId?: string | null,
    nextUsageTier?:  {
      __typename: "LLMUsageTier",
      id: string,
      projectId: string,
      status: LLMUsageTierStatus,
      name: string,
      description?: string | null,
      version: number,
      activeAt?: string | null,
      inactiveAt?: string | null,
      priorUsageTierId?: string | null,
      priorUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      baseUsageTierId?: string | null,
      baseUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      replenishmentPeriod?: LLMPeriod | null,
      replenishmentMethod?: LLMReplenishmentMethod | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokenReplenishmentAmount?: number | null,
      premiumTokenReplenishmentAmount?: number | null,
      superPremiumTokenReplenishmentAmount?: number | null,
      reasoningTokenReplenishmentAmount?: number | null,
      standardCallReplenishmentAmount?: number | null,
      premiumCallReplenishmentAmount?: number | null,
      superPremiumCallReplenishmentAmount?: number | null,
      reasoningCallReplenishmentAmount?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nextUsageTierAt?: string | null,
    usageLimitAction?: LLMUsageLimitAction | null,
    standardTokensRemaining?: number | null,
    premiumTokensRemaining?: number | null,
    superPremiumTokensRemaining?: number | null,
    reasoningTokensRemaining?: number | null,
    standardCallsRemaining?: number | null,
    premiumCallsRemaining?: number | null,
    superPremiumCallsRemaining?: number | null,
    reasoningCallsRemaining?: number | null,
    standardTokenUnlimited?: boolean | null,
    premiumTokenUnlimited?: boolean | null,
    superPremiumTokenUnlimited?: boolean | null,
    reasoningTokenUnlimited?: boolean | null,
    standardCallUnlimited?: boolean | null,
    premiumCallUnlimited?: boolean | null,
    superPremiumCallUnlimited?: boolean | null,
    reasoningCallUnlimited?: boolean | null,
    updatedAt: string,
  } | null,
};

export type ListLLMCustomersQueryVariables = {
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMCustomersQuery = {
  listLLMCustomers?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByStatusQueryVariables = {
  status: string,
  nextReplenishAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByStatusQuery = {
  customersByStatus?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByProjectIdAndLastCallMadeAtQueryVariables = {
  projectId: string,
  lastCallMadeAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByProjectIdAndLastCallMadeAtQuery = {
  customersByProjectIdAndLastCallMadeAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByProjectIdAndCreatedAtQuery = {
  customersByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByProjectIdAndTokensRemainingQueryVariables = {
  projectId: string,
  tokensRemaining?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByProjectIdAndTokensRemainingQuery = {
  customersByProjectIdAndTokensRemaining?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByTokenReplenishmentPeriodAndLastReplenishedAtQueryVariables = {
  tokenReplenishmentPeriod: string,
  lastReplenishedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByTokenReplenishmentPeriodAndLastReplenishedAtQuery = {
  customersByTokenReplenishmentPeriodAndLastReplenishedAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByUsageTierIdAndNextReplenishAtQueryVariables = {
  usageTierId: string,
  nextReplenishAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByUsageTierIdAndNextReplenishAtQuery = {
  customersByUsageTierIdAndNextReplenishAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMCallQueryVariables = {
  id: string,
};

export type GetLLMCallQuery = {
  getLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    modelId?: string | null,
    model?:  {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    customer_user_id?: string | null,
    customer_user_name?: string | null,
    customer_user_email?: string | null,
    batch?: boolean | null,
    callbackUrl?: string | null,
    batchId?: string | null,
    batchCustomId?: string | null,
    batchRequest?: string | null,
    executionMode?: string | null,
    pricingMode?: string | null,
    vendorBatchId?: string | null,
    vendorResponseId?: string | null,
    vendorStatus?: string | null,
    resolvedModelId?: string | null,
    usageTapCallId?: string | null,
    usageTapStripeCustomerId?: string | null,
    error?: string | null,
    cacheReadTokens?: number | null,
    cacheWriteTokens?: number | null,
    cacheStatus?: string | null,
    compactionTriggered?: boolean | null,
    compactionTokensSaved?: number | null,
    curatedTokensSaved?: number | null,
    curatedItems?: number | null,
    updatedAt: string,
  } | null,
};

export type ListLLMCallsQueryVariables = {
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMCallsQuery = {
  listLLMCalls?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByProjectIdAndCreatedAtQuery = {
  callsByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByCustomerIdAndCreatedAtQueryVariables = {
  customerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByCustomerIdAndCreatedAtQuery = {
  callsByCustomerIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByHashAndCreatedAtQueryVariables = {
  hash: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByHashAndCreatedAtQuery = {
  callsByHashAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByRandomGroupAndCreatedAtQueryVariables = {
  randomGroup: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByRandomGroupAndCreatedAtQuery = {
  callsByRandomGroupAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByAgentIdAndCreatedAtQueryVariables = {
  agentId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByAgentIdAndCreatedAtQuery = {
  callsByAgentIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByConversationIdAndCreatedAtQueryVariables = {
  conversationId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByConversationIdAndCreatedAtQuery = {
  callsByConversationIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByBatchIdAndCreatedAtQueryVariables = {
  batchId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByBatchIdAndCreatedAtQuery = {
  callsByBatchIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      modelId?: string | null,
      model?:  {
        __typename: "LLMModel",
        id: string,
        status: string,
        vendor: string,
        host: string,
        supported: boolean,
        name: string,
        description?: string | null,
        modelKey?: string | null,
        modelKeyLatest?: string | null,
        inputTokenPrice?: number | null,
        cachedTokenPrice?: number | null,
        outputTokenPrice?: number | null,
        inputTokenBatchPrice?: number | null,
        outputTokenBatchPrice?: number | null,
        searchCost?: number | null,
        supportsSearch?: boolean | null,
        textInputSupport?: boolean | null,
        imageInputSupport?: boolean | null,
        audioInputSupport?: boolean | null,
        textOutputSupport?: boolean | null,
        imageOutputSupport?: boolean | null,
        audioOutputSupport?: boolean | null,
        thinkingSupport?: boolean | null,
        contextWindowTokens?: number | null,
        maxResponseTokens?: number | null,
        knowledgeCutoffDate?: string | null,
        lastCheckedDate?: string | null,
        supportedLanguages?: string | null,
        warningDate?: string | null,
        warningMessage?: string | null,
        deprecationDate?: string | null,
        deprecationMessage?: string | null,
        defaultServiceGroup?: string | null,
        defaultEnabled?: boolean | null,
        displayOrder?: number | null,
        recommendedUseCase?: string | null,
        performanceRating?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      customer_user_id?: string | null,
      customer_user_name?: string | null,
      customer_user_email?: string | null,
      batch?: boolean | null,
      callbackUrl?: string | null,
      batchId?: string | null,
      batchCustomId?: string | null,
      batchRequest?: string | null,
      executionMode?: string | null,
      pricingMode?: string | null,
      vendorBatchId?: string | null,
      vendorResponseId?: string | null,
      vendorStatus?: string | null,
      resolvedModelId?: string | null,
      usageTapCallId?: string | null,
      usageTapStripeCustomerId?: string | null,
      error?: string | null,
      cacheReadTokens?: number | null,
      cacheWriteTokens?: number | null,
      cacheStatus?: string | null,
      compactionTriggered?: boolean | null,
      compactionTokensSaved?: number | null,
      curatedTokensSaved?: number | null,
      curatedItems?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMBatchQueryVariables = {
  id: string,
};

export type GetLLMBatchQuery = {
  getLLMBatch?:  {
    __typename: "LLMBatch",
    id: string,
    projectId: string,
    status: string,
    vendor: string,
    vendorBatchId?: string | null,
    vendorInputFileId?: string | null,
    vendorOutputFileId?: string | null,
    vendorErrorFileId?: string | null,
    requestCount: number,
    completedCount: number,
    failedCount: number,
    nextPollAt: string,
    callbackUrl?: string | null,
    callbackSecret?: string | null,
    callbackStatus?: string | null,
    callbackAttempts?: number | null,
    callbackLastError?: string | null,
    idempotencyKeyHash?: string | null,
    requestHash?: string | null,
    error?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMBatchesQueryVariables = {
  filter?: ModelLLMBatchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMBatchesQuery = {
  listLLMBatches?:  {
    __typename: "ModelLLMBatchConnection",
    items:  Array< {
      __typename: "LLMBatch",
      id: string,
      projectId: string,
      status: string,
      vendor: string,
      vendorBatchId?: string | null,
      vendorInputFileId?: string | null,
      vendorOutputFileId?: string | null,
      vendorErrorFileId?: string | null,
      requestCount: number,
      completedCount: number,
      failedCount: number,
      nextPollAt: string,
      callbackUrl?: string | null,
      callbackSecret?: string | null,
      callbackStatus?: string | null,
      callbackAttempts?: number | null,
      callbackLastError?: string | null,
      idempotencyKeyHash?: string | null,
      requestHash?: string | null,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BatchesByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMBatchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BatchesByProjectIdAndCreatedAtQuery = {
  batchesByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMBatchConnection",
    items:  Array< {
      __typename: "LLMBatch",
      id: string,
      projectId: string,
      status: string,
      vendor: string,
      vendorBatchId?: string | null,
      vendorInputFileId?: string | null,
      vendorOutputFileId?: string | null,
      vendorErrorFileId?: string | null,
      requestCount: number,
      completedCount: number,
      failedCount: number,
      nextPollAt: string,
      callbackUrl?: string | null,
      callbackSecret?: string | null,
      callbackStatus?: string | null,
      callbackAttempts?: number | null,
      callbackLastError?: string | null,
      idempotencyKeyHash?: string | null,
      requestHash?: string | null,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BatchesByStatusAndNextPollAtQueryVariables = {
  status: string,
  nextPollAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMBatchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BatchesByStatusAndNextPollAtQuery = {
  batchesByStatusAndNextPollAt?:  {
    __typename: "ModelLLMBatchConnection",
    items:  Array< {
      __typename: "LLMBatch",
      id: string,
      projectId: string,
      status: string,
      vendor: string,
      vendorBatchId?: string | null,
      vendorInputFileId?: string | null,
      vendorOutputFileId?: string | null,
      vendorErrorFileId?: string | null,
      requestCount: number,
      completedCount: number,
      failedCount: number,
      nextPollAt: string,
      callbackUrl?: string | null,
      callbackSecret?: string | null,
      callbackStatus?: string | null,
      callbackAttempts?: number | null,
      callbackLastError?: string | null,
      idempotencyKeyHash?: string | null,
      requestHash?: string | null,
      error?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMPromptQueryVariables = {
  id: string,
};

export type GetLLMPromptQuery = {
  getLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMPromptsQueryVariables = {
  filter?: ModelLLMPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMPromptsQuery = {
  listLLMPrompts?:  {
    __typename: "ModelLLMPromptConnection",
    items:  Array< {
      __typename: "LLMPrompt",
      id: string,
      projectId: string,
      status: string,
      name: string,
      description?: string | null,
      prompt?: string | null,
      key: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromptsByProjectIdAndKeyQueryVariables = {
  projectId: string,
  key?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromptsByProjectIdAndKeyQuery = {
  promptsByProjectIdAndKey?:  {
    __typename: "ModelLLMPromptConnection",
    items:  Array< {
      __typename: "LLMPrompt",
      id: string,
      projectId: string,
      status: string,
      name: string,
      description?: string | null,
      prompt?: string | null,
      key: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMCallLogFileQueryVariables = {
  id: string,
};

export type GetLLMCallLogFileQuery = {
  getLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type ListLLMCallLogFilesQueryVariables = {
  filter?: ModelLLMCallLogFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMCallLogFilesQuery = {
  listLLMCallLogFiles?:  {
    __typename: "ModelLLMCallLogFileConnection",
    items:  Array< {
      __typename: "LLMCallLogFile",
      id: string,
      projectId: string,
      fromDate?: string | null,
      toDate?: string | null,
      chunk?: number | null,
      count?: number | null,
      status: string,
      bucket: string,
      key: string,
      url?: string | null,
      urlExpiresAt?: string | null,
      deleteFileAfter?: string | null,
      createdAt: string,
      randomGroup?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallLogFilesByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallLogFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallLogFilesByProjectIdAndCreatedAtQuery = {
  callLogFilesByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMCallLogFileConnection",
    items:  Array< {
      __typename: "LLMCallLogFile",
      id: string,
      projectId: string,
      fromDate?: string | null,
      toDate?: string | null,
      chunk?: number | null,
      count?: number | null,
      status: string,
      bucket: string,
      key: string,
      url?: string | null,
      urlExpiresAt?: string | null,
      deleteFileAfter?: string | null,
      createdAt: string,
      randomGroup?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallLogFilesByRandomGroupAndDeleteFileAfterQueryVariables = {
  randomGroup: number,
  deleteFileAfter?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallLogFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallLogFilesByRandomGroupAndDeleteFileAfterQuery = {
  callLogFilesByRandomGroupAndDeleteFileAfter?:  {
    __typename: "ModelLLMCallLogFileConnection",
    items:  Array< {
      __typename: "LLMCallLogFile",
      id: string,
      projectId: string,
      fromDate?: string | null,
      toDate?: string | null,
      chunk?: number | null,
      count?: number | null,
      status: string,
      bucket: string,
      key: string,
      url?: string | null,
      urlExpiresAt?: string | null,
      deleteFileAfter?: string | null,
      createdAt: string,
      randomGroup?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentQueryVariables = {
  id: string,
};

export type GetLLMAgentQuery = {
  getLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        approvalMode?: LLMMCPApprovalMode | null,
        executionMode?: LLMMCPExecutionMode | null,
        url?: string | null,
        accessToken?: string | null,
        headers?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    ragSkipChecksOnContext?: boolean | null,
    ragShadowRead?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    injectMemories?: number | null,
    injectKnowledgeGraph?: number | null,
    enableWebSearch?: boolean | null,
    linkedFileTypes?: string | null,
    thinkingDepth?: LLMThinkingDepth | null,
    enablePromptCaching?: boolean | null,
    compactionPolicy?: string | null,
    compactionThreshold?: number | null,
    curateToolResults?: boolean | null,
    curateAfterTurns?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentsQueryVariables = {
  filter?: ModelLLMAgentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentsQuery = {
  listLLMAgents?:  {
    __typename: "ModelLLMAgentConnection",
    items:  Array< {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentsByProjectIdQuery = {
  agentsByProjectId?:  {
    __typename: "ModelLLMAgentConnection",
    items:  Array< {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentMCPQueryVariables = {
  id: string,
};

export type GetLLMAgentMCPQuery = {
  getLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    approvalMode?: LLMMCPApprovalMode | null,
    executionMode?: LLMMCPExecutionMode | null,
    url?: string | null,
    accessToken?: string | null,
    headers?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentMCPSQueryVariables = {
  filter?: ModelLLMAgentMCPFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentMCPSQuery = {
  listLLMAgentMCPS?:  {
    __typename: "ModelLLMAgentMCPConnection",
    items:  Array< {
      __typename: "LLMAgentMCP",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      approvalMode?: LLMMCPApprovalMode | null,
      executionMode?: LLMMCPExecutionMode | null,
      url?: string | null,
      accessToken?: string | null,
      headers?: string | null,
      stdioCommand?: string | null,
      stdioArgs?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentMCPByAgentIdQueryVariables = {
  agentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentMCPFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentMCPByAgentIdQuery = {
  agentMCPByAgentId?:  {
    __typename: "ModelLLMAgentMCPConnection",
    items:  Array< {
      __typename: "LLMAgentMCP",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      approvalMode?: LLMMCPApprovalMode | null,
      executionMode?: LLMMCPExecutionMode | null,
      url?: string | null,
      accessToken?: string | null,
      headers?: string | null,
      stdioCommand?: string | null,
      stdioArgs?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentDocumentQueryVariables = {
  id: string,
};

export type GetLLMAgentDocumentQuery = {
  getLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentDocumentsQueryVariables = {
  filter?: ModelLLMAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentDocumentsQuery = {
  listLLMAgentDocuments?:  {
    __typename: "ModelLLMAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMAgentDocument",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      fileName?: string | null,
      fileSize?: string | null,
      fileType?: string | null,
      uploadDate?: string | null,
      uploader?: string | null,
      lastModifiedDate?: string | null,
      ownershipAttestation?: string | null,
      location?: string | null,
      type?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentDocumentsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentDocumentsByProjectIdQuery = {
  agentDocumentsByProjectId?:  {
    __typename: "ModelLLMAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMAgentDocument",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      fileName?: string | null,
      fileSize?: string | null,
      fileType?: string | null,
      uploadDate?: string | null,
      uploader?: string | null,
      lastModifiedDate?: string | null,
      ownershipAttestation?: string | null,
      location?: string | null,
      type?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentDocumentsByAgentIdQueryVariables = {
  agentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentDocumentsByAgentIdQuery = {
  agentDocumentsByAgentId?:  {
    __typename: "ModelLLMAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMAgentDocument",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      fileName?: string | null,
      fileSize?: string | null,
      fileType?: string | null,
      uploadDate?: string | null,
      uploader?: string | null,
      lastModifiedDate?: string | null,
      ownershipAttestation?: string | null,
      location?: string | null,
      type?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMOpenAIAgentDocumentQueryVariables = {
  id: string,
};

export type GetLLMOpenAIAgentDocumentQuery = {
  getLLMOpenAIAgentDocument?:  {
    __typename: "LLMOpenAIAgentDocument",
    id: string,
    projectId: string,
    projectBackend: string,
    documentId: string,
    agentId?: string | null,
    backend: string,
    status: string,
    vectorStoreId?: string | null,
    openaiFileIds?: Array< string | null > | null,
    sourceType?: string | null,
    sourceLocation?: string | null,
    fileName?: string | null,
    fileType?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    chunkCount?: number | null,
    providerVersion?: string | null,
    lastError?: string | null,
    createdAt: string,
    updatedAt: string,
    readyAt?: string | null,
    deletedAt?: string | null,
  } | null,
};

export type ListLLMOpenAIAgentDocumentsQueryVariables = {
  filter?: ModelLLMOpenAIAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMOpenAIAgentDocumentsQuery = {
  listLLMOpenAIAgentDocuments?:  {
    __typename: "ModelLLMOpenAIAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMOpenAIAgentDocument",
      id: string,
      projectId: string,
      projectBackend: string,
      documentId: string,
      agentId?: string | null,
      backend: string,
      status: string,
      vectorStoreId?: string | null,
      openaiFileIds?: Array< string | null > | null,
      sourceType?: string | null,
      sourceLocation?: string | null,
      fileName?: string | null,
      fileType?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      chunkCount?: number | null,
      providerVersion?: string | null,
      lastError?: string | null,
      createdAt: string,
      updatedAt: string,
      readyAt?: string | null,
      deletedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenAIAgentDocumentsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenAIAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenAIAgentDocumentsByProjectIdQuery = {
  openAIAgentDocumentsByProjectId?:  {
    __typename: "ModelLLMOpenAIAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMOpenAIAgentDocument",
      id: string,
      projectId: string,
      projectBackend: string,
      documentId: string,
      agentId?: string | null,
      backend: string,
      status: string,
      vectorStoreId?: string | null,
      openaiFileIds?: Array< string | null > | null,
      sourceType?: string | null,
      sourceLocation?: string | null,
      fileName?: string | null,
      fileType?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      chunkCount?: number | null,
      providerVersion?: string | null,
      lastError?: string | null,
      createdAt: string,
      updatedAt: string,
      readyAt?: string | null,
      deletedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenAIAgentDocumentsByProjectBackendQueryVariables = {
  projectBackend: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenAIAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenAIAgentDocumentsByProjectBackendQuery = {
  openAIAgentDocumentsByProjectBackend?:  {
    __typename: "ModelLLMOpenAIAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMOpenAIAgentDocument",
      id: string,
      projectId: string,
      projectBackend: string,
      documentId: string,
      agentId?: string | null,
      backend: string,
      status: string,
      vectorStoreId?: string | null,
      openaiFileIds?: Array< string | null > | null,
      sourceType?: string | null,
      sourceLocation?: string | null,
      fileName?: string | null,
      fileType?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      chunkCount?: number | null,
      providerVersion?: string | null,
      lastError?: string | null,
      createdAt: string,
      updatedAt: string,
      readyAt?: string | null,
      deletedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenAIAgentDocumentsByDocumentIdQueryVariables = {
  documentId: string,
  backend?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenAIAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenAIAgentDocumentsByDocumentIdQuery = {
  openAIAgentDocumentsByDocumentId?:  {
    __typename: "ModelLLMOpenAIAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMOpenAIAgentDocument",
      id: string,
      projectId: string,
      projectBackend: string,
      documentId: string,
      agentId?: string | null,
      backend: string,
      status: string,
      vectorStoreId?: string | null,
      openaiFileIds?: Array< string | null > | null,
      sourceType?: string | null,
      sourceLocation?: string | null,
      fileName?: string | null,
      fileType?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      chunkCount?: number | null,
      providerVersion?: string | null,
      lastError?: string | null,
      createdAt: string,
      updatedAt: string,
      readyAt?: string | null,
      deletedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenAIAgentDocumentsByAgentIdQueryVariables = {
  agentId: string,
  backend?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenAIAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenAIAgentDocumentsByAgentIdQuery = {
  openAIAgentDocumentsByAgentId?:  {
    __typename: "ModelLLMOpenAIAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMOpenAIAgentDocument",
      id: string,
      projectId: string,
      projectBackend: string,
      documentId: string,
      agentId?: string | null,
      backend: string,
      status: string,
      vectorStoreId?: string | null,
      openaiFileIds?: Array< string | null > | null,
      sourceType?: string | null,
      sourceLocation?: string | null,
      fileName?: string | null,
      fileType?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      chunkCount?: number | null,
      providerVersion?: string | null,
      lastError?: string | null,
      createdAt: string,
      updatedAt: string,
      readyAt?: string | null,
      deletedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenAIAgentDocumentsByStatusQueryVariables = {
  status: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenAIAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenAIAgentDocumentsByStatusQuery = {
  openAIAgentDocumentsByStatus?:  {
    __typename: "ModelLLMOpenAIAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMOpenAIAgentDocument",
      id: string,
      projectId: string,
      projectBackend: string,
      documentId: string,
      agentId?: string | null,
      backend: string,
      status: string,
      vectorStoreId?: string | null,
      openaiFileIds?: Array< string | null > | null,
      sourceType?: string | null,
      sourceLocation?: string | null,
      fileName?: string | null,
      fileType?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      chunkCount?: number | null,
      providerVersion?: string | null,
      lastError?: string | null,
      createdAt: string,
      updatedAt: string,
      readyAt?: string | null,
      deletedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMConversationQueryVariables = {
  id: string,
};

export type GetLLMConversationQuery = {
  getLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          nextReplenishAt?: string | null,
          usageTierId?: string | null,
          nextUsageTierId?: string | null,
          nextUsageTierAt?: string | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokensRemaining?: number | null,
          premiumTokensRemaining?: number | null,
          superPremiumTokensRemaining?: number | null,
          reasoningTokensRemaining?: number | null,
          standardCallsRemaining?: number | null,
          premiumCallsRemaining?: number | null,
          superPremiumCallsRemaining?: number | null,
          reasoningCallsRemaining?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        modelId?: string | null,
        model?:  {
          __typename: "LLMModel",
          id: string,
          status: string,
          vendor: string,
          host: string,
          supported: boolean,
          name: string,
          description?: string | null,
          modelKey?: string | null,
          modelKeyLatest?: string | null,
          inputTokenPrice?: number | null,
          cachedTokenPrice?: number | null,
          outputTokenPrice?: number | null,
          inputTokenBatchPrice?: number | null,
          outputTokenBatchPrice?: number | null,
          searchCost?: number | null,
          supportsSearch?: boolean | null,
          textInputSupport?: boolean | null,
          imageInputSupport?: boolean | null,
          audioInputSupport?: boolean | null,
          textOutputSupport?: boolean | null,
          imageOutputSupport?: boolean | null,
          audioOutputSupport?: boolean | null,
          thinkingSupport?: boolean | null,
          contextWindowTokens?: number | null,
          maxResponseTokens?: number | null,
          knowledgeCutoffDate?: string | null,
          lastCheckedDate?: string | null,
          supportedLanguages?: string | null,
          warningDate?: string | null,
          warningMessage?: string | null,
          deprecationDate?: string | null,
          deprecationMessage?: string | null,
          defaultServiceGroup?: string | null,
          defaultEnabled?: boolean | null,
          displayOrder?: number | null,
          recommendedUseCase?: string | null,
          performanceRating?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        customer_user_id?: string | null,
        customer_user_name?: string | null,
        customer_user_email?: string | null,
        batch?: boolean | null,
        callbackUrl?: string | null,
        batchId?: string | null,
        batchCustomId?: string | null,
        batchRequest?: string | null,
        executionMode?: string | null,
        pricingMode?: string | null,
        vendorBatchId?: string | null,
        vendorResponseId?: string | null,
        vendorStatus?: string | null,
        resolvedModelId?: string | null,
        usageTapCallId?: string | null,
        usageTapStripeCustomerId?: string | null,
        error?: string | null,
        cacheReadTokens?: number | null,
        cacheWriteTokens?: number | null,
        cacheStatus?: string | null,
        compactionTriggered?: boolean | null,
        compactionTokensSaved?: number | null,
        curatedTokensSaved?: number | null,
        curatedItems?: number | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    endedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLLMConversationsQueryVariables = {
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMConversationsQuery = {
  listLLMConversations?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      endedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ConversationsByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ConversationsByProjectIdAndCreatedAtQuery = {
  conversationsByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      endedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ConversationsByCustomerIdAndCreatedAtQueryVariables = {
  customerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ConversationsByCustomerIdAndCreatedAtQuery = {
  conversationsByCustomerIdAndCreatedAt?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      endedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ConversationsByStatusAndCreatedAtQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ConversationsByStatusAndCreatedAtQuery = {
  conversationsByStatusAndCreatedAt?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      endedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMModelQueryVariables = {
  id: string,
};

export type GetLLMModelQuery = {
  getLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host: string,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    supportsSearch?: boolean | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    defaultServiceGroup?: string | null,
    defaultEnabled?: boolean | null,
    displayOrder?: number | null,
    recommendedUseCase?: string | null,
    performanceRating?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMModelsQueryVariables = {
  filter?: ModelLLMModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMModelsQuery = {
  listLLMModels?:  {
    __typename: "ModelLLMModelConnection",
    items:  Array< {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LLMModelsByHostAndModelKeyQueryVariables = {
  host: string,
  modelKey?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LLMModelsByHostAndModelKeyQuery = {
  lLMModelsByHostAndModelKey?:  {
    __typename: "ModelLLMModelConnection",
    items:  Array< {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LLMModelsByHostAndModelKeyLatestQueryVariables = {
  host: string,
  modelKeyLatest?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LLMModelsByHostAndModelKeyLatestQuery = {
  lLMModelsByHostAndModelKeyLatest?:  {
    __typename: "ModelLLMModelConnection",
    items:  Array< {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host: string,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      supportsSearch?: boolean | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      defaultServiceGroup?: string | null,
      defaultEnabled?: boolean | null,
      displayOrder?: number | null,
      recommendedUseCase?: string | null,
      performanceRating?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMProviderQueryVariables = {
  id: string,
};

export type GetLLMProviderQuery = {
  getLLMProvider?:  {
    __typename: "LLMProvider",
    id: string,
    displayName: string,
    contactUrl?: string | null,
    description?: string | null,
    defaultIsModerated?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListLLMProvidersQueryVariables = {
  filter?: ModelLLMProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMProvidersQuery = {
  listLLMProviders?:  {
    __typename: "ModelLLMProviderConnection",
    items:  Array< {
      __typename: "LLMProvider",
      id: string,
      displayName: string,
      contactUrl?: string | null,
      description?: string | null,
      defaultIsModerated?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProvidersByDisplayNameQueryVariables = {
  displayName: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProvidersByDisplayNameQuery = {
  providersByDisplayName?:  {
    __typename: "ModelLLMProviderConnection",
    items:  Array< {
      __typename: "LLMProvider",
      id: string,
      displayName: string,
      contactUrl?: string | null,
      description?: string | null,
      defaultIsModerated?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMOpenRouterModelQueryVariables = {
  id: string,
};

export type GetLLMOpenRouterModelQuery = {
  getLLMOpenRouterModel?:  {
    __typename: "LLMOpenRouterModel",
    id: string,
    providerId: string,
    provider?:  {
      __typename: "LLMProvider",
      id: string,
      displayName: string,
      contactUrl?: string | null,
      description?: string | null,
      defaultIsModerated?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    canonicalSlug?: string | null,
    name: string,
    description?: string | null,
    tokenizer?: string | null,
    instructType?: string | null,
    contextLength?: number | null,
    maxCompletionTokens?: number | null,
    isModerated?: boolean | null,
    architectureModality?: string | null,
    architectureInputModalities?: string | null,
    architectureOutputModalities?: string | null,
    supportedParameters?: string | null,
    defaultParameters?: string | null,
    huggingFaceId?: string | null,
    latestPricingSnapshotId?: string | null,
    isDeprecated?: boolean | null,
    deprecatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListLLMOpenRouterModelsQueryVariables = {
  filter?: ModelLLMOpenRouterModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMOpenRouterModelsQuery = {
  listLLMOpenRouterModels?:  {
    __typename: "ModelLLMOpenRouterModelConnection",
    items:  Array< {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenRouterModelsByProviderIdAndNameQueryVariables = {
  providerId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenRouterModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenRouterModelsByProviderIdAndNameQuery = {
  openRouterModelsByProviderIdAndName?:  {
    __typename: "ModelLLMOpenRouterModelConnection",
    items:  Array< {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OpenRouterModelsByCanonicalSlugQueryVariables = {
  canonicalSlug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMOpenRouterModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OpenRouterModelsByCanonicalSlugQuery = {
  openRouterModelsByCanonicalSlug?:  {
    __typename: "ModelLLMOpenRouterModelConnection",
    items:  Array< {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMModelPricingSnapshotQueryVariables = {
  id: string,
};

export type GetLLMModelPricingSnapshotQuery = {
  getLLMModelPricingSnapshot?:  {
    __typename: "LLMModelPricingSnapshot",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    source: LLMModelPricingSource,
    fetchedAt: string,
    currency: string,
    promptTokenUsdNano?: string | null,
    completionTokenUsdNano?: string | null,
    cacheReadTokenUsdNano?: string | null,
    cacheWriteTokenUsdNano?: string | null,
    reasoningTokenUsdNano?: string | null,
    webSearchUsdNano?: string | null,
    requestUsdNano?: string | null,
    imageUsdNano?: string | null,
    audioUsdNano?: string | null,
    internalNotes?: string | null,
    isCurrent?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListLLMModelPricingSnapshotsQueryVariables = {
  filter?: ModelLLMModelPricingSnapshotFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMModelPricingSnapshotsQuery = {
  listLLMModelPricingSnapshots?:  {
    __typename: "ModelLLMModelPricingSnapshotConnection",
    items:  Array< {
      __typename: "LLMModelPricingSnapshot",
      id: string,
      modelId: string,
      model?:  {
        __typename: "LLMOpenRouterModel",
        id: string,
        providerId: string,
        provider?:  {
          __typename: "LLMProvider",
          id: string,
          displayName: string,
          contactUrl?: string | null,
          description?: string | null,
          defaultIsModerated?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        canonicalSlug?: string | null,
        name: string,
        description?: string | null,
        tokenizer?: string | null,
        instructType?: string | null,
        contextLength?: number | null,
        maxCompletionTokens?: number | null,
        isModerated?: boolean | null,
        architectureModality?: string | null,
        architectureInputModalities?: string | null,
        architectureOutputModalities?: string | null,
        supportedParameters?: string | null,
        defaultParameters?: string | null,
        huggingFaceId?: string | null,
        latestPricingSnapshotId?: string | null,
        isDeprecated?: boolean | null,
        deprecatedAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      source: LLMModelPricingSource,
      fetchedAt: string,
      currency: string,
      promptTokenUsdNano?: string | null,
      completionTokenUsdNano?: string | null,
      cacheReadTokenUsdNano?: string | null,
      cacheWriteTokenUsdNano?: string | null,
      reasoningTokenUsdNano?: string | null,
      webSearchUsdNano?: string | null,
      requestUsdNano?: string | null,
      imageUsdNano?: string | null,
      audioUsdNano?: string | null,
      internalNotes?: string | null,
      isCurrent?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PricingSnapshotsByModelIdAndFetchedAtQueryVariables = {
  modelId: string,
  fetchedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMModelPricingSnapshotFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PricingSnapshotsByModelIdAndFetchedAtQuery = {
  pricingSnapshotsByModelIdAndFetchedAt?:  {
    __typename: "ModelLLMModelPricingSnapshotConnection",
    items:  Array< {
      __typename: "LLMModelPricingSnapshot",
      id: string,
      modelId: string,
      model?:  {
        __typename: "LLMOpenRouterModel",
        id: string,
        providerId: string,
        provider?:  {
          __typename: "LLMProvider",
          id: string,
          displayName: string,
          contactUrl?: string | null,
          description?: string | null,
          defaultIsModerated?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        canonicalSlug?: string | null,
        name: string,
        description?: string | null,
        tokenizer?: string | null,
        instructType?: string | null,
        contextLength?: number | null,
        maxCompletionTokens?: number | null,
        isModerated?: boolean | null,
        architectureModality?: string | null,
        architectureInputModalities?: string | null,
        architectureOutputModalities?: string | null,
        supportedParameters?: string | null,
        defaultParameters?: string | null,
        huggingFaceId?: string | null,
        latestPricingSnapshotId?: string | null,
        isDeprecated?: boolean | null,
        deprecatedAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      source: LLMModelPricingSource,
      fetchedAt: string,
      currency: string,
      promptTokenUsdNano?: string | null,
      completionTokenUsdNano?: string | null,
      cacheReadTokenUsdNano?: string | null,
      cacheWriteTokenUsdNano?: string | null,
      reasoningTokenUsdNano?: string | null,
      webSearchUsdNano?: string | null,
      requestUsdNano?: string | null,
      imageUsdNano?: string | null,
      audioUsdNano?: string | null,
      internalNotes?: string | null,
      isCurrent?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMModelCapabilityQueryVariables = {
  id: string,
};

export type GetLLMModelCapabilityQuery = {
  getLLMModelCapability?:  {
    __typename: "LLMModelCapability",
    id: string,
    modelId: string,
    model?:  {
      __typename: "LLMOpenRouterModel",
      id: string,
      providerId: string,
      provider?:  {
        __typename: "LLMProvider",
        id: string,
        displayName: string,
        contactUrl?: string | null,
        description?: string | null,
        defaultIsModerated?: boolean | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      canonicalSlug?: string | null,
      name: string,
      description?: string | null,
      tokenizer?: string | null,
      instructType?: string | null,
      contextLength?: number | null,
      maxCompletionTokens?: number | null,
      isModerated?: boolean | null,
      architectureModality?: string | null,
      architectureInputModalities?: string | null,
      architectureOutputModalities?: string | null,
      supportedParameters?: string | null,
      defaultParameters?: string | null,
      huggingFaceId?: string | null,
      latestPricingSnapshotId?: string | null,
      isDeprecated?: boolean | null,
      deprecatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    category: string,
    value: string,
    metadata?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListLLMModelCapabilitiesQueryVariables = {
  filter?: ModelLLMModelCapabilityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMModelCapabilitiesQuery = {
  listLLMModelCapabilities?:  {
    __typename: "ModelLLMModelCapabilityConnection",
    items:  Array< {
      __typename: "LLMModelCapability",
      id: string,
      modelId: string,
      model?:  {
        __typename: "LLMOpenRouterModel",
        id: string,
        providerId: string,
        provider?:  {
          __typename: "LLMProvider",
          id: string,
          displayName: string,
          contactUrl?: string | null,
          description?: string | null,
          defaultIsModerated?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        canonicalSlug?: string | null,
        name: string,
        description?: string | null,
        tokenizer?: string | null,
        instructType?: string | null,
        contextLength?: number | null,
        maxCompletionTokens?: number | null,
        isModerated?: boolean | null,
        architectureModality?: string | null,
        architectureInputModalities?: string | null,
        architectureOutputModalities?: string | null,
        supportedParameters?: string | null,
        defaultParameters?: string | null,
        huggingFaceId?: string | null,
        latestPricingSnapshotId?: string | null,
        isDeprecated?: boolean | null,
        deprecatedAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      category: string,
      value: string,
      metadata?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CapabilitiesByModelIdQueryVariables = {
  modelId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMModelCapabilityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CapabilitiesByModelIdQuery = {
  capabilitiesByModelId?:  {
    __typename: "ModelLLMModelCapabilityConnection",
    items:  Array< {
      __typename: "LLMModelCapability",
      id: string,
      modelId: string,
      model?:  {
        __typename: "LLMOpenRouterModel",
        id: string,
        providerId: string,
        provider?:  {
          __typename: "LLMProvider",
          id: string,
          displayName: string,
          contactUrl?: string | null,
          description?: string | null,
          defaultIsModerated?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        canonicalSlug?: string | null,
        name: string,
        description?: string | null,
        tokenizer?: string | null,
        instructType?: string | null,
        contextLength?: number | null,
        maxCompletionTokens?: number | null,
        isModerated?: boolean | null,
        architectureModality?: string | null,
        architectureInputModalities?: string | null,
        architectureOutputModalities?: string | null,
        supportedParameters?: string | null,
        defaultParameters?: string | null,
        huggingFaceId?: string | null,
        latestPricingSnapshotId?: string | null,
        isDeprecated?: boolean | null,
        deprecatedAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      category: string,
      value: string,
      metadata?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CapabilitiesByCategoryAndValueQueryVariables = {
  modelId: string,
  value?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMModelCapabilityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CapabilitiesByCategoryAndValueQuery = {
  capabilitiesByCategoryAndValue?:  {
    __typename: "ModelLLMModelCapabilityConnection",
    items:  Array< {
      __typename: "LLMModelCapability",
      id: string,
      modelId: string,
      model?:  {
        __typename: "LLMOpenRouterModel",
        id: string,
        providerId: string,
        provider?:  {
          __typename: "LLMProvider",
          id: string,
          displayName: string,
          contactUrl?: string | null,
          description?: string | null,
          defaultIsModerated?: boolean | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        canonicalSlug?: string | null,
        name: string,
        description?: string | null,
        tokenizer?: string | null,
        instructType?: string | null,
        contextLength?: number | null,
        maxCompletionTokens?: number | null,
        isModerated?: boolean | null,
        architectureModality?: string | null,
        architectureInputModalities?: string | null,
        architectureOutputModalities?: string | null,
        supportedParameters?: string | null,
        defaultParameters?: string | null,
        huggingFaceId?: string | null,
        latestPricingSnapshotId?: string | null,
        isDeprecated?: boolean | null,
        deprecatedAt?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
      } | null,
      category: string,
      value: string,
      metadata?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMScheduledPromptQueryVariables = {
  id: string,
};

export type GetLLMScheduledPromptQuery = {
  getLLMScheduledPrompt?:  {
    __typename: "LLMScheduledPrompt",
    id: string,
    projectId: string,
    status: LLMScheduledPromptStatus,
    agentId: string,
    agent?:  {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          modelId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          customer_user_id?: string | null,
          customer_user_name?: string | null,
          customer_user_email?: string | null,
          batch?: boolean | null,
          callbackUrl?: string | null,
          batchId?: string | null,
          batchCustomId?: string | null,
          batchRequest?: string | null,
          executionMode?: string | null,
          pricingMode?: string | null,
          vendorBatchId?: string | null,
          vendorResponseId?: string | null,
          vendorStatus?: string | null,
          resolvedModelId?: string | null,
          usageTapCallId?: string | null,
          usageTapStripeCustomerId?: string | null,
          error?: string | null,
          cacheReadTokens?: number | null,
          cacheWriteTokens?: number | null,
          cacheStatus?: string | null,
          compactionTriggered?: boolean | null,
          compactionTokensSaved?: number | null,
          curatedTokensSaved?: number | null,
          curatedItems?: number | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          approvalMode?: LLMMCPApprovalMode | null,
          executionMode?: LLMMCPExecutionMode | null,
          url?: string | null,
          accessToken?: string | null,
          headers?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      ragSkipChecksOnContext?: boolean | null,
      ragShadowRead?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      injectMemories?: number | null,
      injectKnowledgeGraph?: number | null,
      enableWebSearch?: boolean | null,
      linkedFileTypes?: string | null,
      thinkingDepth?: LLMThinkingDepth | null,
      enablePromptCaching?: boolean | null,
      compactionPolicy?: string | null,
      compactionThreshold?: number | null,
      curateToolResults?: boolean | null,
      curateAfterTurns?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    title?: string | null,
    data?: string | null,
    prompt: string,
    scheduledAt: string,
    priorScheduledPromptId?: string | null,
    nextScheduledPromptId?: string | null,
    processedAt?: string | null,
    response?: string | null,
    failedTimes?: number | null,
    errorMessage?: string | null,
    notificationEmailAddresses?: string | null,
    notificationEmailSubject?: string | null,
    repeatIntervalHours?: number | null,
    followOnAgentId?: string | null,
    followOnFollowOnAgentId?: string | null,
    followOnTitle?: string | null,
    followOnPrompt?: string | null,
    followOnScheduledAtHours?: number | null,
    followOnNotificationEmailAddresses?: string | null,
    followOnNotificationEmailSubject?: string | null,
    followOnRepeatIntervalHours?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMScheduledPromptsQueryVariables = {
  filter?: ModelLLMScheduledPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMScheduledPromptsQuery = {
  listLLMScheduledPrompts?:  {
    __typename: "ModelLLMScheduledPromptConnection",
    items:  Array< {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ScheduledPromptsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMScheduledPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledPromptsByProjectIdQuery = {
  scheduledPromptsByProjectId?:  {
    __typename: "ModelLLMScheduledPromptConnection",
    items:  Array< {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ScheduledPromptsByStatusQueryVariables = {
  status: LLMScheduledPromptStatus,
  scheduledAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMScheduledPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledPromptsByStatusQuery = {
  scheduledPromptsByStatus?:  {
    __typename: "ModelLLMScheduledPromptConnection",
    items:  Array< {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ScheduledPromptsByAgentIdQueryVariables = {
  agentId: string,
  scheduledAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMScheduledPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ScheduledPromptsByAgentIdQuery = {
  scheduledPromptsByAgentId?:  {
    __typename: "ModelLLMScheduledPromptConnection",
    items:  Array< {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMTriggerQueryVariables = {
  id: string,
};

export type GetLLMTriggerQuery = {
  getLLMTrigger?:  {
    __typename: "LLMTrigger",
    id: string,
    projectId: string,
    status: LLMTriggerStatus,
    triggerType: string,
    scheduledPromptId?: string | null,
    scheduledPrompt?:  {
      __typename: "LLMScheduledPrompt",
      id: string,
      projectId: string,
      status: LLMScheduledPromptStatus,
      agentId: string,
      agent?:  {
        __typename: "LLMAgent",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        displayTheme?: string | null,
        cssUrl?: string | null,
        displayTitle?: string | null,
        displayStartMessageOrPrompt?: string | null,
        displayInitialMessageOrPrompt?: string | null,
        displayPromptTemplate?: string | null,
        displayFollowOnPrompts?: string | null,
        displayActions?: string | null,
        displayWidth?: string | null,
        displayHeight?: string | null,
        displayPlaceholder?: string | null,
        displayHideInitialPrompt?: boolean | null,
        displayShowSaveButton?: boolean | null,
        displayShowEmailButton?: boolean | null,
        displayShowCallToAction?: boolean | null,
        displayCallToActionButtonText?: string | null,
        displayCallToActionEmailAddress?: string | null,
        displayCallToActionEmailSubject?: string | null,
        displayCallToActionMustSendEmail?: boolean | null,
        displayScrollToEnd?: boolean | null,
        groupId?: string | null,
        data?: string | null,
        calls?:  {
          __typename: "ModelLLMCallConnection",
          nextToken?: string | null,
        } | null,
        documents?:  {
          __typename: "ModelLLMAgentDocumentConnection",
          nextToken?: string | null,
        } | null,
        mcpServers?:  {
          __typename: "ModelLLMAgentMCPConnection",
          nextToken?: string | null,
        } | null,
        ragQueryLimit?: number | null,
        ragRankLimit?: number | null,
        ragIncludeCitations?: boolean | null,
        ragDoRerank?: boolean | null,
        ragSkipChecksOnContext?: boolean | null,
        ragShadowRead?: boolean | null,
        visibility?: LLMVisibility | null,
        createConversationOnFirstChat?: boolean | null,
        customerEmailCaptureMode?: LLMEmailCaptureMode | null,
        customerEmailCapturePlaceholder?: string | null,
        enableRAG?: boolean | null,
        enableMCP?: boolean | null,
        injectMemories?: number | null,
        injectKnowledgeGraph?: number | null,
        enableWebSearch?: boolean | null,
        linkedFileTypes?: string | null,
        thinkingDepth?: LLMThinkingDepth | null,
        enablePromptCaching?: boolean | null,
        compactionPolicy?: string | null,
        compactionThreshold?: number | null,
        curateToolResults?: boolean | null,
        curateAfterTurns?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      title?: string | null,
      data?: string | null,
      prompt: string,
      scheduledAt: string,
      priorScheduledPromptId?: string | null,
      nextScheduledPromptId?: string | null,
      processedAt?: string | null,
      response?: string | null,
      failedTimes?: number | null,
      errorMessage?: string | null,
      notificationEmailAddresses?: string | null,
      notificationEmailSubject?: string | null,
      repeatIntervalHours?: number | null,
      followOnAgentId?: string | null,
      followOnFollowOnAgentId?: string | null,
      followOnTitle?: string | null,
      followOnPrompt?: string | null,
      followOnScheduledAtHours?: number | null,
      followOnNotificationEmailAddresses?: string | null,
      followOnNotificationEmailSubject?: string | null,
      followOnRepeatIntervalHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMTriggersQueryVariables = {
  filter?: ModelLLMTriggerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMTriggersQuery = {
  listLLMTriggers?:  {
    __typename: "ModelLLMTriggerConnection",
    items:  Array< {
      __typename: "LLMTrigger",
      id: string,
      projectId: string,
      status: LLMTriggerStatus,
      triggerType: string,
      scheduledPromptId?: string | null,
      scheduledPrompt?:  {
        __typename: "LLMScheduledPrompt",
        id: string,
        projectId: string,
        status: LLMScheduledPromptStatus,
        agentId: string,
        agent?:  {
          __typename: "LLMAgent",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          displayTheme?: string | null,
          cssUrl?: string | null,
          displayTitle?: string | null,
          displayStartMessageOrPrompt?: string | null,
          displayInitialMessageOrPrompt?: string | null,
          displayPromptTemplate?: string | null,
          displayFollowOnPrompts?: string | null,
          displayActions?: string | null,
          displayWidth?: string | null,
          displayHeight?: string | null,
          displayPlaceholder?: string | null,
          displayHideInitialPrompt?: boolean | null,
          displayShowSaveButton?: boolean | null,
          displayShowEmailButton?: boolean | null,
          displayShowCallToAction?: boolean | null,
          displayCallToActionButtonText?: string | null,
          displayCallToActionEmailAddress?: string | null,
          displayCallToActionEmailSubject?: string | null,
          displayCallToActionMustSendEmail?: boolean | null,
          displayScrollToEnd?: boolean | null,
          groupId?: string | null,
          data?: string | null,
          ragQueryLimit?: number | null,
          ragRankLimit?: number | null,
          ragIncludeCitations?: boolean | null,
          ragDoRerank?: boolean | null,
          ragSkipChecksOnContext?: boolean | null,
          ragShadowRead?: boolean | null,
          visibility?: LLMVisibility | null,
          createConversationOnFirstChat?: boolean | null,
          customerEmailCaptureMode?: LLMEmailCaptureMode | null,
          customerEmailCapturePlaceholder?: string | null,
          enableRAG?: boolean | null,
          enableMCP?: boolean | null,
          injectMemories?: number | null,
          injectKnowledgeGraph?: number | null,
          enableWebSearch?: boolean | null,
          linkedFileTypes?: string | null,
          thinkingDepth?: LLMThinkingDepth | null,
          enablePromptCaching?: boolean | null,
          compactionPolicy?: string | null,
          compactionThreshold?: number | null,
          curateToolResults?: boolean | null,
          curateAfterTurns?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        title?: string | null,
        data?: string | null,
        prompt: string,
        scheduledAt: string,
        priorScheduledPromptId?: string | null,
        nextScheduledPromptId?: string | null,
        processedAt?: string | null,
        response?: string | null,
        failedTimes?: number | null,
        errorMessage?: string | null,
        notificationEmailAddresses?: string | null,
        notificationEmailSubject?: string | null,
        repeatIntervalHours?: number | null,
        followOnAgentId?: string | null,
        followOnFollowOnAgentId?: string | null,
        followOnTitle?: string | null,
        followOnPrompt?: string | null,
        followOnScheduledAtHours?: number | null,
        followOnNotificationEmailAddresses?: string | null,
        followOnNotificationEmailSubject?: string | null,
        followOnRepeatIntervalHours?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TriggersByProjectIdAndTriggerTypeQueryVariables = {
  projectId: string,
  triggerType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMTriggerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TriggersByProjectIdAndTriggerTypeQuery = {
  triggersByProjectIdAndTriggerType?:  {
    __typename: "ModelLLMTriggerConnection",
    items:  Array< {
      __typename: "LLMTrigger",
      id: string,
      projectId: string,
      status: LLMTriggerStatus,
      triggerType: string,
      scheduledPromptId?: string | null,
      scheduledPrompt?:  {
        __typename: "LLMScheduledPrompt",
        id: string,
        projectId: string,
        status: LLMScheduledPromptStatus,
        agentId: string,
        agent?:  {
          __typename: "LLMAgent",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          displayTheme?: string | null,
          cssUrl?: string | null,
          displayTitle?: string | null,
          displayStartMessageOrPrompt?: string | null,
          displayInitialMessageOrPrompt?: string | null,
          displayPromptTemplate?: string | null,
          displayFollowOnPrompts?: string | null,
          displayActions?: string | null,
          displayWidth?: string | null,
          displayHeight?: string | null,
          displayPlaceholder?: string | null,
          displayHideInitialPrompt?: boolean | null,
          displayShowSaveButton?: boolean | null,
          displayShowEmailButton?: boolean | null,
          displayShowCallToAction?: boolean | null,
          displayCallToActionButtonText?: string | null,
          displayCallToActionEmailAddress?: string | null,
          displayCallToActionEmailSubject?: string | null,
          displayCallToActionMustSendEmail?: boolean | null,
          displayScrollToEnd?: boolean | null,
          groupId?: string | null,
          data?: string | null,
          ragQueryLimit?: number | null,
          ragRankLimit?: number | null,
          ragIncludeCitations?: boolean | null,
          ragDoRerank?: boolean | null,
          ragSkipChecksOnContext?: boolean | null,
          ragShadowRead?: boolean | null,
          visibility?: LLMVisibility | null,
          createConversationOnFirstChat?: boolean | null,
          customerEmailCaptureMode?: LLMEmailCaptureMode | null,
          customerEmailCapturePlaceholder?: string | null,
          enableRAG?: boolean | null,
          enableMCP?: boolean | null,
          injectMemories?: number | null,
          injectKnowledgeGraph?: number | null,
          enableWebSearch?: boolean | null,
          linkedFileTypes?: string | null,
          thinkingDepth?: LLMThinkingDepth | null,
          enablePromptCaching?: boolean | null,
          compactionPolicy?: string | null,
          compactionThreshold?: number | null,
          curateToolResults?: boolean | null,
          curateAfterTurns?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        title?: string | null,
        data?: string | null,
        prompt: string,
        scheduledAt: string,
        priorScheduledPromptId?: string | null,
        nextScheduledPromptId?: string | null,
        processedAt?: string | null,
        response?: string | null,
        failedTimes?: number | null,
        errorMessage?: string | null,
        notificationEmailAddresses?: string | null,
        notificationEmailSubject?: string | null,
        repeatIntervalHours?: number | null,
        followOnAgentId?: string | null,
        followOnFollowOnAgentId?: string | null,
        followOnTitle?: string | null,
        followOnPrompt?: string | null,
        followOnScheduledAtHours?: number | null,
        followOnNotificationEmailAddresses?: string | null,
        followOnNotificationEmailSubject?: string | null,
        followOnRepeatIntervalHours?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TriggersByStatusQueryVariables = {
  status: LLMTriggerStatus,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMTriggerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TriggersByStatusQuery = {
  triggersByStatus?:  {
    __typename: "ModelLLMTriggerConnection",
    items:  Array< {
      __typename: "LLMTrigger",
      id: string,
      projectId: string,
      status: LLMTriggerStatus,
      triggerType: string,
      scheduledPromptId?: string | null,
      scheduledPrompt?:  {
        __typename: "LLMScheduledPrompt",
        id: string,
        projectId: string,
        status: LLMScheduledPromptStatus,
        agentId: string,
        agent?:  {
          __typename: "LLMAgent",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          displayTheme?: string | null,
          cssUrl?: string | null,
          displayTitle?: string | null,
          displayStartMessageOrPrompt?: string | null,
          displayInitialMessageOrPrompt?: string | null,
          displayPromptTemplate?: string | null,
          displayFollowOnPrompts?: string | null,
          displayActions?: string | null,
          displayWidth?: string | null,
          displayHeight?: string | null,
          displayPlaceholder?: string | null,
          displayHideInitialPrompt?: boolean | null,
          displayShowSaveButton?: boolean | null,
          displayShowEmailButton?: boolean | null,
          displayShowCallToAction?: boolean | null,
          displayCallToActionButtonText?: string | null,
          displayCallToActionEmailAddress?: string | null,
          displayCallToActionEmailSubject?: string | null,
          displayCallToActionMustSendEmail?: boolean | null,
          displayScrollToEnd?: boolean | null,
          groupId?: string | null,
          data?: string | null,
          ragQueryLimit?: number | null,
          ragRankLimit?: number | null,
          ragIncludeCitations?: boolean | null,
          ragDoRerank?: boolean | null,
          ragSkipChecksOnContext?: boolean | null,
          ragShadowRead?: boolean | null,
          visibility?: LLMVisibility | null,
          createConversationOnFirstChat?: boolean | null,
          customerEmailCaptureMode?: LLMEmailCaptureMode | null,
          customerEmailCapturePlaceholder?: string | null,
          enableRAG?: boolean | null,
          enableMCP?: boolean | null,
          injectMemories?: number | null,
          injectKnowledgeGraph?: number | null,
          enableWebSearch?: boolean | null,
          linkedFileTypes?: string | null,
          thinkingDepth?: LLMThinkingDepth | null,
          enablePromptCaching?: boolean | null,
          compactionPolicy?: string | null,
          compactionThreshold?: number | null,
          curateToolResults?: boolean | null,
          curateAfterTurns?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        title?: string | null,
        data?: string | null,
        prompt: string,
        scheduledAt: string,
        priorScheduledPromptId?: string | null,
        nextScheduledPromptId?: string | null,
        processedAt?: string | null,
        response?: string | null,
        failedTimes?: number | null,
        errorMessage?: string | null,
        notificationEmailAddresses?: string | null,
        notificationEmailSubject?: string | null,
        repeatIntervalHours?: number | null,
        followOnAgentId?: string | null,
        followOnFollowOnAgentId?: string | null,
        followOnTitle?: string | null,
        followOnPrompt?: string | null,
        followOnScheduledAtHours?: number | null,
        followOnNotificationEmailAddresses?: string | null,
        followOnNotificationEmailSubject?: string | null,
        followOnRepeatIntervalHours?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMMemoryQueryVariables = {
  id: string,
};

export type GetLLMMemoryQuery = {
  getLLMMemory?:  {
    __typename: "LLMMemory",
    id: string,
    projectId: string,
    status: string,
    entityType: LLMMemoryEntityType,
    customerId?: string | null,
    agentId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    key: string,
    data: string,
    tags?: Array< string | null > | null,
    memoryType: LLMMemoryType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMMemoriesQueryVariables = {
  filter?: ModelLLMMemoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMMemoriesQuery = {
  listLLMMemories?:  {
    __typename: "ModelLLMMemoryConnection",
    items:  Array< {
      __typename: "LLMMemory",
      id: string,
      projectId: string,
      status: string,
      entityType: LLMMemoryEntityType,
      customerId?: string | null,
      agentId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      key: string,
      data: string,
      tags?: Array< string | null > | null,
      memoryType: LLMMemoryType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MemoryByProjectIdAndKeyQueryVariables = {
  projectId: string,
  key?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMMemoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MemoryByProjectIdAndKeyQuery = {
  memoryByProjectIdAndKey?:  {
    __typename: "ModelLLMMemoryConnection",
    items:  Array< {
      __typename: "LLMMemory",
      id: string,
      projectId: string,
      status: string,
      entityType: LLMMemoryEntityType,
      customerId?: string | null,
      agentId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      key: string,
      data: string,
      tags?: Array< string | null > | null,
      memoryType: LLMMemoryType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MemoryByStatusQueryVariables = {
  status: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMMemoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MemoryByStatusQuery = {
  memoryByStatus?:  {
    __typename: "ModelLLMMemoryConnection",
    items:  Array< {
      __typename: "LLMMemory",
      id: string,
      projectId: string,
      status: string,
      entityType: LLMMemoryEntityType,
      customerId?: string | null,
      agentId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      key: string,
      data: string,
      tags?: Array< string | null > | null,
      memoryType: LLMMemoryType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MemoryByCustomerIdAndKeyQueryVariables = {
  customerId: string,
  key?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMMemoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MemoryByCustomerIdAndKeyQuery = {
  memoryByCustomerIdAndKey?:  {
    __typename: "ModelLLMMemoryConnection",
    items:  Array< {
      __typename: "LLMMemory",
      id: string,
      projectId: string,
      status: string,
      entityType: LLMMemoryEntityType,
      customerId?: string | null,
      agentId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      key: string,
      data: string,
      tags?: Array< string | null > | null,
      memoryType: LLMMemoryType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MemoryByAgentIdAndKeyQueryVariables = {
  agentId: string,
  key?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMMemoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MemoryByAgentIdAndKeyQuery = {
  memoryByAgentIdAndKey?:  {
    __typename: "ModelLLMMemoryConnection",
    items:  Array< {
      __typename: "LLMMemory",
      id: string,
      projectId: string,
      status: string,
      entityType: LLMMemoryEntityType,
      customerId?: string | null,
      agentId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      key: string,
      data: string,
      tags?: Array< string | null > | null,
      memoryType: LLMMemoryType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMKnowledgeGraphQueryVariables = {
  id: string,
};

export type GetLLMKnowledgeGraphQuery = {
  getLLMKnowledgeGraph?:  {
    __typename: "LLMKnowledgeGraph",
    id: string,
    projectId: string,
    customerId: string,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      nextReplenishAt?: string | null,
      usageTierId?: string | null,
      usageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierId?: string | null,
      nextUsageTier?:  {
        __typename: "LLMUsageTier",
        id: string,
        projectId: string,
        status: LLMUsageTierStatus,
        name: string,
        description?: string | null,
        version: number,
        activeAt?: string | null,
        inactiveAt?: string | null,
        priorUsageTierId?: string | null,
        priorUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        baseUsageTierId?: string | null,
        baseUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        replenishmentPeriod?: LLMPeriod | null,
        replenishmentMethod?: LLMReplenishmentMethod | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokenReplenishmentAmount?: number | null,
        premiumTokenReplenishmentAmount?: number | null,
        superPremiumTokenReplenishmentAmount?: number | null,
        reasoningTokenReplenishmentAmount?: number | null,
        standardCallReplenishmentAmount?: number | null,
        premiumCallReplenishmentAmount?: number | null,
        superPremiumCallReplenishmentAmount?: number | null,
        reasoningCallReplenishmentAmount?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      nextUsageTierAt?: string | null,
      usageLimitAction?: LLMUsageLimitAction | null,
      standardTokensRemaining?: number | null,
      premiumTokensRemaining?: number | null,
      superPremiumTokensRemaining?: number | null,
      reasoningTokensRemaining?: number | null,
      standardCallsRemaining?: number | null,
      premiumCallsRemaining?: number | null,
      superPremiumCallsRemaining?: number | null,
      reasoningCallsRemaining?: number | null,
      standardTokenUnlimited?: boolean | null,
      premiumTokenUnlimited?: boolean | null,
      superPremiumTokenUnlimited?: boolean | null,
      reasoningTokenUnlimited?: boolean | null,
      standardCallUnlimited?: boolean | null,
      premiumCallUnlimited?: boolean | null,
      superPremiumCallUnlimited?: boolean | null,
      reasoningCallUnlimited?: boolean | null,
      updatedAt: string,
    } | null,
    status: LLMKnowledgeGraphStatus,
    version: number,
    title?: string | null,
    description?: string | null,
    graphData: string,
    memoryCount?: number | null,
    generatedFromMemoryIds?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMKnowledgeGraphsQueryVariables = {
  filter?: ModelLLMKnowledgeGraphFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMKnowledgeGraphsQuery = {
  listLLMKnowledgeGraphs?:  {
    __typename: "ModelLLMKnowledgeGraphConnection",
    items:  Array< {
      __typename: "LLMKnowledgeGraph",
      id: string,
      projectId: string,
      customerId: string,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      status: LLMKnowledgeGraphStatus,
      version: number,
      title?: string | null,
      description?: string | null,
      graphData: string,
      memoryCount?: number | null,
      generatedFromMemoryIds?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type KnowledgeGraphsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMKnowledgeGraphFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type KnowledgeGraphsByProjectIdQuery = {
  knowledgeGraphsByProjectId?:  {
    __typename: "ModelLLMKnowledgeGraphConnection",
    items:  Array< {
      __typename: "LLMKnowledgeGraph",
      id: string,
      projectId: string,
      customerId: string,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      status: LLMKnowledgeGraphStatus,
      version: number,
      title?: string | null,
      description?: string | null,
      graphData: string,
      memoryCount?: number | null,
      generatedFromMemoryIds?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type KnowledgeGraphsByCustomerIdAndCreatedAtQueryVariables = {
  customerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMKnowledgeGraphFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type KnowledgeGraphsByCustomerIdAndCreatedAtQuery = {
  knowledgeGraphsByCustomerIdAndCreatedAt?:  {
    __typename: "ModelLLMKnowledgeGraphConnection",
    items:  Array< {
      __typename: "LLMKnowledgeGraph",
      id: string,
      projectId: string,
      customerId: string,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        nextReplenishAt?: string | null,
        usageTierId?: string | null,
        usageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierId?: string | null,
        nextUsageTier?:  {
          __typename: "LLMUsageTier",
          id: string,
          projectId: string,
          status: LLMUsageTierStatus,
          name: string,
          description?: string | null,
          version: number,
          activeAt?: string | null,
          inactiveAt?: string | null,
          priorUsageTierId?: string | null,
          baseUsageTierId?: string | null,
          replenishmentPeriod?: LLMPeriod | null,
          replenishmentMethod?: LLMReplenishmentMethod | null,
          usageLimitAction?: LLMUsageLimitAction | null,
          standardTokenReplenishmentAmount?: number | null,
          premiumTokenReplenishmentAmount?: number | null,
          superPremiumTokenReplenishmentAmount?: number | null,
          reasoningTokenReplenishmentAmount?: number | null,
          standardCallReplenishmentAmount?: number | null,
          premiumCallReplenishmentAmount?: number | null,
          superPremiumCallReplenishmentAmount?: number | null,
          reasoningCallReplenishmentAmount?: number | null,
          standardTokenUnlimited?: boolean | null,
          premiumTokenUnlimited?: boolean | null,
          superPremiumTokenUnlimited?: boolean | null,
          reasoningTokenUnlimited?: boolean | null,
          standardCallUnlimited?: boolean | null,
          premiumCallUnlimited?: boolean | null,
          superPremiumCallUnlimited?: boolean | null,
          reasoningCallUnlimited?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        nextUsageTierAt?: string | null,
        usageLimitAction?: LLMUsageLimitAction | null,
        standardTokensRemaining?: number | null,
        premiumTokensRemaining?: number | null,
        superPremiumTokensRemaining?: number | null,
        reasoningTokensRemaining?: number | null,
        standardCallsRemaining?: number | null,
        premiumCallsRemaining?: number | null,
        superPremiumCallsRemaining?: number | null,
        reasoningCallsRemaining?: number | null,
        standardTokenUnlimited?: boolean | null,
        premiumTokenUnlimited?: boolean | null,
        superPremiumTokenUnlimited?: boolean | null,
        reasoningTokenUnlimited?: boolean | null,
        standardCallUnlimited?: boolean | null,
        premiumCallUnlimited?: boolean | null,
        superPremiumCallUnlimited?: boolean | null,
        reasoningCallUnlimited?: boolean | null,
        updatedAt: string,
      } | null,
      status: LLMKnowledgeGraphStatus,
      version: number,
      title?: string | null,
      description?: string | null,
      graphData: string,
      memoryCount?: number | null,
      generatedFromMemoryIds?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentValidationQueryVariables = {
  id: string,
};

export type GetLLMAgentValidationQuery = {
  getLLMAgentValidation?:  {
    __typename: "LLMAgentValidation",
    id: string,
    projectId: string,
    agentId: string,
    name?: string | null,
    description?: string | null,
    operator: ValidationOperator,
    expectedValue?: string | null,
    customPromptTemplate?: string | null,
    status: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentValidationsQueryVariables = {
  filter?: ModelLLMAgentValidationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentValidationsQuery = {
  listLLMAgentValidations?:  {
    __typename: "ModelLLMAgentValidationConnection",
    items:  Array< {
      __typename: "LLMAgentValidation",
      id: string,
      projectId: string,
      agentId: string,
      name?: string | null,
      description?: string | null,
      operator: ValidationOperator,
      expectedValue?: string | null,
      customPromptTemplate?: string | null,
      status: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ValidationsByAgentIdQueryVariables = {
  agentId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentValidationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ValidationsByAgentIdQuery = {
  validationsByAgentId?:  {
    __typename: "ModelLLMAgentValidationConnection",
    items:  Array< {
      __typename: "LLMAgentValidation",
      id: string,
      projectId: string,
      agentId: string,
      name?: string | null,
      description?: string | null,
      operator: ValidationOperator,
      expectedValue?: string | null,
      customPromptTemplate?: string | null,
      status: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};
